// Page-specific strings, namespaced as 'pages.<pageName>.<key>'.
export default {
  'pages.app.analysisType.cpChecklist.title': '先决条件清单',
  'pages.app.analysisType.cpChecklist.description': '根据所选文档生成先决条件清单。',
  'pages.app.analysisType.companyOverview.title': '公司概况',
  'pages.app.analysisType.companyOverview.description': '根据所选文档编写公司概况。',
  'pages.chat.promptLibrary.purposeRequired': '请输入此提示词的用途。',
  'pages.chat.promptLibrary.metadataUnavailable':
    '部分提示词选项暂不可用。保存前至少需要选择一个业务领域。',
  'pages.chat.promptLibrary.retryOptions': '重试',
  'pages.chat.promptLibrary.tags': '标签',
  'pages.chat.promptLibrary.tagsRequired': '请至少添加一个标签。',
  'pages.chat.promptLibrary.tagsPlaceholder': '选择或创建标签',
  'pages.chat.promptLibrary.practiceAreas': '业务领域',
  'pages.chat.promptLibrary.practiceAreasRequired': '请至少选择一个业务领域。',
  'pages.chat.promptLibrary.practiceAreasPlaceholder': '选择业务领域',
  'pages.chat.promptLibrary.exampleTemplate':
    '任务：[描述此提示词应执行的任务。]\n\n输入：[指定需要提供的文档或信息。]\n\n要求：[描述结构、语气、限制和详细程度。]\n\n请将以下内容用作所需输出的示例。请根据新的输入进行调整，而非重复示例中的事实：\n\n',
  'pages.chat.promptLibrary.discardTitle': '放弃此提示词草稿？',
  'pages.chat.promptLibrary.discardDescription': '您的修改尚未保存到提示词库。',
  'pages.chat.promptLibrary.discard': '放弃',
  'pages.chat.promptLibrary.keepEditing': '继续编辑',
  'pages.chat.promptLibrary.saved': '提示词已保存到您的个人提示词库。',
  'pages.chat.promptLibrary.viewLibrary': '查看提示词库',
  'pages.chat.promptLibrary.saveFailed': '无法保存提示词。您的草稿仍然保留，请重试。',
  'pages.chat.promptLibrary.create': '创建可重复使用的提示词',
  'pages.chat.promptLibrary.cancel': '取消',
  'pages.chat.promptLibrary.save': '保存到我的提示词库',
  'pages.chat.promptLibrary.reviewTitle': '使其适用于新对话',
  'pages.chat.promptLibrary.reviewDescription':
    '保留可重复使用的指令，或将有用的回答作为示例。将名称和事项特有的事实替换为[协议]等占位符。请明确“上述”等表述所指的内容。聊天记录和附件不会包含在内。',
  'pages.chat.promptLibrary.original': '原始聊天文本',
  'pages.chat.promptLibrary.keepWording': '保留所选措辞',
  'pages.chat.promptLibrary.useExample': '用作输出示例',
  'pages.chat.promptLibrary.exampleHelp': '请填写下方的任务、输入和要求，说明如何生成类似结果。',
  'pages.chat.promptLibrary.name': '名称',
  'pages.chat.promptLibrary.nameRequired': '请输入此提示词的名称。',
  'pages.chat.promptLibrary.purpose': '用途',
  'pages.chat.promptLibrary.content': '提示词',
  'pages.chat.promptLibrary.contentRequired': '请输入要保存的指令。',
  'pages.adminManagement.groupName': '组名',
  'pages.adminManagement.personalTag': '个人',
  'pages.adminManagement.owner': '所有者',
  'pages.adminManagement.deletedUserTag': '已删除用户',
  'pages.adminManagement.members': '成员',
  'pages.adminManagement.options': '操作',
  'pages.adminManagement.manageGroupTooltip': '管理群组',
  'pages.adminManagement.manageFilesTooltip': '管理文件',
  'pages.adminManagement.removeGroupTooltip': '删除群组',
  'pages.adminManagement.stats.totalUsers': '用户总数',
  'pages.adminManagement.stats.totalGroups': '群组总数',
  'pages.adminManagement.stats.personalGroups': '个人群组',
  'pages.adminManagement.stats.sharedGroups': '共享群组',
  'pages.adminManagement.stats.totalFiles': '文件总数',
  'pages.adminManagement.stats.totalFolders': '文件夹总数',
  'pages.adminManagement.sharedTag': '共享',
  'pages.adminManagement.moveAll': '全部移动',
  'pages.adminManagement.fileDescription': '{username} · {date} {action}',
  'pages.adminManagement.fileAction.uploaded': '已上传',
  'pages.adminManagement.fileAction.created': '已创建',
  'pages.adminManagement.createGroupButton': '创建群组',
  'pages.adminManagement.modifyUserGroupTitle': '修改用户组',
  'pages.adminManagement.createUserGroupTitle': '创建用户组',
  'pages.adminManagement.updateSubmitText': '更新',
  'pages.adminManagement.userGroupUpdatedSuccess': '用户组更新成功',
  'pages.adminManagement.userGroupCreatedSuccess': '用户组创建成功',
  'pages.adminManagement.groupNameRequiredMessage': '请输入组名',
  'pages.adminManagement.ownerRequiredMessage': '请选择群组所有者',
  'pages.adminManagement.membersRequiredMessage': '请选择群组成员',
  'pages.adminManagement.moveFolderTitle': '移动文件夹',
  'pages.adminManagement.moveFileTitle': '移动文件',
  'pages.adminManagement.allMovedSuccess': '全部移动成功',
  'pages.adminManagement.folderMovedSuccess': '文件夹移动成功',
  'pages.adminManagement.fileMovedSuccess': '文件移动成功',
  'pages.adminManagement.destinationGroupLabel': '目标群组',
  'pages.adminManagement.destinationGroupRequiredMessage': '请选择目标群组',
  'pages.adminManagement.destinationFolderPlaceholder': '请选择目标文件夹',
  'pages.adminManagement.renameOptionalLabel': '重命名（可选）',
  'pages.adminManagement.loadFolderDataError': '加载文件夹数据失败',
  'pages.adminManagement.ownerCannotBeRemovedWarning': '群组所有者不能从成员中移除',
  'pages.aISetting.promptCopied': '提示词已复制！',
  'pages.aISetting.failedToCopyPrompt': '复制提示词失败',
  'pages.aISetting.updatedByMeta': '由 {user} 于 {date} 更新',
  'pages.aISetting.updateButton': '更新',
  'pages.aISetting.systemPromptLabel': '系统提示词',
  'pages.aISetting.additionalPromptLabel': '附加提示词',
  'pages.aISetting.temperatureLabel': '温度',
  'pages.aISetting.updatedBadge': '已更新！！',
  'pages.aISetting.requiredParamsMissing': '缺少必填参数：{params}',
  'pages.angelInsider.micrositeFrameTitle': 'A&GEL Insider',
  'pages.angelInsider.nav.basics': '基础',
  'pages.angelInsider.nav.learnMore': '了解更多',
  'pages.angelInsider.nav.whatsNew': '新功能',
  'pages.angelInsider.nav.futureStuff': '即将推出',
  'pages.angelInsider.nav.logoAlt': 'A&GEL Insider',
  'pages.angelInsider.landing.tiles.basics.title': '基础',
  'pages.angelInsider.landing.tiles.basics.subtitle': '从这里开始，第一天所需的一切都在这里。',
  'pages.angelInsider.landing.tiles.learnMore.title': '了解更多',
  'pages.angelInsider.landing.tiles.learnMore.subtitle': '面向进阶用户的强大功能。',
  'pages.angelInsider.landing.tiles.whatsNew.title': '新功能',
  'pages.angelInsider.landing.tiles.whatsNew.subtitle': '近期上线的功能与更新。',
  'pages.angelInsider.landing.tiles.comingUp.title': '即将推出',
  'pages.angelInsider.landing.tiles.comingUp.subtitle': '团队正在开发的下一步内容。',
  'pages.angelInsider.landing.pills.all': '全部',
  'pages.angelInsider.landing.pills.chatAndContext': '对话与上下文',
  'pages.angelInsider.landing.pills.filesAndVault': '文件与保险库',
  'pages.angelInsider.landing.pills.promptLibrary': '提示词库',
  'pages.angelInsider.landing.pills.quickInfo': '快速信息',
  'pages.angelInsider.landing.pills.scribe': '笔录',
  'pages.angelInsider.landing.pills.disputeResolution': '争议解决',
  'pages.angelInsider.landing.pills.sideBySide': '并排对比',
  'pages.angelInsider.landing.pills.multiStepPrompt': '多步提示词',
  'pages.angelInsider.landing.pills.timeline': '时间线',
  'pages.angelInsider.landing.pills.workstudio': 'Workstudio',
  'pages.angelInsider.landing.pills.deepResearch': '深度研究',
  'pages.angelInsider.landing.pills.scopeSummary': '范围摘要',
  'pages.angelInsider.landing.pills.review': '审阅',
  'pages.angelInsider.landing.pills.whatsNew': '新功能',
  'pages.angelInsider.landing.pills.futureStuff': '即将推出',
  'pages.angelInsider.landing.preferOneFeature': '更希望逐一了解各项功能？',
  'pages.angelInsider.landing.scrollFeatureList': '滚动功能列表',
  'pages.angelInsider.basics.habits.habit1.num': '习惯 01',
  'pages.angelInsider.basics.habits.habit1.title': '为 A&GEL 提供可用的信息',
  'pages.angelInsider.basics.habits.habit2.num': '习惯 02',
  'pages.angelInsider.basics.habits.habit2.title': '把大语言模型当作“文本处理器”，而非知识引擎',
  'pages.angelInsider.basics.habits.habit3.num': '习惯 03',
  'pages.angelInsider.basics.habits.habit3.title': '不要只用对话功能——探索其他功能',
  'pages.angelInsider.basics.heading': '基础',
  'pages.angelInsider.basics.welcome.timeHeading': '学习新工具需要时间——这很正常',
  'pages.angelInsider.basics.welcome.pacingHeading': '按自己的节奏前进',
  'pages.angelInsider.basics.welcome.togetherHeading': '携手同行，共赴更远',
  'pages.angelInsider.basics.welcome.signatureName': 'Kok Leong',
  'pages.angelInsider.basics.welcome.signatureTeam': 'A&GEL 开发团队',
  'pages.angelInsider.basics.welcome.ctaLetsBegin': '开始使用 →',
  'pages.angelInsider.basics.habitsSection.title': '只需 3 个习惯，助您一路前行',
  'pages.angelInsider.reader.back': '← 返回',
  'pages.angelInsider.reader.label': 'A&GEL INSIDER',
  'pages.angelInsider.reader.contents': '目录',
  'pages.angelInsider.reader.issueNumber': '第 {number} 期',
  'pages.angelInsider.reader.featureGuide': '功能指南',
  'pages.angelInsider.reader.minRead': '{minutes} 分钟阅读',
  'pages.angelInsider.reader.atAGlance': '一览',
  'pages.angelInsider.blockRenderer.supportedAlt': '支持',
  'pages.angelInsider.typewriterExample.badLabel': '这样可以：',
  'pages.angelInsider.typewriterExample.goodLabel': '但这样更好：',
  'pages.angelInsider.basics.habits.labels.takeaways': '要点',
  'pages.angelInsider.basics.habits.labels.examples': '示例',
  'pages.angelInsider.basics.habits.labels.benefits': '收益',
  'pages.angelInsider.basics.habits.habit1.tile.patternMatchers':
    'A&GEL 这类 AI 工具并不会读心；它们是<strong>模式匹配器</strong>。问题问得含糊，得到的就是泛泛的答案；提供丰富而具体的上下文，则更有可能获得精准、可付诸行动的结果。',
  'pages.angelInsider.basics.habits.habit1.tile.callItContext':
    '我们把这个起点称为<strong>“上下文”</strong>。',
  'pages.angelInsider.basics.habits.habit1.tile.rawMaterial':
    '请把上下文视为 A&GEL 赖以工作的原材料。撰写法律备忘录时，别只说“总结这个案子”。应当上传判决书、指明您关心的关键事实或法律争点，并告诉 AI 受众是谁（您也可以使用我们为总结任务开发的现成提示词，可在提示词库中找到）。一般而言，您提供的上下文越多，A&GEL 表现越好。',
  'pages.angelInsider.basics.habits.habit1.tile.promptLibraryLink': '了解更多提示词库内容',
  'pages.angelInsider.basics.habits.habit1.tile.empowerYou':
    'A&GEL 这类 AI 工具直接赋能<em>您本人</em>——它们会放大您的能力，但前提是由您来指明方向。没有上下文，AI 就像一位未获案情简报的杰出律师，或是一位缺少必要背景信息、无从下手的能干同事。',
  'pages.angelInsider.basics.habits.habit1.tile.vault.title': '保险库是您在 A&GEL 上的“大脑”',
  'pages.angelInsider.basics.habits.habit1.tile.vault.body':
    '保险库是 A&GEL 最主要的上下文来源，它把 A&GEL 的输出锚定在您可信、经过筛选的知识库之上。A&GEL 不会搜索互联网——它严格在您上传的内容范围内工作。请把它想象成一位不知疲倦的同事：递给他一张堆满无关文件的凌乱办公桌，他的工作就会打折扣；递给他一份切题的先例，他的工作就会变得犀利。请把文件整理进合乎逻辑的子文件夹，对上传内容有所取舍，并用“引用文件权重”与“会话文件权重”微调 A&GEL 的优先级。请把保险库当作一座精心编排的图书馆，而不是垃圾填埋场。',
  'pages.angelInsider.basics.habits.habit1.tile.vault.link': '了解更多保险库内容',
  'pages.angelInsider.basics.habits.habit1.tile.documents.title': '在提问之前先给 A&GEL 具体的文档',
  'pages.angelInsider.basics.habits.habit1.tile.documents.body':
    '如果您把文件拖放到对话中，或选中某份文件与之对话，这就相当于只把这份文档的内容装入了 A&GEL 的短期记忆。参加过我们工作坊的许多同仁应该都听我们把这份文件形容为“你昨晚刚追完的那集韩剧”（<em>今天满脑子都只想聊它</em>）。这会让 A&GEL 产生“隧道视野”，而这一点可以善加引导，用来获得准确的输出。',
  'pages.angelInsider.basics.habits.habit1.tile.documents.link': '了解更多上下文内容',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.title':
    '与 A&GEL 协作，和与同事协作并无二致',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.body':
    '正如您会给团队成员一些信息以助其推进工作，对 A&GEL 也是一样。',
  'pages.angelInsider.basics.habits.habit1.tile.query.title':
    '那我提示词中的问题或指令本身呢？这算不算“给了 A&GEL 一些东西”？',
  'pages.angelInsider.basics.habits.habit1.tile.query.body':
    '算。对 A&GEL 这类 AI 工具而言，提示词只是作为一串词语被摄入／处理，因此整条提示词对 AI 工具或 A&GEL 来说就是“上下文”。如果您在提示词中提问，那么问得更好，答案自然更好。',
  'pages.angelInsider.basics.habits.habit1.tile.query.link': '了解更多提示词撰写内容',
  'pages.angelInsider.basics.habits.habit1.tile.benefitsIntro':
    '为 A&GEL 提供丰富的上下文，您将获得：',
  'pages.angelInsider.basics.habits.habit1.tile.benefit1':
    '<strong>更好的输出：</strong>具体的上下文带来具体的结果——获得充分简报的 A&GEL，表现得像一位已然熟悉案情的同事，而非从零开始的新手。',
  'pages.angelInsider.basics.habits.habit1.tile.benefit2':
    '<strong>更少的往返：</strong>起点越精准，您花在重复提示或纠错上的时间就越少。请尽早把方向定准。',
  'pages.angelInsider.basics.habits.habit1.tile.benefit3':
    '<strong>（好的那种）隧道视野：</strong>在提问前先上传特定文档，会把 A&GEL 的注意力牢牢锁定——它只在该上下文内工作，这意味着更高的准确性与更少的输出噪音。',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.bad':
    '把每次 A&GEL 对话都当作一次性行为，每次都从零开始',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.good':
    '像对待新加入团队的同事那样把 A&GEL 拉进来——先简要介绍事项、各方当事人以及您想达成的目标，再请它着手工作。',
  'pages.angelInsider.basics.habits.habit1.examples.clause.bad': '让 A&GEL“审阅这个条款”',
  'pages.angelInsider.basics.habits.habit1.examples.clause.good':
    '“请为[客户]审阅这个条款，用于[……]”，并说明审阅时应重点关注什么（例如“任何与费用或财务事项相关的问题”）。',
  'pages.angelInsider.basics.habits.habit2.tile.intro':
    '大语言模型擅长梳理信息结构、识别模式、起草文本以及整理复杂数据。它是用来<em>处理</em>的工具，而不是用来<em>决策</em>的。您依然是裁判、策略制定者与最终权威。AI 承担语言处理的重活——改写、概括、提取条款——而由您运用专业能力去验证其输出。这一区分至关重要：可以信任 AI 去处理，但绝不要把判断外包出去。正如指南所提醒的，AI 工具“或许无法取代人的判断，但在许多方面能够放大您的能力”。',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.title':
    '把它拆开（尤其是冗长的提示词）',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.body':
    '许多用户把 A&GEL 当作简单的聊天机器人，敲进一长条提示词就寄望于最好的结果。这并不是使用 A&GEL 这类 AI 工具的最佳方式。进阶用户会把复杂任务拆解为更小、更可控的部分——与其用一条大提示词，不如分成若干条子提示词。这种技巧称为<em>分解</em>，往往能带来更高质量的结果。',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.imageAlt': '一条冗长的提示词',
  'pages.angelInsider.basics.habits.habit2.tile.oneGoExample':
    '一口气运行一条庞大、繁复、多部分的提示词，例如“准备一份报告，涵盖我在文档 1 与文档 2 中的全部关注点，然后为该报告作总结以生成执行摘要，随后再把完整报告与执行摘要合并为一份文档”。',
  'pages.angelInsider.basics.habits.habit2.tile.breakTaskIntro':
    '把任务拆分为更小的连续步骤，并用应用中的多步提示词逐一执行。',
  'pages.angelInsider.basics.habits.habit2.tile.step1.title': '第 1 步：提取',
  'pages.angelInsider.basics.habits.habit2.tile.step1.context':
    '输入上下文：[<em>插入文档 1 与文档 2 的正文</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step1.prompt':
    '提示词 1：“生成一份全面的要点清单，列出两份文档中提及的所有关注点、问题或风险。”',
  'pages.angelInsider.basics.habits.habit2.tile.step2.title': '第 2 步：撰写完整报告',
  'pages.angelInsider.basics.habits.habit2.tile.step2.context':
    '输入上下文：[<em>插入第 1 步的输出</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step2.prompt':
    '提示词 2：“利用该要点清单，撰写一份详尽的正式报告。把相似的关注点归入相应的标题之下。不要包含引言或执行摘要。”',
  'pages.angelInsider.basics.habits.habit2.tile.step3.title': '第 3 步：执行摘要与最终整合',
  'pages.angelInsider.basics.habits.habit2.tile.step3.context':
    '输入上下文：[<em>插入第 2 步的输出</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step3.prompt':
    '提示词 3：“首先，为这份正式报告撰写一段简明扼要的执行摘要。然后输出该执行摘要，加上一条视觉分隔线，并在其下方原样输出该正式报告，以形成一份合并后的文档。”',
  'pages.angelInsider.basics.habits.habit2.tile.multiStepLink': '查看多步提示词的完整实操示例',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.title':
    '用 A&GEL 改写、排版既有文本，或据以延伸推演',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.body':
    '与其在毫无参考资料的情况下让 A&GEL 从零起草复杂的法律文件，不如提供参考资料，并且 (i) 借助 A&GEL 的语言能力，把您的草稿在语气、结构或排版上加以调整，或把多份草稿融合为一；或 (ii) 从中延伸推演意图、走向、影响或其他二阶特征（例如跨若干段落或文档生成一份审阅发现清单）。',
  'pages.angelInsider.basics.habits.habit2.tile.benefitsIntro':
    '把 A&GEL 当作文本处理器并拆解您的任务，您将获得：',
  'pages.angelInsider.basics.habits.habit2.tile.benefit1':
    '<strong>更高质量的输出：</strong>把复杂任务分解为子提示词，能让 A&GEL 一次只专注一件事——每一步都稳稳地建立在上一步之上，而不会在一条超载的提示词下崩塌。',
  'pages.angelInsider.basics.habits.habit2.tile.benefit2':
    '<strong>更可预期的结果：</strong>当您掌控每一步，您就掌控了输出。您可以先验证再往前推进，而不是寄望于一条大提示词恰好命中。',
  'pages.angelInsider.basics.habits.habit2.tile.benefit3':
    '<strong>更好地发挥您的专业：</strong>A&GEL 承担语言上的重活——改写、组织结构、提取要点。您则保持审阅者与策略制定者的角色，而这正是您的判断最有价值之处。',
  'pages.angelInsider.basics.habits.habit2.examples.nda.bad':
    '让 A&GEL“为一个软件项目起草一份保密协议”',
  'pages.angelInsider.basics.habits.habit2.examples.nda.good':
    '“这是我们的标准保密协议范本[粘贴]。请把保密期限改为 5 年，加入监管披露的例外条款，并把所有关于新加坡法律的援引替换为香港法律。”',
  'pages.angelInsider.basics.habits.habit3.tile.intro':
    '通过探索简单对话之外的功能——例如上传文档、使用特定应用或专项功能，或把多个功能按步骤串联起来——您可以对输出获得更精细的掌控。',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.title': '动手尝试是关键',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.body':
    '请自由地尝试与探索其他功能。专项模式下的许多功能都针对更高的准确性与周全度作了调优。请找出最契合您工作流的功能，并且不要害怕犯错。技能提升就像登楼梯：先从基础开始，随着信心增强，您自然会迈向更进阶的技巧。',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.closing':
    '当您掌握了上下文、尊重 AI 作为文本处理器的角色（以及您自身作为专家的角色），并学会拆解复杂任务，您就会把 A&GEL 从一件新奇玩意儿，变成日常执业中不可或缺的一部分。',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.title':
    'A&GEL 与其说是聊天机器人，不如说是一把瑞士军刀',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.body':
    '这是我们一开始就作出的设计选择：提供一整套多用途的知识工具，以精准之力破解复杂难题，而不是把所有能力都塞进一个对话窗口。对话很适合头脑风暴与快速提问，但面对篇幅极大的文档（例如超过 20,000 字的文档）或复杂的多步骤、多部分任务时就会力不从心。我们没有把这些利器藏在对话里，而是把它们放在左侧边栏最显眼的位置。我们的目标，是帮助您把具体的工作目标与合适的功能——或功能组合——对应起来。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.title': '探索对话之外的其他功能',
  'pages.angelInsider.basics.habits.habit3.tile.explore.review':
    '审阅：适合多文档分析、尽职调查，以及借助结构化问题清单梳理复杂文件。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.reviewLink': '了解更多审阅内容',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudio':
    'Workstudio：通过自动落实标准立场，使合同起草标准化。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudioLink': '了解更多 Workstudio 内容',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribe':
    '笔录：把音频文件精准转写为文字，并支持实时转写与跨境通话的同声翻译。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribeLink': '了解更多笔录内容',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfo':
    '快速信息／引导式摘要：对任一单份文档作快速、可溯源的解读。要概览就用快速信息；想掌控重点就用引导式摘要。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfoLink':
    '了解更多快速信息与引导式摘要内容',
  'pages.angelInsider.basics.habits.habit3.tile.explore.translation':
    '翻译：为法律与商务内容提供专门的、段落级精准的翻译。',
  'pages.angelInsider.basics.habits.habit3.tile.explore.apps':
    '应用：针对特定任务在准确性与周全度上作了调优。举例来说，多步提示词提供多种分析工具，可就特定要点剖析文档，为篇幅更长、复杂度超出对话能力范围的工作提供所需的精度。',
  'pages.angelInsider.basics.habits.habit3.tile.benefitsIntro':
    '把任务与具体功能对应起来，您将获得：',
  'pages.angelInsider.basics.habits.habit3.tile.benefit1':
    '<strong>更强的掌控：</strong>为工作挑选合适的工具，而不是一味依赖单一的对话界面，准确性自然更高。',
  'pages.angelInsider.basics.habits.habit3.tile.benefit2':
    '<strong>技能积累：</strong>动手尝试是关键。当您试用不同功能及其组合时，就会逐步建立起对 A&GEL 能力边界的心智模型。这就像登楼梯：先从对话中的基础提问开始，随着熟练度提升，再进阶到应用或审阅中的复杂多步分析。',
  'pages.angelInsider.basics.habits.habit3.tile.benefit3':
    '<strong>效率：</strong>知道该用哪件工具就能省下时间。您不必再为那些本该交给专门功能处理的任务（例如用笔录做转写、用翻译做精准语言转换）在对话里反复折腾提示词。',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.bad':
    '无论面对 90 页的协议还是多步骤分析，都只用对话',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.good':
    '试着用审阅处理一份冗长的合同，或用多步提示词处理一项分若干阶段的任务——并留意哪个功能在该项工作上更快、更准。',
  'pages.angelInsider.basics.habits.habit3.examples.paste.bad':
    '把一份 90 页的协议粘贴进对话，然后问“有哪些风险？”',
  'pages.angelInsider.basics.habits.habit3.examples.paste.good':
    '用“审阅”配合一份结构化的问题清单来处理它——或使用应用中的“多步提示词”——逐节梳理该文档，精准定位您真正想找的内容。',
  'pages.angelInsider.seeMore': '查看更多',
  'pages.angelInsider.learnMore.heading': '了解更多',
  'pages.angelInsider.learnMore.intro':
    '除对话之外，A&GEL 的应用模式还涵盖各类专项任务：深度研究、引导式摘要、快速信息、时间线以及提取截止日期。这些功能越精准、准备越充分，效果越好。',
  'pages.angelInsider.learnMore.featuredBadge': '精选',
  'pages.angelInsider.learnMore.cards.usingFiles.title': '在 A&GEL 中使用您的文件',
  'pages.angelInsider.learnMore.cards.usingFiles.body':
    '扫描件需要先具备文本层，A&GEL 才能读取。请使用 Kofax 将 PDF 转换为可搜索格式，然后再上传。',
  'pages.angelInsider.learnMore.cards.workStudio.title': 'Workstudio',
  'pages.angelInsider.learnMore.cards.workStudio.body':
    '只需一次性录入团队的标准立场——A&GEL 即可返回带修订标记的 Word 文档。',
  'pages.angelInsider.learnMore.cards.workStudio.imageAlt': 'Workstudio',
  'pages.angelInsider.learnMore.cards.review.title': '审阅',
  'pages.angelInsider.learnMore.cards.review.body':
    '一次性针对多份文档提出多个问题——结果以表格形式呈现，并附带内联引注。使用迷你对话即可在当前页面继续追问。',
  'pages.angelInsider.learnMore.cards.review.imageAlt': '审阅模式',
  'pages.angelInsider.learnMore.cards.dispute.title': '争议解决',
  'pages.angelInsider.learnMore.cards.dispute.body':
    '在完整文档集范围内完成案情摘要、索赔陈述书分析、答辩状起草以及诉状追踪。',
  'pages.angelInsider.learnMore.cards.dispute.imageAlt': '诉状追踪器',
  'pages.angelInsider.learnMore.cards.sideBySide.title': '并排对比与比较',
  'pages.angelInsider.learnMore.cards.sideBySide.body':
    '逐条款审阅，并可完整核验来源段落。比较功能支持修订标记与修订版本。',
  'pages.angelInsider.learnMore.cards.sideBySide.imageAlt': '并排对比分析',
  'pages.angelInsider.learnMore.cards.multiStep.title': '多步提示词',
  'pages.angelInsider.learnMore.cards.multiStep.body':
    '将复杂的法律任务拆解为连续步骤，每一步都以上一步为基础。',
  'pages.angelInsider.learnMore.cards.multiStep.imageAlt': '应用模式',
  'pages.angelInsider.learnMore.cards.timeline.title': '时间线',
  'pages.angelInsider.learnMore.cards.timeline.body':
    '将最多 100 份文档中的时间脉络合并为一条经来源核验的时间线。',
  'pages.angelInsider.learnMore.cards.timeline.imageAlt': '时间线',
  'pages.angelInsider.learnMore.cards.deepResearch.title': '深度研究',
  'pages.angelInsider.learnMore.cards.deepResearch.body':
    '在结构化研究提示词的引导下开展深入的跨文档分析。每项发现都可通过可点击的内联引注回溯至来源段落。',
  'pages.angelInsider.learnMore.cards.deepResearch.imageAlt': '深度研究',
  'pages.angelInsider.learnMore.cards.scopeSummary.title': '范围摘要',
  'pages.angelInsider.learnMore.cards.scopeSummary.body':
    '围绕您设定的关注领域生成结构化摘要。每个提取要点均附带可点击的内联引注，便于对照来源核验。',
  'pages.angelInsider.learnMore.faq.heading': '常见问题',
  'pages.angelInsider.learnMore.faq.group1.kicker': '总体原则',
  'pages.angelInsider.learnMore.faq.experts.question': '“始终让专业人士做专业的事”是什么意思？',
  'pages.angelInsider.learnMore.faq.experts.answer':
    '作为专业人士，您的判断、洞察与操守应始终是工作的核心。A&GEL 不会取代您的专业能力——它旨在帮助您以更多资源完成更多工作。',
  'pages.angelInsider.learnMore.faq.unfamiliar.question':
    '如果我对向 A&GEL 提问的主题完全不熟悉，该怎么办？',
  'pages.angelInsider.learnMore.faq.unfamiliar.answer':
    '您仍然可以使用 A&GEL——但需要更加谨慎，并对输出结果进行更多核查。可以把 A&GEL 当作通往团队既有专业知识的入口，随时获取洞见，助力自身的培训与成长。',
  'pages.angelInsider.learnMore.faq.group2.kicker': '文件管理',
  'pages.angelInsider.learnMore.faq.referenceMaterial.question':
    '我应该向 A&GEL 上传哪类参考资料？',
  'pages.angelInsider.learnMore.faq.referenceMaterial.answer':
    '仅上传可信、可靠且准确的资料——一手法律渊源（法规、判例）以及可信的内部资料（公司专业知识、经过验证的文档）。请保持清晰的命名规范。',
  'pages.angelInsider.learnMore.faq.thirdParty.question': '我可以上传第三方文档吗？',
  'pages.angelInsider.learnMore.faq.thirdParty.answer':
    '可以——包括对方律师提供的文档。请将其上传至明确标注的文件夹，以便与您可信的范本区分开来。同时请遵守公司关于 AI 使用及第三方内容的相关政策。',
  'pages.angelInsider.learnMore.faq.processingTime.question':
    '为什么 A&GEL 处理上传文件需要较长时间？',
  'pages.angelInsider.learnMore.faq.processingTime.answer':
    '文档必须先转换为 A&GEL 可处理的“向量嵌入”——这一过程在上传时只进行一次。在对话中，您可以通过“上下文”按钮选择已上传的文档，在新会话中重复使用。',
  'pages.angelInsider.learnMore.faq.bulkUpload.question': '如何批量上传文档？',
  'pages.angelInsider.learnMore.faq.bulkUpload.answer':
    '在文件模式下，点击右上角的上传按钮，选择文件后按“打开”。上传过程中您可以继续使用 A&GEL。',
  'pages.angelInsider.learnMore.faq.sorting.question': '我应该如何整理和管理参考资料？',
  'pages.angelInsider.learnMore.faq.sorting.answer':
    '不要把所有内容都上传到同一个文件夹。请按（i）主题和（ii）工作流对文档进行分组——例如 <code>Home / IP Licensing / Licensor</code>。这有助于 A&GEL 检索到正确的上下文，也更便于您核验其输出。',
  'pages.angelInsider.learnMore.faq.group3.kicker': '提示词',
  'pages.angelInsider.learnMore.faq.promptTypes.question': '我可以使用哪些类型的提示词？',
  'pages.angelInsider.learnMore.faq.promptTypes.answer':
    '包括信息获取类（提问式、解释式、研究式）、任务导向类（指令式、多步骤、模板式）、分析类（数据分析、问题解决、比较分析）、分类类（归类、排序、打标签）以及转换类（翻译、格式转换、文风调整）等多种提示词。',
  'pages.angelInsider.learnMore.faq.effectivePrompts.question': '如何撰写有效的提示词？',
  'pages.angelInsider.learnMore.faq.effectivePrompts.answer':
    '最有效的提示词包含四个部分：<strong>（a）角色</strong>——A&GEL 应当扮演的身份；<strong>（b）任务</strong>——具体的指令；<strong>（c）上下文</strong>——背景信息与参考资料；<strong>（d）格式</strong>——您希望输出呈现的结构。',
  'pages.angelInsider.learnMore.faq.rag.question': '什么是 RAG？A&GEL 何时会使用它？',
  'pages.angelInsider.learnMore.faq.rag.answer':
    'RAG（检索增强生成）是 A&GEL 对话模式的默认方式。它会调用您保险库中的参考资料，并与您的提示词一同传递给模型，从而提升输出的精确度与可靠性。',
  'pages.angelInsider.learnMore.faq.allMaterials.question':
    '为什么不应该让 A&GEL 在每次提示时都考虑我上传的全部资料？',
  'pages.angelInsider.learnMore.faq.allMaterials.answer':
    '提供无关的上下文会降低速度、准确性与可靠性。A&GEL 以概率方式运作，可能会调用不适合当前任务的资料。请将上下文限定为与您的提示词相关的文档。',
  'pages.angelInsider.learnMore.faq.selectMaterials.question':
    '我该如何为每个提示词选择相关的参考资料？',
  'pages.angelInsider.learnMore.faq.selectMaterials.answer':
    '在对话模式下，进入“上下文”，点击选择图标，仅勾选相关的文档或文件夹。',
  'pages.angelInsider.learnMore.faq.group4.kicker': '使用输出结果',
  'pages.angelInsider.learnMore.faq.outputAsIs.question': '我可以直接使用 A&GEL 的输出结果吗？',
  'pages.angelInsider.learnMore.faq.outputAsIs.answer':
    '不可以——使用前请务必检查 A&GEL 的输出。请将其视为起点，并与可信的知识来源（包括您上传的参考资料）交叉核对。',
  'pages.angelInsider.learnMore.faq.accuracy.question': '我应如何检查输出的准确性与可靠性？',
  'pages.angelInsider.learnMore.faq.accuracy.answer':
    '在对话模式下，输出会附带指向 A&GEL 所引用来源文档的参考链接。请逐条点击参考链接，对照原始资料进行核验。A&GEL 应当是通往您专业知识的入口，而非知识本身的来源。没有参考来源的输出容易出现幻觉，除非提示词纯粹用于写作、排版或文本编辑且已提供充分上下文，否则不应使用。',
  'pages.angelInsider.learnMore.faq.group5.kicker': '术语表',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.term': '收藏文件权重',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.definition':
    '调整 A&GEL 在生成回复时对保险库中标记为“收藏”的文档的优先程度。',
  'pages.angelInsider.learnMore.glossary.reRanking.term': '重排序',
  'pages.angelInsider.learnMore.glossary.reRanking.definition':
    '一道二次排序流程，会复核初始检索结果，在生成回复前优先选出最相关的条款与文本片段。',
  'pages.angelInsider.learnMore.glossary.searchRatio.term': '检索比例',
  'pages.angelInsider.learnMore.glossary.searchRatio.definition':
    '控制 A&GEL 检索保险库的广度。比例越高，上下文范围越广；比例越低，越侧重精确匹配。',
  'pages.angelInsider.learnMore.glossary.systemPrompt.term': '系统提示词',
  'pages.angelInsider.learnMore.glossary.systemPrompt.definition':
    '为每次会话设定 A&GEL 的角色、语气与边界的基础指令。',
  'pages.angelInsider.learnMore.glossary.thinking.term': '“思考”/“推理”',
  'pages.angelInsider.learnMore.glossary.thinking.definition':
    'A&GEL 在生成最终回复前进行的内部逐步推演，旨在减少复杂分析中的错误。',
  'pages.angelInsider.learnMore.issues.heading': '如果您想阅读各期内容',
  'pages.angelInsider.learnMore.issues.issue1.title': '上下文（几乎）就是一切',
  'pages.angelInsider.learnMore.issues.issue1.description':
    '基础 • 提示词要点 • 2026 年 2 月 17 日',
  'pages.angelInsider.learnMore.issues.issue2.title': '争议解决应用场景',
  'pages.angelInsider.learnMore.issues.issue2.description':
    '案情摘要 • 诉状追踪器 • 提示词技巧 • 2026 年 3 月 19 日',
  'pages.angelInsider.learnMore.issues.issue3.title': '全新时间线与多步提示词应用',
  'pages.angelInsider.learnMore.issues.issue3.description':
    '邮件上传 • 笔录更新 • 时间线改版 • 2026 年 3 月 19 日',
  'pages.angelInsider.learnMore.issues.issue4.title': '笔录实时翻译与 Workstudio',
  'pages.angelInsider.learnMore.issues.issue4.description':
    '实时翻译 • 全新 Workstudio 功能 • 2026 年 4 月 1 日',
  'pages.angelInsider.learnMore.issues.issue5.title': '内联引注、迷你对话及更多更新',
  'pages.angelInsider.learnMore.issues.issue5.description':
    '定位引注 • 可移动迷你对话 • 笔录时间戳 • 2026 年 4 月 10 日',
  'pages.angelInsider.learnMore.issues.pill': '第 {number} 期',
  'pages.angelInsider.whatsNew.heading': '新功能',
  'pages.angelInsider.whatsNew.cards.msgUpload.title': '.msg 邮件上传',
  'pages.angelInsider.whatsNew.cards.msgUpload.body':
    '可直接上传 .msg 邮件文件，并完整读取其中的附件内容。',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.title': '内联引注',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.body':
    '深度研究、时间线、范围摘要与审阅现已支持可点击的定位引注——无需离开当前页面即可对照来源核验任何输出。',
  'pages.angelInsider.comingUp.heading': '即将推出',
  'pages.angelInsider.comingUp.intro':
    '在下一期 A&GEL Insider 中，我们将更深入地介绍 Workstudio。您将学会如何从零构建多步提示词，并借此生成体现团队标准立场的带修订标记草稿。敬请期待。',
  'pages.angelInsider.comingUp.cards.workstudioV2.title': 'Workstudio V2',
  'pages.angelInsider.comingUp.cards.workstudioV2.body':
    '更深入的 Workstudio 撰写工具，以及更完善的带修订标记输出。详情见第 5 期。',
  'pages.angelInsider.comingUp.cards.workstudioV2.badge': '即将推出',
  'pages.angelInsider.comingUp.cards.moreToCome.title': '更多内容陆续推出',
  'pages.angelInsider.comingUp.cards.moreToCome.body':
    'A&GEL 团队持续推出新功能。敬请期待下一期 Insider。',
  'pages.angelInsider.comingUp.cards.moreToCome.badge': '开发中',
  'pages.angelInsider.issues.basics-intro.title': '欢迎使用 A&GEL',
  'pages.angelInsider.issues.basics-intro.subtitle': '几点建议，助您有一个良好的开端。',
  'pages.angelInsider.issues.basics-intro.glance.0': '学习新工具需要时间——我们会全程为您提供支持。',
  'pages.angelInsider.issues.basics-intro.glance.1':
    'A&GEL 这类工具能<strong>放大您的能力</strong>，远超您独自所能达到的程度。',
  'pages.angelInsider.issues.basics-intro.glance.2':
    '最好的学习方式就是<strong>开始使用 A&GEL</strong>——自由探索，允许犯错。',
  'pages.angelInsider.issues.basics-intro.glance.3':
    '当团队共同拥抱 A&GEL 时，收益会为所有人叠加放大。',
  'pages.angelInsider.issues.basics-intro.sections.0.kicker': '01 — 入门',
  'pages.angelInsider.issues.basics-intro.sections.0.heading': '学习新工具需要时间——这很正常',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.0.p':
    '非常高兴您加入我们。在您开始探索 A&GEL 之际，我们想分享几点想法，助您有一个良好的开端。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.1.p':
    '我们明白，刚开始接触新技术时可能会觉得有些吃力。请记住：我们会在每一步为您提供支持。如果您有任何疑问、遇到卡顿，或者只是希望我们带您走一遍流程，都请随时与我们联系。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.3.p':
    'A&GEL 这类 AI 工具<strong>与以往的工具不同</strong>——它们<strong>直接赋能于您</strong>。可以把它想象成随时待命的一支助理团队：它们或许无法取代人的判断，但在许多方面都能把您的能力放大到独自难以企及的程度。',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.4.p':
    '<strong>开始学习的最佳方式，就是开始使用 A&GEL——</strong>我们鼓励您自由探索。多加尝试，允许犯（安全范围内的）错误，从中找到最适合自己的方式。',
  'pages.angelInsider.issues.basics-intro.sections.1.kicker': '02 — 技能进阶',
  'pages.angelInsider.issues.basics-intro.sections.1.heading': '按自己的节奏前进',
  'pages.angelInsider.issues.basics-intro.sections.1.blocks.0.p':
    '可以把技能提升想象成登楼梯。先从基础开始，随着信心增强，迈向下一层会变得自然许多。不必着急——这不是一场比赛。请给自己足够的时间打好基础。',
  'pages.angelInsider.issues.basics-intro.sections.2.kicker': '03 — 社群',
  'pages.angelInsider.issues.basics-intro.sections.2.heading': '携手同行，共赴更远',
  'pages.angelInsider.issues.basics-intro.sections.2.blocks.0.p':
    '当团队与律所共同拥抱 A&GEL 时，收益会为所有人叠加放大。在用户社群中分享知识、彼此协作，会形成提升所有人的涟漪效应。',
  'pages.angelInsider.issues.basics-intro.signoff.line':
    '欢迎加入——我们很期待与 A&GEL 一起创造出怎样的成果。',
  'pages.angelInsider.issues.basics-intro.signoff.name': 'Kok Leong<br>A&GEL 开发团队',
  'pages.angelInsider.issues.issue-1.title': '上下文（几乎）就是一切',
  'pages.angelInsider.issues.issue-1.subtitle':
    '提示词要点——上下文的选择如何决定 A&GEL 返回的一切内容。',
  'pages.angelInsider.issues.issue-1.date': '2026 年 1 月 15 日',
  'pages.angelInsider.issues.issue-1.glance.0':
    '对话现已配备专门的<strong>上下文</strong>按钮以及<strong>“上下文占比”</strong>指示器。',
  'pages.angelInsider.issues.issue-1.glance.1':
    '默认检索参数现为<strong>零上下文</strong>——速度更快，适合校对与轻量编辑。',
  'pages.angelInsider.issues.issue-1.glance.2':
    '从保险库中建立一套<strong>默认上下文预设</strong>，用于日常工作。',
  'pages.angelInsider.issues.issue-1.glance.3':
    '没有上下文的提示词只是一次猜测——请务必补上只有您掌握的背景信息。',
  'pages.angelInsider.issues.issue-1.sections.0.kicker': '01 — 对话',
  'pages.angelInsider.issues.issue-1.sections.0.heading':
    '对话中的上下文：专门的按钮与“上下文占比”指示器',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.0.p':
    'A&GEL 的对话功能采用定制化的<strong>检索增强生成（RAG）</strong>管线。它会调用您保险库中的专业知识与参考资料，并将其传递给模型以生成输出。决定 RAG 质量最关键的因素就是<em>上下文选择</em>——即答案取材于保险库中多大的范围。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.1.p':
    '为了让这一点更直观，我们新增了<strong>“上下文占比”</strong>指示器——它虽然粗略，却能一目了然地反映当前对话会话纳入了保险库的多少内容。点击上下文按钮，即可精确选择要参与对话的文件夹或文件。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.title': '新的默认设置：零上下文',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.body':
    '默认检索参数现为零上下文（位于对话窗口右上角）。这样对话速度更快，仅依据预训练的公共知识生成内容——适合校对或文字润色等简单需求。在零上下文设置下，A&GEL 通常可在数秒内作出回应。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.3.h': '为日常使用设定默认上下文',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.4.p':
    '由于 A&GEL 依据<em>您</em>的专业知识作答，您可以创建默认上下文预设：点击上下文按钮，选择文件夹，再点击加号（+）。为预设命名，可勾选<strong>“设为默认”</strong>，然后点击确定。',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.5.p':
    '选中<strong>全部</strong>文件夹（100% 上下文）会让 A&GEL 变慢，因为它需要检索每一份文档——范围越广并不总是越好。请针对具体问题调整上下文。响应时间可能长达一分钟，具体取决于您可访问的文件数量以及问题的复杂程度。',
  'pages.angelInsider.issues.issue-1.sections.1.kicker': '02 — 提示词',
  'pages.angelInsider.issues.issue-1.sections.1.heading': '撰写提示词时，务必补上您的上下文',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.0.quote':
    '没有上下文的提示词只是一次猜测——形同“提示词轮盘赌”。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.1.p':
    '提示词要行之有效，就必须获得正确的信息——在高度专业化的领域尤其如此。请把 A&GEL 视为一位能干的助理，但它需要完整的全貌：请提供只有您知道的背景——您的关键目标、衡量成败的标准，甚至“好答案”与“坏答案”的示例。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.2.h': '让提示词更充实的简单框架',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.3.p':
    '请不断自问：我提供的上下文是否足够。这正是您施展专业功力之处——与基础提示相比，结果的质量可能有天壤之别。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.title': '诉讼示例',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.body':
    '诉讼律师只需复制一份提示词，再把方括号中的部分改写成自己案件的内容，输出质量便会大幅提升。您提供的法律上下文（适用法律的简要梳理）与商业上下文（相关事实背景）越充分，该提示词作为分析工具的表现就越好。',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.5.p':
    '最了解自身上下文的人是您——因此请务必补上那类能让您的提示词、问题清单和自定义指令真正发挥效力的具体上下文。',
  'pages.angelInsider.issues.issue-1.sections.2.kicker': '03 — 开始使用',
  'pages.angelInsider.issues.issue-1.sections.2.heading': '需要帮助？',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.title':
    '遇到问题？请告诉我们三件事',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.body':
    '请发消息或发邮件给 A&GEL 开发人员。只需包含以下内容即可：',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.0':
    '<strong>时间戳</strong>——例如“今天下午 4:31 开始的一次对话”',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.1':
    '<strong>出问题的功能</strong>——例如“在分析 → 深度研究中尝试上传文件，未能加载”',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.2':
    '<strong>简要描述</strong>或截图',
  'pages.angelInsider.issues.issue-1.signoff.line': '祝好，并请记住——上下文优先。',
  'pages.angelInsider.issues.issue-1.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.issue-2.title': '争议解决应用场景',
  'pages.angelInsider.issues.issue-2.subtitle':
    '生成摘要与初稿、分析并追踪诉状——另附提示词撰写技巧。',
  'pages.angelInsider.issues.issue-2.date': '2026 年 2 月 12 日',
  'pages.angelInsider.issues.issue-2.glance.0':
    '两套<strong>案情摘要</strong>提示词（简明版与详尽版）——详尽版在复杂判决上表现尤为出色。',
  'pages.angelInsider.issues.issue-2.glance.1':
    '用于起草<strong>答辩状</strong>和面向客户的<strong>法律动态</strong>的提示词。',
  'pages.angelInsider.issues.issue-2.glance.2':
    '一整套用于<strong>分析诉状</strong>的提示词——涵盖索赔陈述书、答辩状及诉状充分性。',
  'pages.angelInsider.issues.issue-2.glance.3':
    '把<strong>审阅模式</strong>当作跨多份文档的诉状追踪器来使用。',
  'pages.angelInsider.issues.issue-2.sections.0.kicker': '01 — 摘要',
  'pages.angelInsider.issues.issue-2.sections.0.heading': '生成案情摘要',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.0.p':
    '我们开发了两套用于总结案件的提示词——一套生成简明概览，另一套进行更深入的分析。它们改编自新加坡律师学院（SAL）公开发布的提示词，并借助生成式 AI 反复打磨（包括让 A&GEL 点评自己的输出）。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.1.p':
    '根据我们的经验，<strong>详尽版</strong>案情摘要通常更胜一筹，在较复杂的判决上尤其如此。A&GEL 被要求<em>完全</em>依据原判决作答——但请注意，它在区分<em>判决理由（ratio decidendi）</em>与<em>附带意见（obiter dicta）</em>时可能会力有不逮。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.title': '并非万灵药',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.body':
    '输出仍须按常规方式复核与验证——对准确性与完整性作彻底检查。这些提示词为您提供的是高效的起点，而非可直接交付的成果。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.3.p':
    '请将其与<strong>引导式摘要</strong>功能（位于应用模式下）搭配使用，该功能会在提示词的引导下总结单份文档。上传一份新加坡法院判决，选择案情摘要（详尽版）提示词，并补充您特别关注的要点。',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.4.figure.caption':
    '提示词库中的案情摘要（简明版）v1.1 与案情摘要（详尽版）v1.1。',
  'pages.angelInsider.issues.issue-2.sections.1.kicker': '02 — 起草',
  'pages.angelInsider.issues.issue-2.sections.1.heading': '生成初稿',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.0.p':
    '有一套提示词（基于 SAL 公开发布的提示词）可针对索赔陈述书生成<strong>答辩状</strong>初稿。请复制后按需调整，并务必补充充分的上下文。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.1.p':
    '另一套提示词可根据案情摘要生成面向客户的<strong>法律动态</strong>，并以一篇简短的知识管理范文来引导文风、结构与语气。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.0.caption':
    '针对索赔陈述书起草答辩状。',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.1.caption':
    '按参考文章的文风与语气起草 v1.2。',
  'pages.angelInsider.issues.issue-2.sections.2.kicker': '03 — 诉状',
  'pages.angelInsider.issues.issue-2.sections.2.heading': '分析诉状',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.0.p':
    '我们准备了若干诉状分析提示词。它们仅经过初步测试——欢迎试用、复制改进，并分享给其他用户。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.0':
    '<strong>分析索赔陈述书</strong>——执行摘要、时间脉络、对照《2021 年法院规则》的充分性评估、关键争点与初步抗辩，以及即时行动事项与后续步骤。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.1':
    '<strong>分析答辩状</strong>——提炼抗辩策略，并找出未就索赔陈述书中的指控作具体回应的缺口。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.2':
    '<strong>诉状充分性</strong>——最初为评估答辩状而设计；请复制后按您正在审阅的诉状类型进行调整。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.0.caption':
    '索赔陈述书分析与时间脉络 v1.5。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.1.caption':
    '分析针对索赔陈述书的答辩状 v1.0。',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.2.caption':
    '答辩状诉状充分性 v1.0。',
  'pages.angelInsider.issues.issue-2.sections.3.kicker': '04 — 审阅模式',
  'pages.angelInsider.issues.issue-2.sections.3.heading': '把审阅当作诉状追踪器使用',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.0.p':
    '一目了然地查看争议全过程中各方的立场。在<strong>审阅模式</strong>下，把索赔陈述书中的每一项诉因都当作引导性问题，系统性地检视并质辩诉状与誓章中提出的立场。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.1.h': '第 1 步——在对话中生成问题清单',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.2.p':
    '将索赔陈述书上传至您的文件或直接拖入对话，然后运行提示词提取诉因：',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.label': '问题清单生成器',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.text':
    '你是一位拥有 20 年经验的诉讼律师。请深呼吸，集中注意力。\n\n所上传的文档是一份索赔陈述书。你的任务是生成一份要点式摘要。每个要点应涵盖：(a) 一项诉因；(b) 该诉因所针对的被告；(c) 所依据的事实主张；以及 (d) 所请求的救济。请把所有子要点写在同一个要点内——不要使用下一级要点。请提取文档中的全部内容。若存在多名被告，请先完整列出针对第一被告的所有诉因，再处理第二被告，依此类推。\n\n内容要全面但简洁：概括并援引与每项诉因直接相关的全部内容。用词要精确：避免含糊表述，并沿用文档本身的措辞。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.4.h': '第 2 步——在审阅中用该清单比对诉状',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.5.p':
    '复制生成的清单，切换到<strong>审阅</strong>，点击<strong>快速提问</strong>。将清单粘贴到<em>添加问题</em>中，点击<em>添加 +</em>，附上您的索赔陈述书，然后点击提交。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.6.gallery.0.caption':
    '审阅模式——将问题清单添加为快速提问矩阵。',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.title': '不止于诉状',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.body':
    '审阅能够针对大量文档提出大量问题，这一能力同样适合其他文档密集型工作——例如证据开示、文档审阅，以及审阅篇幅浩繁的誓章。',
  'pages.angelInsider.issues.issue-2.sections.4.kicker': '05 — 技艺',
  'pages.angelInsider.issues.issue-2.sections.4.heading': '提示词技巧：测试与改进',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.0.p':
    '<strong>测试您的提示词。</strong>把 A&GEL 的输出与您事先准备好的标准答案作比较，以此衡量提示词的水准。若二者高度吻合，说明提示词打磨得不错；若不吻合，请找出差距并补充上下文。',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.1.p':
    '<strong>改进您的提示词。</strong>使用提示词库中的<em>Improve My Prompt v1.0</em> 工具作进一步优化。',
  'pages.angelInsider.issues.issue-2.signoff.line': '复制、调整，并分享行之有效的做法。',
  'pages.angelInsider.issues.issue-2.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-scribe.title': '笔录',
  'pages.angelInsider.issues.feature-scribe.subtitle':
    '录音、转写、实时翻译与编辑会议内容——全部在同一处完成。',
  'pages.angelInsider.issues.feature-scribe.glance.0':
    '<strong>实时编辑</strong>——在笔录录音的同时即可修改转写文本；被编辑的部分会加下划线。',
  'pages.angelInsider.issues.feature-scribe.glance.1':
    '<strong>音频回放</strong>——点击转写文本的任一片段，即可从该处开始播放录音。',
  'pages.angelInsider.issues.feature-scribe.glance.2':
    '<strong>实时翻译</strong>——实时翻译成您选择的语言。',
  'pages.angelInsider.issues.feature-scribe.glance.3':
    '<strong>带时间戳的下载文件</strong>——导出的 Word 转写稿附有时间戳，便于快速定位。',
  'pages.angelInsider.issues.feature-scribe.sections.0.kicker': '笔录',
  'pages.angelInsider.issues.feature-scribe.sections.0.heading': '实时编辑与音频回放',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.0.p':
    '<strong>实时编辑</strong>——改进后的笔录允许您直接修改转写文本；被编辑的部分会加下划线，便于查阅。<strong>音频回放</strong>——转写内容保存后，打开原始转写稿并点击任一片段，即可从该处开始播放录音。',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.0.caption':
    '笔录正在录音，并同步进行实时转写。',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.1.caption':
    '原始转写稿——点击片段即可回放对应音频。',
  'pages.angelInsider.issues.feature-scribe.sections.1.kicker': '笔录',
  'pages.angelInsider.issues.feature-scribe.sections.1.heading': '实时翻译，现已登陆笔录',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.0.p':
    '用您选择的语言听懂通话与会议内容。勾选<strong>实时翻译</strong>并选定语言——A&GEL 会即时把译文呈现在原始转写文本下方。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.1.figure.caption':
    '启用实时翻译，并从下拉菜单中选择语言。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.2.p':
    '在 A&GEL 转写与翻译的同时，您可以直接输入笔记或修改转写文本——您的编辑会以<strong>黄色</strong>显示，以便与 A&GEL 生成的文本区分。保存后的转写稿会同时保留译文与您的编辑。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.0.caption':
    '译文位于原文下方，可编辑的笔记以黄色显示。',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.1.caption':
    '时间戳沿原始转写稿左侧依次排列。',
  'pages.angelInsider.issues.feature-scribe.sections.2.kicker': '笔录',
  'pages.angelInsider.issues.feature-scribe.sections.2.heading': '可下载的转写稿，现已支持时间戳',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.0.p':
    '笔录转写稿现已在下载的 Word 文档中包含<strong>时间戳</strong>——这些标记让您更方便地定位到录音对话或会议中的特定时刻。',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.1.figure.caption':
    '下载的笔录转写稿，保留了时间戳与译文。',
  'pages.angelInsider.issues.feature-scribe.signoff.line': '录制、复核、回放。',
  'pages.angelInsider.issues.feature-scribe.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-prompt-library.title': '提示词库',
  'pages.angelInsider.issues.feature-prompt-library.subtitle':
    '查找、复制并调整由社群构建的提示词——并借助内置工具加以打磨。',
  'pages.angelInsider.issues.feature-prompt-library.glance.0':
    '浏览、复制并调整提示词库中由社群构建的提示词，使之贴合您的具体事项。',
  'pages.angelInsider.issues.feature-prompt-library.glance.1':
    '<strong>测试您的提示词</strong>——把 A&GEL 的输出与您事先准备好的标准答案作比较。',
  'pages.angelInsider.issues.feature-prompt-library.glance.2':
    '使用提示词库中的 <strong>Improve My Prompt v1.0</strong>，进一步优化表现不及预期的提示词。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.kicker': '技艺',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.heading': '提示词技巧：测试与改进',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.0.p':
    '<strong>测试您的提示词。</strong>衡量提示词是否有效的一个好办法，是把 A&GEL 的输出与您事先准备好的“标准答案”或参考输出作比较。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.1.p':
    '举例来说，如果您正在开发一套用于总结案件的提示词，可以拿一份您先前撰写、且非常熟悉的案情摘要作为基准。运行您的摘要提示词，并将 A&GEL 的输出与您此前的成果作对照。若输出与基准高度吻合，说明提示词打磨得不错；若不吻合，请找出具体差距并据此优化提示词——例如补充更多上下文。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.2.p':
    '<strong>改进您的提示词。</strong>可以考虑使用提示词库中的 <em>Improve My Prompt v1.0</em> 工具，进一步优化您的提示词。',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.3.figure.caption':
    'Improve My Prompt v1.0——优化库中已有的提示词。',
  'pages.angelInsider.issues.feature-prompt-library.signoff.line':
    '复制、调整，并分享行之有效的做法。',
  'pages.angelInsider.issues.feature-prompt-library.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-prompting.title': '提示词撰写',
  'pages.angelInsider.issues.feature-prompting.subtitle':
    '没有上下文的提示词只是猜测。这套框架能改变这一点。',
  'pages.angelInsider.issues.feature-prompting.glance.0':
    '每条有效的提示词都包含四个部分：<strong>角色、任务、上下文与格式</strong>。',
  'pages.angelInsider.issues.feature-prompting.glance.1':
    '上下文是只有<em>您</em>才能提供的部分——您的专业功力正体现在此。',
  'pages.angelInsider.issues.feature-prompting.glance.2':
    '没有上下文的提示词形同“提示词轮盘赌”——形式上成立，却难以产出有用的结果。',
  'pages.angelInsider.issues.feature-prompting.glance.3':
    '从提示词库中复制一条提示词，再结合您案件的具体事实与法律框架加以调整。',
  'pages.angelInsider.issues.feature-prompting.sections.0.kicker': '01 — 框架',
  'pages.angelInsider.issues.feature-prompting.sections.0.heading': '角色、任务、上下文、格式',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.0.p':
    '每条有效的提示词都包含四个部分。不妨把它当作一份检查清单：',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.1.p':
    '<strong>角色</strong>——告诉 A&GEL 应当扮演什么身份。<em>“你是一位拥有 20 年经验的诉讼律师。”</em>这会塑造输出的语气、深度与具体程度。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.2.p':
    '<strong>任务</strong>——清晰、具体地说明您希望完成什么。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.3.p':
    '<strong>上下文</strong>——这是只有您才能提供的部分：具体的法律框架、商业事实以及案件的周边情况。没有上下文的提示词只是一次猜测——团队称之为“提示词轮盘赌”。A&GEL 输出的质量，与您提供的上下文质量成正比。',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.4.p':
    '<strong>格式</strong>——明确您希望输出以何种结构呈现。编号清单？表格？条款草案？还是一段简明的文字？若不指定，A&GEL 会采用通用格式，未必契合您的工作流程。',
  'pages.angelInsider.issues.feature-prompting.sections.1.kicker': '02 — 上下文实战',
  'pages.angelInsider.issues.feature-prompting.sections.1.heading': '上下文带来的差别',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.0.p':
    '请把 A&GEL 视为一位能干的助理，它需要完整的全貌才能发挥最佳水准。与其提出泛泛的问题，不如提供只有您知道的具体背景——您的关键目标、案件事实，以及“好答案”与“坏答案”分别是什么样子。',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.1.p':
    '您提供的法律内容（例如适用法律领域的简要梳理）与商业上下文（例如交易或争议的周边事实）越充分，输出就越有用。有了这类上下文，结果的质量与基础提示相比可能有天壤之别。',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.title': '案情摘要示例',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.body':
    '使用案情摘要提示词时，请补充您所关心的法律争点的简要说明——例如判决理由（ratio decidendi）与附带意见（obiter dicta）之间的区分。从库中复制该提示词，按您的具体关注点加以修改，您会发现输出比直接套用原提示词更有针对性。',
  'pages.angelInsider.issues.feature-prompting.sections.2.kicker': '03 — 测试与改进',
  'pages.angelInsider.issues.feature-prompting.sections.2.heading': '先设基准，再作打磨',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.0.p':
    '拿您手头已有的“标准答案”来测试任何提示词——例如您撰写过的案情摘要，或先前起草的条款。运行提示词，把输出与您的基准作比较。若二者吻合，说明提示词已经成熟；若不吻合，请找出具体差距并相应补充上下文。',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.1.p':
    '使用提示词库中的 <strong>Improve My Prompt v1.0</strong> 工具，进一步优化任何表现不及预期的提示词。',
  'pages.angelInsider.issues.feature-prompting.signoff.line':
    '最了解自身上下文的人是您——请把它写进提示词。',
  'pages.angelInsider.issues.feature-prompting.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-prompting.altCta.label': '了解更多提示词库内容 &rarr;',
  'pages.angelInsider.issues.feature-guided-summary.title': '快速信息与引导式摘要',
  'pages.angelInsider.issues.feature-guided-summary.subtitle':
    '对任一单份文档作快速、可溯源的解读——概览式或定向式皆可。',
  'pages.angelInsider.issues.feature-guided-summary.glance.0':
    '使用<strong>快速信息</strong>即时获取任一文档的概览。',
  'pages.angelInsider.issues.feature-guided-summary.glance.1':
    '<strong>引导式摘要</strong>（位于应用模式下）让您掌控关注重点——请搭配库中的提示词使用。',
  'pages.angelInsider.issues.feature-guided-summary.glance.2':
    '上传文档，选择提示词，并补充您希望覆盖的具体要点。',
  'pages.angelInsider.issues.feature-guided-summary.glance.3':
    '现已提速——生成过程中提供<strong>中间进度更新与内联引注</strong>。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.kicker': '01 — 引导式摘要',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.heading':
    '在提示词引导下，为任一文档生成可溯源的摘要',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.0.p':
    '提示词库中包含两套用于总结文档的提示词——一套生成简明概览，另一套进行更深入的分析。它们改编自新加坡律师学院（SAL）公开发布的提示词，并借助生成式 AI 反复打磨。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.1.p':
    '根据我们的经验，<strong>详尽版</strong>摘要工具通常更胜一筹，在较复杂的文档上尤其如此。A&GEL 被要求<em>完全</em>依据原文作答——但在判例法中，它区分<em>判决理由（ratio decidendi）</em>与<em>附带意见（obiter dicta）</em>时可能会力有不逮。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.title':
    '并非万灵药',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.body':
    '输出仍须按常规方式复核与验证——对准确性与完整性作彻底检查。这些提示词为您提供的是高效的起点，而非可直接交付的成果。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.3.p':
    '使用<strong>引导式摘要</strong>功能（位于应用模式下），可针对单份文档运行任意提示词。上传文件，从库中选择提示词，并补充您特别关注的要点。',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.4.figure.caption':
    '提示词库中的案情摘要（简明版）v1.1 与案情摘要（详尽版）v1.1。',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.kicker': '02 — 速度与更新',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.heading':
    '生成更快，并提供中间进度更新',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.0.p':
    '引导式摘要现已在生成过程中提供<strong>带内联引注的中间进度更新</strong>——您可以看到各部分内容逐步生成，并在完整输出完成之前就开始核对引注。',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.1.p':
    '整体输出速度也有所提升。请注意：对于较简单的文档，摘要可能加载得足够快，从而完全跳过中间进度更新。',
  'pages.angelInsider.issues.feature-guided-summary.signoff.line':
    '要概览就用快速信息；想掌控重点就用引导式摘要。',
  'pages.angelInsider.issues.feature-guided-summary.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-vault.title': '您的保险库',
  'pages.angelInsider.issues.feature-vault.subtitle':
    '保险库是您在 A&GEL 上的“大脑”——把它经营好，AI 的输出也会随之更精准。',
  'pages.angelInsider.issues.feature-vault.glance.0':
    'A&GEL <strong>不会</strong>搜索互联网——它只在您的保险库范围内工作。',
  'pages.angelInsider.issues.feature-vault.glance.1':
    '<strong>上下文就是一切</strong>：精准而有选择地上传，才能得到精准可靠的输出。',
  'pages.angelInsider.issues.feature-vault.glance.2':
    '您的文件夹结构本身就是元数据——它会把 AI 引导到正确的视角。',
  'pages.angelInsider.issues.feature-vault.glance.3':
    '使用<strong>引用文件权重</strong>与<strong>会话文件权重</strong>，微调 A&GEL 的优先级。',
  'pages.angelInsider.issues.feature-vault.sections.0.kicker': '01 — 大脑',
  'pages.angelInsider.issues.feature-vault.sections.0.heading': '保险库是您在 A&GEL 上的“大脑”',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.0.p':
    '保险库的设计初衷，是作为 A&GEL 最主要的上下文来源，把 AI 基于概率生成的输出锚定在您可信、经过筛选的知识库之上。',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.1.p':
    '<strong>A&GEL 会上网搜索答案吗？</strong>不会。A&GEL 严格在您保险库的边界内运作，只依据您上传并整理过的文档。这是一项有意为之的设计选择，服务于三个目的：确保输出的准确性、维护安全性，以及保全您专有知识库的完整性。',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.2.p':
    'A&GEL 不会从网络上抓取未经核实的信息，而是严格以您的保险库作为唯一的事实来源。如果您的保险库整理得当，A&GEL 的各项功能就会立足于您认可的先例、您核实过的事实以及您赞同的策略。当 A&GEL 回答问题时，它并不是凭一般常识猜测——而是在综合提炼您那些具体而权威的资料中的洞见。',
  'pages.angelInsider.issues.feature-vault.sections.1.kicker': '02 — 上传',
  'pages.angelInsider.issues.feature-vault.sections.1.heading': '上传什么，以及怎么上传',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.0.p':
    '<strong>可以上传什么？</strong>任何 Word 文档、PDF 或电子邮件。其他文件格式正在开发中。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.1.p':
    '<strong>怎么上传？</strong>把单个文件或整个文件夹拖放到文件界面上，或点击上传按钮。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.2.figure.caption':
    '直接把文件或文件夹拖放到文件界面上。',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.title': '垃圾进，垃圾出',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.body':
    '请不要把 A&GEL 当作有求必应的神谕，而应把它看作一位不知疲倦的同事，他读过您上传的一切。如果您递给这位同事一张堆满无关文件的凌乱办公桌，他的工作多半会一头雾水；如果您只递给他一份切题的先例，他的工作就会变得犀利。这正是使用 A&GEL 的核心真理：<strong>上下文就是一切。</strong>',
  'pages.angelInsider.issues.feature-vault.sections.2.kicker': '03 — 结构',
  'pages.angelInsider.issues.feature-vault.sections.2.heading': '请建立一定的文件夹结构',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.0.p':
    '文件夹结构不只是为了整洁——它是引导 AI 的元数据。把文件整理进合乎逻辑的子文件夹，例如把“卖方”与“买方”的先例分开存放，能帮助 A&GEL 检索到正确的视角。',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.1.figure.caption':
    '深入子文件夹——把“被许可方”与“许可方”的先例分开，可保持上下文清晰。',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.2.p':
    '<strong>避免掉进“全部上传”的陷阱。</strong>把整个资料库一股脑倒进一个文件夹、让 AI 自己去理清，听上去很省事。请不要这么做。A&GEL 采用检索增强生成（RAG），也就是说它会从您上传的文件中提取答案。生成式 AI 并不“理解”事实——它预测的是概率。当您喂给它无关的噪音时，就会稀释有效信号。结果就是：输出的准确性、精确度与可靠性都会下降。请始终手动选择与您提示词相关的具体文档或文件夹。',
  'pages.angelInsider.issues.feature-vault.sections.3.kicker': '04 — 微调',
  'pages.angelInsider.issues.feature-vault.sections.3.heading': '微调信号',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.0.p':
    'A&GEL 为您提供了控制这一过程的旋钮。使用<strong>引用文件权重</strong>，可迫使 AI 优先考虑您所援引的特定文档；使用<strong>会话文件权重</strong>，则可提升仅为当次对话上传的文件的权重。',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.1.p':
    '最后请记住：A&GEL 是起点——是用来集思广益的伙伴，或用来打磨初步想法的协作空间，而不是终点线。请始终对照回复中所链接的来源文档核验输出。',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.title': '归根结底',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.body':
    '请把保险库当作一座精心编排的图书馆，而不是垃圾填埋场。清楚自己的文档存放在哪里，对上下文有所取舍，A&GEL 便会从一个聒噪的聊天机器人，转变为一位高精度的助理。',
  'pages.angelInsider.issues.feature-vault.signoff.line': '经营好您的保险库，掌控好您的上下文。',
  'pages.angelInsider.issues.feature-vault.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-vault.cta.label': '返回基础 →',
  'pages.angelInsider.issues.issue-3.title': '全新时间线与多步提示词应用',
  'pages.angelInsider.issues.issue-3.subtitle':
    '.msg 上传、更聪明的笔录、结构化的多步提示，以及大幅改版的时间线。',
  'pages.angelInsider.issues.issue-3.date': '2026 年 3 月 18 日',
  'pages.angelInsider.issues.issue-3.glance.0':
    '<strong>邮件文件（.msg）</strong>现已支持上传并完整读取——包括其中的附件。',
  'pages.angelInsider.issues.issue-3.glance.1':
    '<strong>笔录</strong>现已支持实时编辑、音频回放，以及每分钟自动保存。',
  'pages.angelInsider.issues.issue-3.glance.2':
    '全新<strong>多步提示词</strong>模式，可把复杂的法律工作流拆解为有针对性的步骤。',
  'pages.angelInsider.issues.issue-3.glance.3':
    '<strong>时间线</strong>全面改版，可合并多份文档中的时间脉络。',
  'pages.angelInsider.issues.issue-3.sections.0.kicker': '01 — 文件',
  'pages.angelInsider.issues.issue-3.sections.0.heading': '上传邮件文件（.msg）',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.0.p':
    'A&GEL 用户现在可以把完整的 <strong>.msg</strong> 邮件文件上传至文件中，供对话或任何专项模式使用。A&GEL 会读取全部内容——包括附件——但带有<em>仅限内部</em>敏感度标签或受密码保护的附件除外。',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.1.p':
    '上传后，您可以让 A&GEL 总结这封邮件、总结随附的文档，或针对它运行提示词库中的任意提示词。',
  'pages.angelInsider.issues.issue-3.sections.1.kicker': '02 — 笔录',
  'pages.angelInsider.issues.issue-3.sections.1.heading': '笔录：实时编辑与音频回放',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.0.p':
    '<strong>实时编辑</strong>——改进后的笔录允许您直接修改转写文本；被编辑的部分会加下划线，便于查阅。<strong>音频回放</strong>——转写内容保存后，打开原始转写稿并点击任一片段，即可从该处开始播放录音。',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.0.caption':
    '笔录正在录音，并同步进行实时转写。',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.1.caption':
    '原始转写稿——点击片段即可回放对应音频。',
  'pages.angelInsider.issues.issue-3.sections.2.kicker': '03 — 全新模式',
  'pages.angelInsider.issues.issue-3.sections.2.heading': '多步提示词',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.0.p':
    '位于<strong>专项应用</strong>下。单次提示词对简单问题很高效，但复杂的法律任务更适合采用结构化、迭代式的方法。多步提示词让您把一个问题拆解为一连串有针对性的交互——这是我们处理中等至高复杂度文档工作时最爱的模式。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.1.h': '把工作流拆解为合乎逻辑的阶段',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.n': '公司业务 · 第 1 步',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.text':
    '总结各方各自负有哪些义务。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.n': '第 2 步',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.text':
    '在上述总结的基础上，标出任何单方面有利或不寻常的条款。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.n': '第 3 步',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.text':
    '针对已标出的条款，若我代表[某方]，请以修订标记列出我应当争取的五项主要修改。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.n': '诉讼 · 第 1 步',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.text':
    '根据[所附]索赔陈述书，起草第一组质询书。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.n': '第 2 步',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.text':
    '在完成第 1 步的基础上，起草相应的文件出示请求。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.n': '第 3 步',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.text':
    '作为最后一步，找出最有可能持有相关文件的五位主要保管人，并说明理由。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.title': '只有一条提示词？照样用它',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.body':
    '即便只有一个步骤，这个应用也非常适合处理需要针对文档执行的复杂单条提示词——往往比对话模式效果更好。',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.5.figure.caption':
    '多步提示词的输出——点击引注会打开内嵌文档查看器并高亮相应内容。',
  'pages.angelInsider.issues.issue-3.sections.3.kicker': '04 — 时间线',
  'pages.angelInsider.issues.issue-3.sections.3.heading': '大幅改版的时间线',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.0.p':
    '<strong>跨文档合并时间线。</strong>更新后的时间线会从每份选定的文档中提取时间脉络，并将它们合并为一条——当您手上有多份篇幅浩大的誓章、诉状或陈词书、各自都带有自己的时间线时，这项功能尤为宝贵。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.0.caption':
    '跨五份文件合并而成的索赔陈述书与答辩状时间线。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.1.caption':
    '深入查看单份文档的时间线，并附带来源引注。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.2.p':
    '<strong>查看来源。</strong>点击任一事件末尾的引注，即可打开来源文档，并高亮显示出处所在的那一行。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.3.h': '智能时间线，贴合您的案件',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.4.p':
    '选定文档后，点击<strong>扩展提示词</strong>，即可让提取聚焦于您关注的主题。<em>Basic Litigation（共享）</em>配置会提取事件描述、来源文档、实体／个人以及佐证段落——您也可以自行添加字段。',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.title': '同样适用于聊天记录',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.body':
    '把时间线指向聊天记录或消息截图（WhatsApp、微信），即可构建时间脉络。',
  'pages.angelInsider.issues.issue-3.signoff.line': '步子迈得小些，时间脉络就更清晰。',
  'pages.angelInsider.issues.issue-3.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-dispute.title': '争议解决',
  'pages.angelInsider.issues.feature-dispute.subtitle':
    '案情摘要、索赔陈述书分析、答辩状起草与诉状追踪——全部在 A&GEL 内完成。',
  'pages.angelInsider.issues.feature-dispute.glance.0':
    '<strong>案情摘要</strong>——面对复杂判决时，详尽版通常优于简明版。',
  'pages.angelInsider.issues.feature-dispute.glance.1':
    '<strong>索赔陈述书分析</strong>——上传索赔陈述书并直接运行分析提示词。',
  'pages.angelInsider.issues.feature-dispute.glance.2':
    '<strong>答辩状起草</strong>——依据索赔陈述书生成答辩状初稿。',
  'pages.angelInsider.issues.feature-dispute.glance.3':
    '<strong>诉状追踪器</strong>——审阅模式可在完整文档集范围内，把每项诉因与各方立场逐一对应。',
  'pages.angelInsider.issues.feature-dispute.sections.0.kicker': '01 — 案情摘要',
  'pages.angelInsider.issues.feature-dispute.sections.0.heading': '总结判决与诉状',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.0.p':
    '提示词库中包含两套案情摘要提示词——简明版与详尽版。根据我们的经验，<strong>详尽版</strong>通常更胜一筹，面对复杂判决时尤其如此。A&GEL 被要求完全依据来源文档作答。',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.1.figure.caption':
    '提示词库中的案情摘要（简明版）v1.1 与案情摘要（详尽版）v1.1。',
  'pages.angelInsider.issues.feature-dispute.sections.1.kicker': '02 — 索赔陈述书与答辩状',
  'pages.angelInsider.issues.feature-dispute.sections.1.heading': '索赔陈述书分析与答辩状起草',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.0.p':
    '在案件初步评估阶段，可使用<strong>索赔陈述书分析与时间脉络</strong>提示词。上传索赔陈述书并运行该提示词——A&GEL 会提取关键事实、诉因以及一条时间脉络。',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.1.p':
    '若要起草首份答辩状，请使用库中的<strong>针对索赔陈述书起草答辩状</strong>提示词。复制后，按您案件的情况调整上下文。',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.title': '详尽版优于简明版',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.body':
    '面对复杂判决或篇幅冗长的索赔陈述书，详尽版摘要工具的输出在准确性与完整性上始终更胜一筹。',
  'pages.angelInsider.issues.feature-dispute.sections.2.kicker': '03 — 诉状追踪器',
  'pages.angelInsider.issues.feature-dispute.sections.2.heading': '把审阅模式当作诉状追踪器',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.0.p':
    '审阅模式可同时针对多份文档运行一份问题清单。在争议解决场景中，载入索赔陈述书、答辩状与答复状，逐一诉因设定问题，A&GEL 便会在一张表格中呈现各方的立场对照。',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.1.figure.caption':
    'Lim Group 案：审阅模式跨 5 份文件追踪欺诈与不当行为主张。',
  'pages.angelInsider.issues.feature-dispute.signoff.line': '案件评估更快，庭前准备更充分。',
  'pages.angelInsider.issues.feature-dispute.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-sidebyside.title': '并排对比与比较',
  'pages.angelInsider.issues.feature-sidebyside.subtitle':
    '颗粒度最细的审阅模式——逐条款进行，并可完整核验来源段落。',
  'pages.angelInsider.issues.feature-sidebyside.glance.0':
    '<strong>并排对比</strong>逐条款展开，每项发现都可完整核验来源段落。',
  'pages.angelInsider.issues.feature-sidebyside.glance.1':
    '<strong>比较</strong>可针对修订标记或文档修订生成初轮法律审阅意见。',
  'pages.angelInsider.issues.feature-sidebyside.glance.2':
    '每项发现都能回溯到确切的来源条款——无需在文档中反复查找。',
  'pages.angelInsider.issues.feature-sidebyside.glance.3':
    '<strong>迷你对话窗口</strong>现已可移动、可调整大小——把它拖到不碍事的位置即可。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.kicker': '01 — 并排对比',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.heading': '逐条款分析并可溯源核验',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.0.p':
    '并排对比是 A&GEL 颗粒度最细的审阅模式。它会逐条款梳理整份文档，并为每项发现呈现确切的来源段落——让您可以直接对照原文核验输出。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.1.figure.caption':
    '对一份股份买卖协议（SPA）的并排对比分析——每项发现都可回溯至来源条款。',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.2.figure.caption':
    '说明面板——A&GEL 的推理过程与来源并排内嵌显示。',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.kicker': '02 — 比较',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.heading': '对修订标记作初轮审阅',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.0.p':
    '<strong>比较</strong>可针对修订标记或文档修订生成初轮法律审阅意见。上传修订后的文档，A&GEL 便会就变更内容及其影响生成结构化分析。',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.title':
    '这是起点，而非成品',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.body':
    '并排对比与比较的输出是高效的起点——定稿前请务必对照原文核验。',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.kicker': '03 — 迷你对话',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.heading': '可移动的迷你对话界面',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.blocks.0.p':
    '审阅、比较与并排对比都配备了<strong>迷你对话窗口</strong>，让您可以同时就文档与 A&GEL 的输出提问。该窗口现已<strong>可移动、可调整大小</strong>——把它拖到屏幕任意位置，避免遮挡您正在审阅的内容。',
  'pages.angelInsider.issues.feature-sidebyside.signoff.line': '逐条款推进，来源可核验。',
  'pages.angelInsider.issues.feature-sidebyside.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-multistep.title': '多步提示词',
  'pages.angelInsider.issues.feature-multistep.subtitle':
    '把复杂的法律任务拆解为连续步骤——每一步都以上一步为基础。',
  'pages.angelInsider.issues.feature-multistep.glance.0': '位于<strong>专项应用</strong>下。',
  'pages.angelInsider.issues.feature-multistep.glance.1':
    '每一步都建立在上一步的输出之上——非常适合复杂的工作流。',
  'pages.angelInsider.issues.feature-multistep.glance.2':
    '既适用于多步骤工作流，<em>也</em>适用于针对单份文档的复杂单条提示词。',
  'pages.angelInsider.issues.feature-multistep.glance.3':
    '输出附带内联来源引注——点击即可打开来源并高亮显示。',
  'pages.angelInsider.issues.feature-multistep.sections.0.kicker': '01 — 入门',
  'pages.angelInsider.issues.feature-multistep.sections.0.heading': '面向复杂法律工作的结构化模式',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.0.p':
    '位于<strong>专项应用</strong>下。多步提示词让您把一个法律问题拆解为一连串有针对性的步骤——每一步都以上一步为基础。它既适合多步骤工作流，也适合那些需要文档级精度的复杂单条提示词。',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.1.figure.caption':
    '专项应用网格中的多步提示词。',
  'pages.angelInsider.issues.feature-multistep.sections.1.kicker': '02 — 示例',
  'pages.angelInsider.issues.feature-multistep.sections.1.heading': '把工作流拆解为合乎逻辑的阶段',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.n': '公司业务 · 第 1 步',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.text':
    '总结各方各自负有哪些义务。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.n': '第 2 步',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.text':
    '在上述总结的基础上，标出任何单方面有利或不寻常的条款。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.n': '第 3 步',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.text':
    '针对已标出的条款，若我代表[某方]，请以修订标记列出我应当争取的五项主要修改。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.n': '诉讼 · 第 1 步',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.text':
    '根据[所附]索赔陈述书，起草第一组质询书。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.n': '第 2 步',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.text':
    '在完成第 1 步的基础上，起草相应的文件出示请求。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.n': '第 3 步',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.text':
    '找出最有可能持有相关文件的五位主要保管人，并说明理由。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.title':
    '只有一条提示词？照样用它',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.body':
    '即便只有一个步骤，这个应用也非常适合针对文档执行的复杂提示词——往往比对话模式效果更好。',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.3.figure.caption':
    '多步提示词的输出——点击引注会打开内嵌文档查看器并高亮相应内容。',
  'pages.angelInsider.issues.feature-multistep.sections.2.kicker': '03 — 实操示例',
  'pages.angelInsider.issues.feature-multistep.sections.2.heading': '跨两份文档撰写报告',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.0.p':
    '这是一套三步工作流：从两份文档中提取关注点，再把它们合并成一份带执行摘要的报告——若想靠单条对话提示词稳定完成，难度过高。',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.title': '第 1 步——提取',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.body':
    '<strong>输入上下文：</strong>[插入文档 1 与文档 2 的正文]<br><strong>提示词：</strong>“阅读所提供的文本。提取一份全面的要点清单，列出两份文档中提及的所有关注点、问题或风险。”<br><em>输出：一份清晰、已整合的关注点清单。</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.title':
    '第 2 步——撰写完整报告',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.body':
    '<strong>输入上下文：</strong>[第 1 步的输出]<br><strong>提示词：</strong>“利用所提供的关注点清单，撰写一份详尽的正式报告。把相似的关注点归入相应的标题之下。此阶段不要包含引言或执行摘要。”<br><em>输出：一份完整且有结构的报告。</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.title':
    '第 3 步——执行摘要与最终整合',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.body':
    '<strong>输入上下文：</strong>[第 2 步的输出]<br><strong>提示词：</strong>“阅读所提供的报告。首先，撰写一段简明扼要的执行摘要。然后输出该执行摘要，加上一条视觉分隔线，并在其下方原样输出完整报告，以形成一份合并后的单一文档。”<br><em>输出：最终的合并文档。</em>',
  'pages.angelInsider.issues.feature-multistep.signoff.line': '步子迈得小些，输出就更精准。',
  'pages.angelInsider.issues.feature-multistep.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-timeline.title': '时间线',
  'pages.angelInsider.issues.feature-timeline.subtitle':
    '将最多 100 份文档中的时间脉络合并为一条经来源核验的时间线。',
  'pages.angelInsider.issues.feature-timeline.glance.0':
    '把<strong>最多 100 份文档</strong>中的时间脉络合并为一条时间线。',
  'pages.angelInsider.issues.feature-timeline.glance.1':
    '<strong>可点击的内联引注</strong>——点击任一引注即可打开来源并高亮相应段落。',
  'pages.angelInsider.issues.feature-timeline.glance.2':
    '<strong>智能时间线</strong>让您提取自定义字段：实体、佐证段落等等。',
  'pages.angelInsider.issues.feature-timeline.glance.3':
    '同样适用于聊天记录与消息截图（WhatsApp、微信）。',
  'pages.angelInsider.issues.feature-timeline.sections.0.kicker': '01 — 合并时间线',
  'pages.angelInsider.issues.feature-timeline.sections.0.heading': '跨多份文档的时间脉络',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.0.p':
    '更新后的时间线会从每份选定的文档中提取时间脉络，并将它们合并为一条——当您手上有多份篇幅浩大的誓章、诉状或陈词书、各自都带有自己的时间线时，这项功能尤为宝贵。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.0.caption':
    '跨五份文件合并而成的索赔陈述书与答辩状时间线。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.1.caption':
    '深入查看单个事件——来源文档、实体与佐证段落一并呈现。',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.2.p':
    '<strong>查看来源。</strong>点击任一事件末尾的内联引注，即可打开来源文档，并高亮显示出处所在的那一行。',
  'pages.angelInsider.issues.feature-timeline.sections.1.kicker': '02 — 智能时间线',
  'pages.angelInsider.issues.feature-timeline.sections.1.heading': '为您的案件提取自定义字段',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.0.p':
    '点击<strong>扩展提示词</strong>，即可让提取聚焦于您关注的主题。<em>Basic Litigation（共享）</em>配置会提取事件描述、来源文档、实体／个人以及佐证段落——您也可以自行添加字段。',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.1.figure.caption':
    '智能时间线：在扩展提示词下添加自定义提取字段。',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.title':
    '同样适用于聊天记录',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.body':
    '把时间线指向聊天记录或消息截图（WhatsApp、微信），即可构建时间脉络。',
  'pages.angelInsider.issues.feature-timeline.signoff.line': '一条时间线，涵盖每份文档。',
  'pages.angelInsider.issues.feature-timeline.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-using-files.title': '在 A&GEL 中使用您的文件',
  'pages.angelInsider.issues.feature-using-files.subtitle':
    'A&GEL 原生支持 Word 文档、PDF 与电子邮件（未来还将支持更多格式）。不过，某些文件可能因缺少文本层、敏感度标签设置有误或格式问题而无法上传，每种情况都有简单的解决办法。',
  'pages.angelInsider.issues.feature-using-files.intro':
    '您可能会遇到某些文件无法成功上传至 A&GEL 的情况。本指南梳理了最常见的原因——从没有文本层的扫描件，到文档敏感度标签——以及相应的解决方法。',
  'pages.angelInsider.issues.feature-using-files.glance.0':
    'A&GEL 读取的是 PDF 中的<strong>文本层</strong>——扫描的纸质文件往往没有文本层。',
  'pages.angelInsider.issues.feature-using-files.glance.1':
    '这在较旧的文件，以及未经 OCR 处理的扫描件中很常见。',
  'pages.angelInsider.issues.feature-using-files.glance.2':
    '解决办法：先把 PDF 转换为可搜索格式，再重新上传至 A&GEL。',
  'pages.angelInsider.issues.feature-using-files.glance.3':
    '需要一次性转换大批 PDF？A&GEL 开发团队可以协助。',
  'pages.angelInsider.issues.feature-using-files.glance.4':
    '内部文档必须先重新标记为<strong>外部</strong>再上传，否则 A&GEL 会拒收。',
  'pages.angelInsider.issues.feature-using-files.glance.5':
    '较旧的 Word 文档（1997–2004 年、OOXML 之前的 .doc）已获支持——无需转换。',
  'pages.angelInsider.issues.feature-using-files.sections.0.kicker': '01 — 缺少文本层',
  'pages.angelInsider.issues.feature-using-files.sections.0.heading': '扫描件相关的问题',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.0.p':
    'A&GEL 通过提取 PDF 中内嵌的文本层来读取文档。当文档没有文本层时（例如扫描的纸质件），A&GEL 只能看到页面的图像，因而无法处理。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.1.p':
    '大多数扫描件——尤其是用复印机数字化的文件——都会保存为纯图像 PDF。这在较旧的文件，以及以图像形式扫描（且未做 OCR）的文档中很常见。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.2.p':
    '上传之前，请先用支持 OCR（光学字符识别）的 PDF 阅读器打开文件——例如 Kofax——以确保能够顺利处理。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.n': '第 1 步',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.text':
    '用具备 OCR 能力的 PDF 阅读器（例如 Kofax）打开您的扫描版 PDF。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.n': '第 2 步',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.text':
    '运行 OCR，使文件可被搜索——在 Kofax 中，对应的是<strong>“Make Searchable”</strong>或<strong>“Searchable PDF”</strong>功能。如果需要转换多个文件，请查找批量或多文件 OCR 选项（在 Kofax 中位于 Advanced Processing 下），而不要逐个转换。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.n': '第 3 步',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.text':
    '保存转换后的文件，然后上传至 A&GEL。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.4.p':
    '转换完成后，文件便会包含可搜索的文本层，A&GEL 即可照常处理。此外，您也可以在扫描时就直接生成可搜索的 PDF，而无需事后转换——许多打印机和扫描仪都能在扫描过程中直接输出可搜索 PDF。请在您自己的设备上查找对应的“Searchable PDF”或 OCR 选项，各型号的菜单名称与操作步骤可能有所不同。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.5.figure.caption':
    '示例：在这台扫描仪的“扫描并发送”界面中，把文件格式选为 PDF 并启用 OCR（优先速度或优先精度），即可生成带文本层的可搜索 PDF。',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.6.p':
    '需要一次性对大批 PDF 做 OCR？请联系 A&GEL 开发团队——他们可以协助您完成批量转换。',
  'pages.angelInsider.issues.feature-using-files.sections.1.kicker': '02 — 敏感度标签',
  'pages.angelInsider.issues.feature-using-files.sections.1.heading': '敏感度标签相关的问题',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.0.p':
    '每份文档都带有敏感度标签，该标签在 Word 或 Outlook 中保存时设定，A&GEL 会在接受上传前检查它。',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.1.p':
    'A&GEL 会拒收带有“内部”敏感度标签的文件——请先把文档重新标记为“外部”并保存，然后再上传。',
  'pages.angelInsider.issues.feature-using-files.sections.2.kicker': '03 — 较旧的 Word 文件',
  'pages.angelInsider.issues.feature-using-files.sections.2.heading': '支持较旧的 Word 文档',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.0.p':
    '较旧的 Word 文档同样受支持。以下格式在上传前都无需转换或另存：',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.left.label': 'PDF',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.topMiddle.label':
    'MS Word 当前版本（.docx）',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.bottomMiddle.label':
    'MS Word 1997–2004（.doc）',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.right.label':
    '电子邮件（.msg）',
  'pages.angelInsider.issues.feature-using-files.signoff.line':
    '用 Kofax 或打印机的 OCR 设置把扫描件转为可搜索格式，上传前把内部文档另存为“外部”，另请注意：较旧与当前的 Word 格式均无需转换即可使用。',
  'pages.angelInsider.issues.feature-using-files.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-work-studio.title': 'Workstudio',
  'pages.angelInsider.issues.feature-work-studio.subtitle':
    '把团队的标准立场固化为一套标准化审阅流程——输出带修订标记的 Word 文档。',
  'pages.angelInsider.issues.feature-work-studio.glance.0':
    '把团队的谈判立场一次性录入 Workstudio——之后每份合同都能复用。',
  'pages.angelInsider.issues.feature-work-studio.glance.1':
    'A&GEL 会套用该 Workstudio，并返回一份<strong>带修订标记的 Word 文档</strong>。',
  'pages.angelInsider.issues.feature-work-studio.glance.2':
    '以已接受／已拒绝／待定三种状态审阅各处修改。',
  'pages.angelInsider.issues.feature-work-studio.glance.3':
    '关于如何构建与使用 Workstudio 的更多细节，将在下一期 A&GEL Insider 中呈现。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.kicker': '01 — Workstudio',
  'pages.angelInsider.issues.feature-work-studio.sections.0.heading': '让您的标准立场自动落地',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.0.p':
    'Workstudio 让您把团队的谈判立场与标准立场固化为一套可复用的审阅模板。建好之后，上传任何合同，A&GEL 都会套用该 Workstudio——返回一份以修订标记形式提出修改建议的 Word 文档，可直接进入审阅与修改环节。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.1.figure.caption':
    'Workstudio 实战——以已接受／已拒绝／待定状态审阅各处修改与批注。',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.title':
    '完整的 Workstudio 指南即将推出',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.body':
    '下一期 A&GEL Insider 将介绍如何从零构建 Workstudio，以及如何把它用在团队的实际事项中。',
  'pages.angelInsider.issues.feature-work-studio.signoff.line': '您的立场，自动落到实处。',
  'pages.angelInsider.issues.feature-work-studio.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-deepresearch.title': '深度研究',
  'pages.angelInsider.issues.feature-deepresearch.subtitle':
    '在结构化研究提示词的引导下开展跨文档分析——每项发现都可回溯至其来源段落。',
  'pages.angelInsider.issues.feature-deepresearch.glance.0':
    '针对您选定的整套文档运行结构化研究提示词。',
  'pages.angelInsider.issues.feature-deepresearch.glance.1':
    '每项发现都附带<strong>可点击的内联引注</strong>——打开来源并高亮相应段落。',
  'pages.angelInsider.issues.feature-deepresearch.glance.2': '位于<strong>专项应用</strong>下。',
  'pages.angelInsider.issues.feature-deepresearch.glance.3':
    '与精心整理的一手资料保险库搭配使用，可获得最高精度。',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.kicker': '01 — 功能简介',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.heading':
    '在结构化提示词引导下的跨文档分析',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.0.p':
    '深度研究会针对您选定的文档运行一条结构化研究提示词，并返回详尽且可溯源的分析。它专为需要跨多份文档综合信息的任务而设计——例如判例法分析、市场调研、法规梳理——而不是用来盘问单份文件。',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.1.figure.caption':
    '深度研究的输出——每项发现都通过可点击的内联引注回溯至其来源文档。',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.kicker': '02 — 内联引注',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.heading': '对照来源核验每项发现',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.0.p':
    '深度研究输出中的每项发现都附带<strong>带编号的内联引注</strong>。点击任一引注，即可打开来源文档并高亮显示出处段落——全程无需离开当前页面。',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.title':
    '有选择地设定上下文',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.body':
    '请把上下文限定为与您研究问题最相关的文档。范围过宽会稀释有效信号——深度研究在经过筛选、目标明确的上传内容上表现最佳。',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.kicker': '03 — 何时使用',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.heading': '最适合综合归纳类任务',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.blocks.0.p':
    '当您需要跨多个来源进行综合归纳时，就该用深度研究——例如比对多份誓章中的立场、就某一具体争点梳理判例法，或跨法域整理监管要求。若只针对单份文档，则可考虑改用引导式摘要或范围摘要。',
  'pages.angelInsider.issues.feature-deepresearch.signoff.line': '每项发现，来源可核验。',
  'pages.angelInsider.issues.feature-deepresearch.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-scopesummary.title': '范围摘要',
  'pages.angelInsider.issues.feature-scopesummary.subtitle':
    '围绕您设定的关注领域生成结构化摘要——每个提取要点都附带可点击的内联引注。',
  'pages.angelInsider.issues.feature-scopesummary.glance.0':
    '生成聚焦于您所设定范围的摘要——而非整份文档的通篇摘要。',
  'pages.angelInsider.issues.feature-scopesummary.glance.1':
    '每个提取要点都附带<strong>可点击的内联引注</strong>，便于对照来源核验。',
  'pages.angelInsider.issues.feature-scopesummary.glance.2': '位于<strong>专项应用</strong>下。',
  'pages.angelInsider.issues.feature-scopesummary.glance.3':
    '范围界定得越收敛，提取结果就越有针对性、越可付诸行动。',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.kicker': '01 — 功能简介',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.heading': '在设定范围内的聚焦式提取',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.0.p':
    '范围摘要让您界定希望 A&GEL 聚焦的领域——义务、风险分配、终止权、知识产权条款——并生成仅限于这些范围的结构化摘要。相较于整份文档的通篇摘要，输出更有针对性，也与您的审阅优先级直接对应。',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.title':
    '把范围界定清楚',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.body':
    '范围越收敛，输出就越精准。范围过宽时，输出会与整份文档摘要相差无几。目标明确的范围——例如“数据保护与安全义务”——则能产出简明且可付诸行动的提取结果。',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.kicker': '02 — 内联引注',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.heading': '每个要点，来源可核验',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.blocks.0.p':
    '范围摘要中的每个提取要点都附带<strong>可点击的内联引注</strong>——点击即可打开来源文档，并高亮显示出处所在的条款或段落。无需切换标签页；全部核验都在同一页面完成。',
  'pages.angelInsider.issues.feature-scopesummary.signoff.line': '限定范围，标明来源，可供核验。',
  'pages.angelInsider.issues.feature-scopesummary.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-review.title': '审阅',
  'pages.angelInsider.issues.feature-review.subtitle':
    '一次性针对多份文档提出多个问题——结果以表格形式呈现，并附带内联引注。',
  'pages.angelInsider.issues.feature-review.glance.0':
    '<strong>同时针对多份文档运行一份问题清单</strong>——结果汇总于一张表格。',
  'pages.angelInsider.issues.feature-review.glance.1':
    '点击任一单元格即可展开<strong>说明面板</strong>，其中附有指向来源条款的内联引注。',
  'pages.angelInsider.issues.feature-review.glance.2':
    '使用<strong>迷你对话</strong>，无需离开审阅页面即可继续追问。',
  'pages.angelInsider.issues.feature-review.glance.3': '位于<strong>专项应用</strong>下。',
  'pages.angelInsider.issues.feature-review.sections.0.kicker': '01 — 功能简介',
  'pages.angelInsider.issues.feature-review.sections.0.heading':
    '在一张表格中完成多文档、多问题审阅',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.0.p':
    '审阅会同时针对多份文档运行一份问题清单，并把结果汇总成表格——每个问题一行，每份文档一列。这种呈现方式非常适合合同比对、跨文档集的尽职调查，或梳理各方在诉状中的立场。',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.1.figure.caption':
    'AI SaaS 基准审阅——在一张表格中对照既定问题集审阅 20 份文件。',
  'pages.angelInsider.issues.feature-review.sections.1.kicker': '02 — 说明面板',
  'pages.angelInsider.issues.feature-review.sections.1.heading': '每项发现都有可溯源的说明',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.0.p':
    '点击任一单元格即可展开<strong>说明面板</strong>。每项发现都会被拆解，并附有结构化的内联引注——点击任一引注即可直接打开来源条款。',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.1.figure.caption':
    '审阅中的说明面板——每项发现都链接至其来源条款。',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.title':
    '问题清单编一次，反复复用',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.body':
    '一份结构良好的问题清单，会成为该类文档的可复用模板。保存下来，下次面对同类合同时直接套用即可。',
  'pages.angelInsider.issues.feature-review.sections.2.kicker': '03 — 迷你对话',
  'pages.angelInsider.issues.feature-review.sections.2.heading': '无需离开页面即可追问',
  'pages.angelInsider.issues.feature-review.sections.2.blocks.0.p':
    '<strong>迷你对话窗口</strong>让您可以同时就文档与审阅结果提出后续问题——无需跳转页面。该窗口可移动、可调整大小，因此不会挡住您的工作区域。',
  'pages.angelInsider.issues.feature-review.signoff.line': '每份文档，每个问题，汇于一表。',
  'pages.angelInsider.issues.feature-review.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-msg.title': '.msg 邮件上传',
  'pages.angelInsider.issues.feature-msg.subtitle':
    '把完整的邮件文件——连同附件——上传至 A&GEL，像处理其他文档一样使用它们。',
  'pages.angelInsider.issues.feature-msg.glance.0':
    '直接把 <strong>.msg</strong> 邮件文件上传至文件中。',
  'pages.angelInsider.issues.feature-msg.glance.1': 'A&GEL 会读取全部内容——包括附件。',
  'pages.angelInsider.issues.feature-msg.glance.2':
    '可与对话或任何专项模式（引导式摘要、时间线等）搭配使用。',
  'pages.angelInsider.issues.feature-msg.glance.3':
    '例外：带有<em>仅限内部</em>标签或受密码保护的附件会被跳过。',
  'pages.angelInsider.issues.feature-msg.sections.0.kicker': '.msg 上传',
  'pages.angelInsider.issues.feature-msg.sections.0.heading': '上传邮件文件（.msg）',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.0.p':
    'A&GEL 用户现在可以把完整的 <strong>.msg</strong> 邮件文件上传至文件中，供对话或任何专项模式使用。A&GEL 会读取全部内容——包括附件——但带有<em>仅限内部</em>敏感度标签或受密码保护的附件除外。',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.1.p':
    '上传后，您可以让 A&GEL 总结这封邮件、总结随附的文档，或针对它运行提示词库中的任意提示词。',
  'pages.angelInsider.issues.feature-msg.signoff.line': '邮件连同附件，一并读取。',
  'pages.angelInsider.issues.feature-msg.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-inline-ref.title': '内联引注',
  'pages.angelInsider.issues.feature-inline-ref.subtitle':
    '深度研究、时间线、范围摘要与审阅中均支持可点击的定位引注——无需离开当前页面即可对照来源核验每一项输出。',
  'pages.angelInsider.issues.feature-inline-ref.glance.0':
    '深度研究、时间线与范围摘要的输出现已附带<strong>可点击的内联引注</strong>。',
  'pages.angelInsider.issues.feature-inline-ref.glance.1':
    '点击任一引注，即可打开来源文档并高亮显示对应的确切段落。',
  'pages.angelInsider.issues.feature-inline-ref.glance.2':
    '审阅的<strong>说明面板</strong>同样为每项 AI 生成的发现提供结构化内联引注。',
  'pages.angelInsider.issues.feature-inline-ref.glance.3':
    '无需切换标签页——所有核验都在同一页面完成。',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.kicker': '内联引注',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.heading': '对照来源核验每一项输出',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.0.p':
    'A&GEL 所有主要的输出类应用——<strong>深度研究、时间线、范围摘要</strong>——现已支持可点击的内联引注。每条引注都带编号并附有链接：点击即可打开来源文档，并高亮显示对应的确切段落。',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.1.p':
    '这样一来，就不必为核验某个具体要点而切换标签页或手动翻查来源文档。交叉比对可在同一页面内完成。',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.kicker': '审阅中的内联引注',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.heading': '说明面板中的结构化引注',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.0.p':
    '审阅页面的<strong>说明</strong>部分——点击任一单元格即可展开——现已支持结构化内联引注。每个说明要点都链接至其来源条款或段落，让您能够轻松地把 AI 生成的发现与事实依据加以核对。',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.1.figure.caption':
    '审阅中的说明面板，附有链接到来源文档的结构化内联引注。',
  'pages.angelInsider.issues.feature-inline-ref.signoff.line': '每一项输出，来源可核验。',
  'pages.angelInsider.issues.feature-inline-ref.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.issue-5.title': '内联引注、迷你对话及更多更新',
  'pages.angelInsider.issues.issue-5.subtitle':
    '各应用全面支持定位引注、可移动的迷你对话、笔录时间戳，以及一系列体验优化。',
  'pages.angelInsider.issues.issue-5.date': '2026 年 4 月 10 日',
  'pages.angelInsider.issues.issue-5.glance.0':
    '深度研究、时间线、范围摘要与审阅现已支持<strong>可点击的内联引注</strong>。',
  'pages.angelInsider.issues.issue-5.glance.1':
    '审阅、比较与并排对比中的迷你对话窗口现已<strong>可移动、可调整大小</strong>。',
  'pages.angelInsider.issues.issue-5.glance.2':
    '笔录转写稿现已在下载的 Word 文档中包含<strong>时间戳</strong>。',
  'pages.angelInsider.issues.issue-5.glance.3':
    '除停止按钮外，现在还可<strong>通过历史记录标签页终止会话</strong>。',
  'pages.angelInsider.issues.issue-5.glance.4': '搜索改进：关键词匹配更准确，并支持文档内搜索。',
  'pages.angelInsider.issues.issue-5.sections.0.kicker': '01 — 内联引注',
  'pages.angelInsider.issues.issue-5.sections.0.heading': '各应用全面支持定位引注',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.0.p':
    '深度研究、时间线与范围摘要现已支持<strong>可点击的内联引注</strong>。有了这些引注，您可以即时把输出与来源文档交叉核对——点击任一引注即可打开来源并高亮显示相关段落，全程无需离开当前页面。',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.1.p':
    '审阅页面展开后的<strong>说明</strong>区块同样新增了链接至来源文档的结构化内联引注，让您更容易把 AI 生成的分析与事实依据加以核对。',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.2.figure.caption':
    '审阅中的说明面板——链接至来源文档的结构化内联引注。',
  'pages.angelInsider.issues.issue-5.sections.1.kicker': '02 — 迷你对话',
  'pages.angelInsider.issues.issue-5.sections.1.heading': '可移动的迷你对话界面',
  'pages.angelInsider.issues.issue-5.sections.1.blocks.0.p':
    '<strong>审阅、比较与并排对比</strong>中的迷你对话窗口现已可移动、可调整大小。在梳理输出内容时，把它拖到一旁即可——它不会再遮挡您的主要工作区域。',
  'pages.angelInsider.issues.issue-5.sections.2.kicker': '03 — 笔录',
  'pages.angelInsider.issues.issue-5.sections.2.heading': '下载的转写稿附带时间戳',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.0.p':
    '下载的笔录转写稿（Word 文档）现已包含<strong>时间戳</strong>——这些标记让您可以直接从文档跳转到录音中的特定时刻。',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.1.figure.caption':
    '下载的笔录转写稿，时间戳与译文并列显示。',
  'pages.angelInsider.issues.issue-5.sections.3.kicker': '04 — 其他更新',
  'pages.angelInsider.issues.issue-5.sections.3.heading': '体验优化',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.0.h': '更便捷地终止会话',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.1.p':
    '除了现有的停止按钮外，进行中的会话现在还可以通过<strong>在历史记录标签页中删除它们</strong>来终止——当您需要修改提示词后重新运行，或会话无响应时，这一点尤其有用。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.2.h': '搜索增强',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.3.p':
    '搜索现已受益于<strong>内联引注</strong>、更准确的关键词匹配以及文档内搜索——让您更容易在保险库中定位特定内容。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.4.h': '更快的引导式摘要',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.5.p':
    '引导式摘要现已在生成过程中提供<strong>带内联引注的中间进度更新</strong>，整体输出速度也有所提升。对于较简单的文档，摘要可能加载得足够快，从而跳过中间进度更新。',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.6.h': '优化后的文件界面',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.7.p':
    '文件页面的分页机制已改进——您可以一眼看到更多文件与文件夹，页面会随屏幕动态填充。',
  'pages.angelInsider.issues.issue-5.signoff.line': '核验更快，工作区更清爽。',
  'pages.angelInsider.issues.issue-5.signoff.name': 'A&GEL 开发团队',
  'pages.angelInsider.issues.feature-faq.title': '常见问题',
  'pages.angelInsider.issues.feature-faq.subtitle':
    'A&GEL 入门指南——从文件管理、提示词撰写，到核查输出结果。',
  'pages.angelInsider.issues.feature-faq.date': '2026 年 2 月 10 日',
  'pages.angelInsider.issues.feature-faq.glance.0': 'A&GEL 如何支持——而非取代——您的专业能力。',
  'pages.angelInsider.issues.feature-faq.glance.1': '文件管理最佳实践：该上传什么，以及如何整理。',
  'pages.angelInsider.issues.feature-faq.glance.2':
    '如何运用「角色—任务—上下文—格式」框架撰写有效的提示词。',
  'pages.angelInsider.issues.feature-faq.glance.3': '如何核查 A&GEL 输出的准确性与可靠性。',
  'pages.angelInsider.issues.feature-faq.glance.4': 'A&GEL 中所用技术术语的术语表。',
  'pages.angelInsider.issues.feature-faq.sections.0.kicker': '1 — 总体原则',
  'pages.angelInsider.issues.feature-faq.sections.0.heading': '始终让专业人士做专业的事',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.0.h':
    '问：A&GEL 设计理念的一部分是我们应当“始终让专业人士做专业的事”。这是什么意思？',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.1.p':
    '“始终让专业人士做专业的事”指的是：作为所在领域的专业人士／专家，您的判断、洞察与操守应始终是工作的核心。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.2.p':
    'A&GEL 不会取代这份专业能力，也不会充当领域专家。相反，它旨在帮助您这样的知识工作者／律师，以更多资源完成更多工作。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.3.h':
    '问：如果我对向 A&GEL 提问的主题完全不熟悉，那我是不是就不该使用 A&GEL？',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.4.p':
    '如果您的专业功力仍在积累之中——这并不意味着您应当回避使用 A&GEL，而是意味着要更留心自己使用 A&GEL 的方式。您应格外谨慎，并对 A&GEL 的输出进行更多核查。',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.5.p':
    '此外，不妨把 A&GEL 当作通往团队或公司既有专业知识的入口与向导。以这种方式获取既有专业知识、随时汲取其中的洞见与教益，A&GEL 便会成为支持您培训与成长的有力工具。',
  'pages.angelInsider.issues.feature-faq.sections.1.kicker': '2 — 文件管理',
  'pages.angelInsider.issues.feature-faq.sections.1.heading': '该上传什么，以及如何整理',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.0.h':
    '问：我应该向 A&GEL 上传哪类参考资料？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.1.p':
    '一般原则是：仅上传可信、可靠且准确的资料。例如一手法律渊源（法规、判例等），以及可信的内部资料（公司专业知识，或您自己经过反复检验的文档）。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.2.p':
    '由于 A&GEL 的输出高度依赖您所指定的文档／文件夹，请务必挑选并上传正确的文件，并为这些可信文档建立清晰的命名规范。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.title': 'Word 文档设置',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.body':
    '上传至 A&GEL 之前，Word 文档的安全设置必须设为“外部”（或其等效选项）。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.4.h':
    '问：第三方文档呢？我可以把它们上传至 A&GEL 吗？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.5.p':
    '当然可以！我们鼓励您使用 A&GEL 分析、盘查或审阅第三方文档——事实上，这正是 A&GEL 多种专项模式（例如审阅）的核心强项之一。这也包括来自对方律师／交易对手的文档。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.6.p':
    '只需注意把它上传到能清楚标明其为第三方文档的文件夹，这样您从文件路径就能分辨出：这究竟是可信的范本，还是您正在处理的“外来”文档。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.7.p':
    '同时也请留意与您使用 A&GEL 相关的公司政策（例如涵盖生成式 AI 使用的政策）与可接受使用政策，其中包括在必要时须取得适当授权方可使用第三方内容。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.8.h':
    '问：为什么 A&GEL“处理”我上传到文件标签页或对话中的文件需要较长时间？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.9.p':
    '文档必须先转换为 A&GEL 能够处理的形式（这种形式称为“向量嵌入”），因此上传时可能需要一些时间——但这只在文件上传至保险库中的“文件”时进行一次。上传至文件标签页的文档，可在新会话中通过在对话或任一专项模式中把该文件选为上下文来重复使用。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.10.p':
    '在对话中，一旦您上传了某份文档，就可以点击“上下文”按钮，再点击“使用文档新建对话”按钮，在全新的对话会话中再次与同一份文档交流。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.11.h':
    '问：我该如何把文档批量上传到文件标签页？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.12.p':
    '在文件模式下，点击屏幕右上角的上传按钮。选择您想上传的文件（数量不限），然后按“打开”。在参考资料上传期间，您可以继续使用 A&GEL 的其他功能。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.13.h':
    '问：我该如何整理和管理上传至 A&GEL 的参考资料？为什么不能干脆把所有内容都上传到一个文件夹？',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.14.p':
    '<strong>为什么文件管理很重要？</strong>妥善的文件管理，是确保您能够有效做到以下两点的关键：(a) 为 A&GEL 挑选相关参考资料，使其回应有据可依；以及 (b) 查看 A&GEL 究竟使用了哪些参考资料，以确保所生成输出的准确性与可靠性。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.15.p':
    '<strong>我该如何管理已上传的参考资料？</strong>向 A&GEL 上传参考资料时，我们强烈建议您不要把所有内容都放进同一个文件夹，而应按以下两个维度对文档加以整理和归组：(i) 主题；以及 (ii) 工作流。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.16.p':
    '具体做法是：在文件标签页中，上传文档之前，点击右上角的“新建文件夹”按钮创建一个新文件夹，并以主题命名。然后在该新建文件夹内再创建子文件夹，以所上传文档的工作流命名。',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.17.p':
    '这样，当您上传文档时，就会形成一条同时体现主题与工作流的合理文件路径。例如：<code>Home / IP Licensing Agreements / Licensor</code>',
  'pages.angelInsider.issues.feature-faq.sections.2.kicker': '3 — 向 A&GEL 提示',
  'pages.angelInsider.issues.feature-faq.sections.2.heading': '撰写有效的提示词',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.0.h': '问：我可以使用哪些类型的提示词？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.1.p':
    '您可以用多种方式向 A&GEL 提示。以下列出若干类型的提示词供您参考（其中一些您可能未曾想到）：',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.2.h': '信息查询与检索',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.0':
    '<strong>提问式提示词：</strong>直接提问，以获取事实信息、解释或澄清。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.1':
    '<strong>解释式提示词：</strong>要求对概念、流程或现象作详细解释。这类提示词常用“解释”“描述”“拆解”等措辞。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.2':
    '<strong>研究式提示词：</strong>较为复杂的信息搜集需求，可能需要综合多个来源的信息。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.4.h': '任务导向与指令式',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.0':
    '<strong>指令式提示词：</strong>清晰、直接的命令，使用“撰写”“创建”“分析”“总结”等动作动词。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.1':
    '<strong>多步骤任务提示词：</strong>把较大的任务拆解为连续步骤的复杂指令。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.2':
    '<strong>模板式提示词：</strong>为 AI 提供特定格式或框架以供遵循的结构化提示词。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.6.h': '分析与问题解决',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.0':
    '<strong>数据分析式提示词：</strong>用于分析数据集、识别模式或提炼洞见的指令。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.1':
    '<strong>问题解决式提示词：</strong>提出某项挑战，并要求 AI 给出解决方案、策略或建议。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.2':
    '<strong>比较分析式提示词：</strong>要求比较不同选项、评估备选方案，或权衡利弊。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.8.h': '分类与归整',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.0':
    '<strong>分类式提示词：</strong>要求把文本、数据或信息归入预设的类别或标签。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.1':
    '<strong>排序与排名式提示词：</strong>要求按特定标准（如重要性、优先级或偏好）组织信息。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.2':
    '<strong>打标签式提示词：</strong>要求为内容分配标签、标记或元数据，以便归整或检索。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.10.h': '转换与格式化',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.0':
    '<strong>翻译式提示词：</strong>要求把文本从一种语言转换为另一种语言，或使内容适配不同的文化语境。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.1':
    '<strong>格式转换式提示词：</strong>要求改变信息的结构或呈现方式，例如把散文改写为要点清单。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.2':
    '<strong>文风转换式提示词：</strong>要求以不同语气、文风或面向不同受众重写内容。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.12.h': '其他类型的提示词',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.0': '角色扮演与人设类提示词',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.1': '对话与互动类提示词',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.2': '系统与行为设定类提示词',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.3': '推理与逻辑类提示词',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.4': '代码与技术类提示词',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.5': '教学与培训类提示词',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.14.h': '问：我该如何撰写有效的提示词？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.15.p':
    '一般来说，最有效的提示词由四个部分组成：<strong>(a) 角色；(b) 任务；(c) 上下文；以及 (d) 格式。</strong>',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.16.h': '(a) 角色',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.17.p':
    '角色指的是您在撰写 AI 提示词时，对自身身份的说明，或希望 A&GEL 扮演的身份。这有助于把 A&GEL 引向特定的文风与语气。加入角色设定，会让您得到更契合自身需求的回应。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.label': '示例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.text':
    '你是一位拥有 30 年经验的资深律师。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.19.h': '(b) 任务',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.20.p':
    '这是您给模型下达的指令。任务指令越具体，得到的结果越好。不过，在给 AI 分派任务时，清晰与简洁同样重要。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.label': '示例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.text':
    '请用不超过 100 字总结这份文档。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.22.h': '(c) 上下文',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.23.p':
    '您喂给 A&GEL 的上下文（即信息）能带来天壤之别。上下文是让 A&GEL 提示词产出有针对性结果的最佳途径。这类上下文也可以以专家“知识”的形式给出，即您希望 A&GEL 在生成输出时特别纳入考量的内容。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.label': '示例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.text':
    '本摘要是给客户看的，客户是本次交易中的买方。请在摘要中从买方视角列出交易的相关细节。\n\n知识：转让、更替或让与条款并不属于控制权、所有权或权益变更的条款或规定。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.25.h': '(d) 格式',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.26.p':
    '这是指输出的呈现形式。可选项包括清单、表格以及 Markdown 格式。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.label': '示例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.text':
    '请以表格形式呈现该摘要。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.title': '从提示词库入手',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.body':
    '撰写有效提示词的一种方式，是拿一条已被证明有效的现成提示词，再按您的目的加以调整。前往提示词库标签页，“复制”相关提示词，并针对您的具体事项加以修改。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.29.h':
    '完整示例——角色 + 任务 + 上下文 + 格式',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.label': '完整提示词示例',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.text':
    '你是一位经验丰富的律师。请为这份文档生成一份简明摘要（每部分不超过 100 字）。要求：重点指出 (1) 文中涵盖的关键益处与正面之处，并另起一个要点，至少给出一个所引用事实作为例证；以及 (b) 文中涵盖的主要风险与不利之处，并另起一个要点，至少给出一个所引用事实作为例证。请确保摘要连贯清晰。若发现不止一个例证或支持论据，请依文中所述指出哪一个最好或最差。请使用正式语言并保持中立语气，避免加入个人观点或解读。所有输出均以 markdown 格式呈现，每个要点使用项目符号，特别重要的结论使用粗体。你的工作必须精确、准确且专业，因为它将由资深法律专业人士审阅，并用于高风险的金融交易之中。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.31.h':
    '问：什么是 RAG？A&GEL 何时会使用它？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.32.p':
    '默认情况下，A&GEL 的对话功能采用检索增强生成（RAG）。它会从您上传至文件标签页的参考资料中提取信息，再连同您向 A&GEL 提出的提示词一并传递给生成组件（即大语言模型）。随后，A&GEL 会基于其掌握的数据——以及来自 RAG 的附加上下文——生成输出。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.33.p':
    'RAG 与大语言模型技术的结合，为 A&GEL 提供了上下文与相关信息，使其能够产出“经增强的回应”，从而提升输出的精确度，进而提高答案可靠的概率。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.34.h':
    '问：为什么我不该干脆让 A&GEL 在所有提示中都考虑我上传的全部资料？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.35.p':
    '我们强烈建议您不要让 A&GEL 去考虑与您提示词无关的已上传资料。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.36.p':
    'A&GEL 这类生成式 AI 工具并不理解词语、条款、协议等的含义。它们依靠概率方法运作，而非真正的理解。在对话模式下，若把所有文件都选为上下文，A&GEL 就会从您保险库中上传的全部文档里提取参考内容。然而，与您提示词真正相关的上下文资料，可能仅限于某一特定主题，甚至某一特定工作流。向 A&GEL 提供与您目的无关的额外上下文，很可能会降低其输出的速度、准确性、精确度与可靠性。',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.37.h':
    '问：我该如何为每条提示词挑选相关的参考资料？',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.38.p':
    '在对话模式下，若要限制 A&GEL 仅以严格相关的参考资料作为提示词的上下文，请进入“上下文”，点击选择图标，并仅勾选相关的文档／文件夹。',
  'pages.angelInsider.issues.feature-faq.sections.3.kicker': '4 — 使用输出结果',
  'pages.angelInsider.issues.feature-faq.sections.3.heading': '核查准确性与可靠性',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.0.h':
    '问：我已经向 A&GEL 提示并拿到了输出。可以直接使用吗？',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.1.p':
    '一般来说，在把 A&GEL 的输出用于您的工作成果之前，应当始终加以核查。建议您仅把 A&GEL 的输出当作起点或参考，并始终与可信／可靠的知识来源（例如您上传的参考资料或经过验证的法律材料）交叉核对。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.2.h':
    '问：我应该如何核查输出的准确性与可靠性？',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.3.p':
    '在对话模式下，A&GEL 的输出已经过优化，只要有可用来源便会附上引用。这些引用是指向可信信息（例如您上传至文件标签页的资料）的链接。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.4.p':
    '<strong>A&GEL 应当是通往您专业知识的入口，而非您专业知识的来源。</strong>点击每一条引用链接，您就能看到 A&GEL 取用上下文的那份参考资料。您应始终对照这些参考资料核查 A&GEL 的输出，以确保其准确性与可靠性。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.5.p':
    '如果您已落实妥善的 A&GEL 文件管理实践，那么这些引用链接——它们会显示所引用文档的文件路径——还能让您一眼判断出 A&GEL 是否使用了正确主题（及工作流）的资料来增强其输出。举例来说，若您是站在“租赁权出让人”的立场提问，却发现 A&GEL 引用了“租赁权受让人”文件夹中的文档，您立刻就能看出该输出并未完全贴合您的目的。',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.title':
    '如果输出没有任何引用怎么办？',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.body':
    '没有引用的输出容易出现幻觉，因为它并未立足于任何可信的参考资料。如果您看不到任何引用，那几乎可以肯定：输出中呈现的信息仅来自模型的预训练。除非您确信该输出是在回应一般性写作或文本编辑类提示（例如简化文档或校对）或摘要任务，且模型已获得充分上下文，否则不应使用该输出。',
  'pages.angelInsider.issues.feature-faq.sections.4.kicker': '5 — 术语表',
  'pages.angelInsider.issues.feature-faq.sections.4.heading': 'A&GEL 中使用的技术术语',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.0.p':
    '<strong>收藏文件权重：</strong>调整 A&GEL 在生成回复时，对您（在保险库中）标记为“收藏”的文档的优先程度。权重越高，这些偏好来源对输出的影响就越大，超过保险库中的一般文件。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.1.p':
    '<strong>重排序：</strong>一道二次排序流程，A&GEL 会复核初始检索结果，以优先选出最相关的条款或文本片段。这可确保在生成回复之前，最切题的信息排在最前面。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.2.p':
    '<strong>检索比例：</strong>控制 AI 为回答某个问题所检索的内部数据量。比例越高，检索范围越广、纳入的上下文越多（适合广泛探索）；比例越低，则越严格聚焦于精确匹配（大致类似 CTRL+F）。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.3.p':
    '<strong>系统提示词：</strong>一组基础指令，用于确立 A&GEL 的具体角色、语气与运作边界（例如“你是一位拥有 20 年经验的高级合伙人”）。这些设定构成主要框架，指导 A&GEL 处理其后的每一次请求。',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.4.p':
    '<strong>“思考”或“推理”：</strong>指 A&GEL 在生成最终回复之前，对复杂问题进行逐步逻辑拆解的过程。这种内部推演模仿人类的推理方式，旨在减少复杂分析中的错误。',
  'pages.angelInsider.issues.feature-faq.signoff.line':
    '任何新工具都需要一点时间来适应——A&GEL 也不例外。您用得越多，它就越好用。',
  'pages.angelInsider.issues.feature-faq.signoff.name': 'A&GEL 开发团队',
  'pages.app.addCustomFieldsTitle': '添加要为每个事件提取的自定义字段',
  'pages.app.addCustomStepButton': '自定义步骤',
  'pages.app.addFieldButton': '添加字段',
  'pages.app.addFromLibraryButton': '从库中选择',
  'pages.app.addFromSavedButton': '已保存的配置',
  'pages.app.addToMattersButton': '添加到项目',
  'pages.app.analysisType.agenticResearch.title': '智能体研究',
  'pages.app.analysisType.comparison.title': '对比',
  'pages.app.analysisType.contractDeadlines.title': '提取截止日期',
  'pages.app.analysisType.executiveSummary.title': '摘要报告',
  'pages.app.analysisType.gartnerReport.description': '提供包含预测和建议的深度行业报告。',
  'pages.app.analysisType.gartnerReport.title': 'Gartner 风格报告',
  'pages.app.analysisType.guidedSummary.description': '根据提示词对单份文档生成详细摘要。',
  'pages.app.analysisType.multiStepPrompt.title': '多步提示词',
  'pages.app.analysisType.scopeOfWork.title': '工作范围摘要',
  'pages.app.analysisType.timeline.description': '针对最多 100 份文档生成详细的事件时间线。',
  'pages.app.analyzingFiles': '正在分析文件...',
  'pages.app.applicablePartiesColumnTitle': '适用方',
  'pages.app.appsList.executiveSummary.description': '面向管理层的要点、发现和建议高层概述',
  'pages.app.appsList.gartnerReport.description': '采用严谨客观的研究方法进行深度行业分析',
  'pages.app.appsList.guidedSummary.description': '根据提示词对单份文档生成详细摘要',
  'pages.app.appsList.standardInfo.description': '提供简明摘要、人员与实体清单以及简要时间线',
  'pages.app.appsList.timeline.description': '针对最多 100 份文档生成详细的事件时间线',
  'pages.app.appsTitle': '应用',
  'pages.app.backToSavedPromptsLabel': '返回已保存的提示词',
  'pages.app.backgroundColumnTitle': '背景',
  'pages.app.buildMultiStepPromptTitle': '构建您的多步骤提示词',
  'pages.app.buildNewButton': '新建配置',
  'pages.app.clauseColumnTitle': '条款',
  'pages.app.clearStepsButton': '清空',
  'pages.app.clearStepsConfirm': '移除列表中的所有步骤？',
  'pages.app.clientDetailsPlaceholder': '客户名称及简要信息',
  'pages.app.clientInformationTitle': '客户信息',
  'pages.app.clientLabel': '客户',
  'pages.app.collapseAllPrompts': '折叠所有提示词',
  'pages.app.collapsePrompt': '折叠提示词',
  'pages.app.compilingFinalSummary': '正在汇总最终摘要...',
  'pages.app.complexityLabel': '复杂度',
  'pages.app.configNameLabel': '配置名称',
  'pages.app.configTagsLabel': '标签',
  'pages.app.configurationDeletedSuccess': '配置已删除',
  'pages.app.configurationSavedSuccess': '配置保存成功',
  'pages.app.configurationUpdatedSuccess': '配置更新成功',
  'pages.app.contactLabel': '联系人',
  'pages.app.counterpartyLabel': '交易对方',
  'pages.app.dateReferenceColumnTitle': '日期/编号',
  'pages.app.deadlinesSectionTitle': '截止日期',
  'pages.app.deleteConfigConfirmTitle': '确定要删除此配置吗？',
  'pages.app.deleteStepTooltip': '删除步骤',
  'pages.app.detailsColumnTitle': '详情',
  'pages.app.doneCount': '已完成（{completed}/{total}）',
  'pages.app.dragHereToUpload': '拖拽至此处上传',
  'pages.app.dragStepTooltip': '拖动步骤',
  'pages.app.dropZoneForNamedStep': '{stepName} 的放置区域',
  'pages.app.dropZoneForStepNumber': '步骤 {stepNumber} 的放置区域',
  'pages.app.durationColumnTitle': '期限',
  'pages.app.enterConfigNamePlaceholder': '输入配置名称',
  'pages.app.enterDescriptionPlaceholder': '输入描述',
  'pages.app.enterTagsPlaceholder': '输入标签后按回车',
  'pages.app.entitiesColumnTitle': '实体',
  'pages.app.expandAllPrompts': '展开所有提示词',
  'pages.app.expandPrompt': '展开提示词',
  'pages.app.extendPromptTabLabel': '扩展提示词',
  'pages.app.extraFieldDescriptionPlaceholder': '描述（例如：提取提及的金额）',
  'pages.app.extraFieldKeyPlaceholder': '键名（例如：预算）',
  'pages.app.extractColumnTitle': '摘录',
  'pages.app.fileCountLabel': '{count} 个文件',
  'pages.app.filesCompleteCount': '已完成 {completed}/{total} 个文件',
  'pages.app.hardDeadlineColumnTitle': '硬性截止日期',
  'pages.app.inProgressSuffix': '（进行中）',
  'pages.app.keyDatesDeadlinesTitle': '关键日期与截止日期',
  'pages.app.libraryPanelTitle': '提示词库',
  'pages.app.loadSavedConfigPlaceholder': '加载已保存的配置',
  'pages.app.loadingDocumentTip': '正在加载文档...',
  'pages.app.mattersUpdatedSuccess': '项目更新成功',
  'pages.app.moveStepDownTooltip': '下移',
  'pages.app.moveStepUpTooltip': '上移',
  'pages.app.newAnalysisModesTitle': '全新分析模式',
  'pages.app.newFieldDefaultKey': '字段 {number}',
  'pages.app.newSessionLabel': '新建会话',
  'pages.app.newStepDefaultName': '新步骤',
  'pages.app.noSourceDocumentsDescription': '无源文档',
  'pages.app.noTimelineItemsExtracted': '未提取到时间线项目。',
  'pages.app.overallTabLabel': '总体',
  'pages.app.overviewSectionTitle': '概览',
  'pages.app.partiesSectionTitle': '当事方',
  'pages.app.peopleEntitiesInvolvedLabel': '涉及的人员/实体',
  'pages.app.periodsDurationsTitle': '期间与期限',
  'pages.app.pleaseEnterPlaceholder': '请输入',
  'pages.app.processingNextStep': '正在处理下一步骤...',
  'pages.app.promptForStepPlaceholder': '此步骤的提示词',
  'pages.app.promptLabelWithValue': '提示词：{prompt}',
  'pages.app.provideDetailsTabLabel': '提供详情',
  'pages.app.provideDocumentsTabLabel': '提供文档',
  'pages.app.providePromptsTabLabel': '提供提示词',
  'pages.app.provisionColumnTitle': '条款规定',
  'pages.app.publishAudienceGroupsLabel': '群组',
  'pages.app.publishAudienceLabel': '受众',
  'pages.app.publishAudienceOptionFirmWide': '全所范围',
  'pages.app.publishAudienceOptionGroup': '群组',
  'pages.app.publishAudienceOptionPublic': '公开',
  'pages.app.publishButton': '发布',
  'pages.app.publishConfigTitle': '发布配置',
  'pages.app.publishPublicNotice': '此配置将对所有用户可见。系统将向超级管理员发送审批请求。',
  'pages.app.publishRequestSubmitted': '发布请求已提交 — 等待管理员审批',
  'pages.app.publishedToGroup': '已发布至群组',
  'pages.app.readingDocumentName': '正在读取 {name}',
  'pages.app.restrictionColumnTitle': '限制',
  'pages.app.restrictiveCovenantsTitle': '限制性约定',
  'pages.app.reuseButton': '重新使用',
  'pages.app.runAppButton': '运行应用',
  'pages.app.sanitizedCheckingDocuments': '正在检查文档…',
  'pages.app.sanitizedSearchingDocuments': '正在搜索文档…',
  'pages.app.sanitizedWorkingThroughDocuments': '正在处理文档…',
  'pages.app.saveAsConfigButton': '另存为',
  'pages.app.saveConfigButton': '保存配置',
  'pages.app.saveConfigurationTitle': '保存配置',
  'pages.app.savedPromptStepCount': '{count, plural, other {# 个步骤}}',
  'pages.app.savedPromptsEmpty': '未找到已保存的多步骤提示词',
  'pages.app.savedPromptsPanelTitle': '选择已保存的配置',
  'pages.app.savedPromptsSearchPlaceholder': '搜索已保存的提示词...',
  'pages.app.savedPromptsTagFilterPlaceholder': '按标签筛选',
  'pages.app.searchMattersPlaceholder': '搜索项目...',
  'pages.app.searchPromptsPlaceholder': '搜索提示词...',
  'pages.app.selectAtLeastOneGroupError': '请至少选择一个群组',
  'pages.app.selectDocumentsStepTitle': '1. 选择您希望分析的文档',
  'pages.app.selectMattersLabel': '选择项目：',
  'pages.app.sharedConfigLabel': '{name}（已共享）',
  'pages.app.sourcesColumnTitle': '来源',
  'pages.app.specialRequestsSectionTitle': '特殊请求',
  'pages.app.specificInformationStepTitle': '2. 具体信息（可选）',
  'pages.app.stepNamePlaceholder': '步骤名称（例如：提取实体）',
  'pages.app.stepNumberLabel': '步骤 {number}',
  'pages.app.stepsAddedFromConfig': '{count, plural, other {已添加 # 个步骤}}',
  'pages.app.subagentLabel': '子代理 {number}',
  'pages.app.subjectLabel': '主题',
  'pages.app.summaryLabel': '摘要',
  'pages.app.tool.checkingDocuments': '正在检查文档',
  'pages.app.tool.readingDocument': '正在读取文档',
  'pages.app.tool.searchingDocuments': '正在搜索文档',
  'pages.app.tool.workingWithName': '处理中（{name}）',
  'pages.app.tool.writingReport': '正在撰写报告',
  'pages.app.untitledSession': '（无标题）',
  'pages.app.updateConfigButton': '更新',
  'pages.app.updateConfigurationTitle': '更新配置',
  'pages.app.updateMattersFailed': '项目更新失败',
  'pages.app.uploadOrSelectFilesError': '请上传文件或选择现有文件',
  'pages.app.urgencyColumnTitle': '紧急程度',
  'pages.app.useAnotherAppButton': '使用其他应用',
  'pages.app.whatsNew': '新功能',
  'pages.app.workingEllipsis': '处理中…',
  'pages.app.workingThroughDocumentsCount': '正在处理文档（{completed}/{total}）',
  'pages.chat.addToMatters': '添加至项目',
  'pages.chat.agentQuestion.answersSent': '答案已发送至代理',
  'pages.chat.agentQuestion.customAnswerPlaceholder': '或输入您自己的答案...',
  'pages.chat.agentQuestion.dismissQuestion': '关闭问题',
  'pages.chat.agentQuestion.noAnswer': '（无答案）',
  'pages.chat.agentQuestion.question': '问题',
  'pages.chat.agentQuestion.questionOfTotal': '第 {current} 个问题（共 {total} 个）',
  'pages.chat.agentQuestion.questionProgress': '{current} / {total}',
  'pages.chat.agentQuestion.reviewAnswers': '查看答案',
  'pages.chat.agentQuestion.reviewYourAnswers': '提交前请查看您的答案。',
  'pages.chat.agentQuestion.seeLess': '收起',
  'pages.chat.agentQuestion.seeMore': '查看更多',
  'pages.chat.agentQuestion.sendAnswers': '发送答案',
  'pages.chat.agentQuestion.submitted': '已提交',
  'pages.chat.agentQuestion.summary': '摘要',
  'pages.chat.agenticRag': '智能体 RAG',
  'pages.chat.agenticRag.lockedByDeepResearch': '深度研究需要启用此功能。',
  'pages.chat.agenticRag.description': '由智能体决定何时搜索你的上下文文件',
  'pages.chat.agenticRag.tooltip': '启用带引用来源的智能体检索。需要聊天上下文中包含文档。',
  'pages.chat.allowSelfPrompting': '允许自我提示',
  'pages.chat.allowSelfPrompting.description': '智能体会从你的提示库中应用匹配的提示',
  'pages.chat.attachedDocument': '已附加文档',
  'pages.chat.auth.contentOpenedInNewTab': '内容已在新标签页中打开',
  'pages.chat.auth.dataOpenedInNewTab': '数据已在新标签页中打开',
  'pages.chat.auth.failedToFetchUrl': '获取 URL 失败：{error}',
  'pages.chat.auth.failedToOpenNewTab': '打开新标签页失败',
  'pages.chat.auth.fileOpenedInNewTab': '文件已在新标签页中打开',
  'pages.chat.auth.jsonResponseTitle': 'JSON 响应',
  'pages.chat.auth.textResponseTitle': '文本响应',
  'pages.chat.cannotCopyNonTextContent': '无法复制非文本内容',
  'pages.chat.chatTitle': '聊天',
  'pages.chat.clickOrDragToUpload': '点击或拖拽以上传',
  'pages.chat.connectionInterrupted': '您的连接已中断。请点击{retry}。',
  'pages.chat.context.custom': '自定义 {suffix}',
  'pages.chat.context.defaultWithName': '默认（{name}）',
  'pages.chat.context.fullContext': '完整上下文',
  'pages.chat.context.label': '上下文',
  'pages.chat.context.selectedLabel': '已选择',
  'pages.chat.customisation': '自定义设置',
  'pages.chat.dragHereToUpload': '拖拽至此处上传',
  'pages.chat.emptyState.desktopTitle': '今天 A&GEL 能为您做些什么？',
  'pages.chat.emptyState.mobileTitle': 'A&GEL 能帮您做什么？',
  'pages.chat.emptyState.subtitle': '选择下方的提示直接开始，或直接输入与 A&GEL 对话。',
  'pages.chat.failedToCopyMessage': '复制消息失败',
  'pages.chat.failedToDownloadFile': '文件下载失败：{error}',
  'pages.chat.fileDownloadedSuccessfully': '文件下载成功',
  'pages.chat.filesInVault': '文件库中的文件',
  'pages.chat.home': '首页',
  'pages.chat.htmlContentIframeTitle': 'HTML 内容',
  'pages.chat.messageCopied': '消息已复制！',
  'pages.chat.newChatConfirm.content': '确定要清除当前聊天记录并开始新会话吗？',
  'pages.chat.newChatConfirm.okText': '是，开始新聊天',
  'pages.chat.newChatConfirm.title': '开始新聊天？',
  'pages.chat.nextStep.button': '下一步',
  'pages.chat.nextStep.review': '审阅',
  'pages.chat.nextStep.workstudio': 'Workstudio',
  'pages.chat.referenceDocument': '参考文档',
  'pages.chat.referenceTitle': '参考：{title}',
  'pages.chat.referencesCount': '{count} 个参考',
  'pages.chat.selectedContext': '已选上下文',
  'pages.chat.selfPromptedUsing': '使用 {name} 自动生成提示。',
  'pages.chat.showMoreLines': '显示更多（{count} 行）',
  'pages.chat.sourcesCount': '来源（{count}）',
  'pages.chat.startNewChat': '开始新聊天',
  'pages.chat.starterPrompt.caseSummariser.name': '案例摘要工具',
  'pages.chat.starterPrompt.draftChecklist.name': '起草检查清单',
  'pages.chat.starterPrompt.summariseArticle.description': '通用文章摘要工具。',
  'pages.chat.starterPrompt.summariseArticle.name': '总结这篇文章',
  'pages.chat.status.completed': '已完成',
  'pages.chat.status.working': '处理中',
  'pages.chat.toolCategory.compare': '正在比较文本',
  'pages.chat.toolCategory.generate': '正在生成文档',
  'pages.chat.toolCategory.read': '正在读取文档',
  'pages.chat.toolCategory.searchDoc': '正在搜索文档',
  'pages.chat.toolCategory.searchFiles': '正在搜索文件',
  'pages.chat.toolCategory.selfInstruction': '正在应用指令',
  'pages.chat.transientFiles': '临时文件',
  'pages.chat.unknownFileName': '未知',
  'pages.chat.unknownFileNameLong': '未知文件',
  'pages.chat.untitledSession': '（未命名）',
  'pages.chat.upload.failedToUploadFile': '上传 {fileName} 失败',
  'pages.chat.upload.onlyAllowedTypes':
    '请仅上传 PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT 或 PPTX 格式的文件',
  'pages.chat.uploadedImageAlt': '已上传',
  'pages.chat.waiting.almostThere': '即将完成...',
  'pages.chat.waiting.fetchingThatForYou': '正在为您获取...',
  'pages.chat.waiting.hangTight': '请稍等，我正在处理...',
  'pages.chat.waiting.holdOnRetrieving': '请稍候，正在检索信息...',
  'pages.chat.waiting.justAMoment': '请稍等...',
  'pages.chat.waiting.letMeCheck': '让我查一下...',
  'pages.chat.waiting.lookingThatUp': '正在为您查找...',
  'pages.chat.waiting.oneSecPlease': '请稍等一下...',
  'pages.chat.waiting.workingOnIt': '正在处理...',
  'pages.chat.outlookSearch.offTooltip': '搜索您的 Outlook 邮件',
  'pages.chat.outlookSearch.onTooltip': 'Outlook 搜索已开启',
  'pages.chat.outlookSearch.connectTooltip': '连接 Microsoft 以搜索您的 Outlook 邮件',
  'pages.chat.outlookSearch.permissionMissing': 'Outlook 搜索需要读取您邮件的权限。请重试。',
  'pages.chat.webSearch.confidentialityNotice':
    '已开启网页搜索。请勿在提示中包含任何客户机密信息或受法律特权保护的信息。',
  'pages.chat.researchPlan.complete': '研究完成',
  'pages.chat.researchReport.tab.report': '报告',
  'pages.chat.researchReport.tab.searches': '搜索 ({count})',
  'pages.chat.researchReport.tab.sources': '来源 ({count})',
  'pages.chat.researchReport.noSearches': '此报告未记录任何搜索。',
  'pages.chat.researchReport.noSources': '此报告未引用任何来源。',
  'pages.chat.researchReport.openReport': '查看报告',
  'pages.chat.researchReport.counts': '{searches} 次搜索 · {sources} 个来源',
  'pages.chat.researchReport.title': '研究报告',
  'pages.chat.researchReport.open': '打开完整报告',
  'pages.chat.researchPlan.ready': '准备开始',
  'pages.chat.researchPlan.editing': '编辑中',
  'pages.chat.researchPlan.addTopic': '添加主题',
  'pages.chat.researchPlan.editSubtitle': '编辑下方主题。更改将在研究开始前生效。',
  'pages.chat.researchPlan.cancel': '取消',
  'pages.chat.researchPlan.saveChanges': '保存更改',
  'pages.chat.researchPlan.showDetails': '显示详情',
  'pages.chat.researchPlan.working': '进行中 ({done}/{total})',
  'pages.chat.researchPlan.stop': '停止',
  'pages.chat.researchPlan.viewProgress': '查看进度',
  'pages.chat.researchPlan.progressTitle': '研究进度',
  'pages.chat.researchPlan.tab.progress': '进度',
  'pages.chat.research.copied': '已复制报告',
  'pages.chat.research.copyFailed': '无法复制报告',
  'pages.chat.research.pageRead': '已读取',
  'pages.chat.research.tableOfContents': '目录',
  'pages.chat.research.resizeContents': '调整目录宽度',
  'pages.chat.research.windowTitle': '研究',
  'pages.chat.research.completed': '已完成',
  'pages.chat.research.running': '进行中',
  'pages.chat.research.stopped': '已停止',
  'pages.chat.research.failed': '失败',
  'pages.chat.research.tab.report': '报告',
  'pages.chat.research.tab.searches': '搜索 ({count})',
  'pages.chat.research.tab.sources': '来源 ({count})',
  'pages.chat.research.reportPending': '报告写好后会显示在这里。',
  'pages.chat.research.noSearches': '暂无搜索。',
  'pages.chat.research.noSources': '暂无来源。',
  'pages.chat.research.searchSent': '已发送',
  'pages.chat.research.searchRunning': '搜索中',
  'pages.chat.research.searchSkipped': '已跳过',
  'pages.chat.researchPlan.title': '研究计划',
  'pages.chat.researchPlan.stepCount': '{count, plural, other {# 个步骤}}',
  'pages.chat.researchPlan.inProgress': '研究进行中',
  'pages.chat.researchPlan.edit': '编辑',
  'pages.chat.researchPlan.done': '完成',
  'pages.chat.researchPlan.start': '开始研究',
  'pages.chat.researchPlan.addStep': '添加步骤',
  'pages.chat.researchPlan.removeStep': '删除第 {number} 步',
  'pages.chat.researchPlan.includeStep': '包含第 {number} 步',
  'pages.chat.researchPlan.started': '研究已开始',
  'pages.chat.webSearch.googleSuggestions': 'Google 搜索建议',
  'pages.chat.webSearch.permission.title': '搜索权限',
  'pages.chat.webSearch.permission.manual': '手动',
  'pages.chat.webSearch.permission.manualDescription': '每条查询发送前均需审核',
  'pages.chat.webSearch.permission.auto': '自动',
  'pages.chat.webSearch.permission.autoDescription': '无需审核直接运行。查询内容将离开本所',
  'pages.chat.webSearch.permission.deep': '深度研究',
  'pages.chat.webSearch.permission.deepDescription': '制定计划并执行多次搜索，始终自动',
  'pages.comparison.analysisFallbackTitle': '分析',
  'pages.comparison.outcomeUnverified': '未验证',
  'pages.comparison.commentTags': '评论标签',
  'pages.comparison.allCommentTags': '所有评论标签',
  'pages.comparison.noMatchingComments': '没有与所选标签匹配的评论',
  'pages.comparison.downloadExcel': '下载 Excel',
  'pages.comparison.stopSuccess': '比较已成功停止。您可以查看部分结果。',
  'pages.comparison.stopFailed': '停止比较失败',
  'pages.comparison.uploadSuccess': '{fileName} 上传成功',
  'pages.comparison.uploadFailed': '{fileName} 上传失败',
  'pages.comparison.uploadLimitExceeded': '此任务类型最多只能上传 {max} 个文件。',
  'pages.comparison.pollingTimeout': '轮询超时。任务可能仍在处理中。',
  'pages.comparison.taskStarted': '比较任务已启动',
  'pages.comparison.startFailed': '启动比较失败',
  'pages.comparison.previousAnalysisTitle': '上一项分析',
  'pages.comparison.analysisPositionCounter': '{current} / {total}',
  'pages.comparison.analysisFoundCounter': '找到 {total} 项',
  'pages.comparison.nextAnalysisTitle': '下一项分析',
  'pages.comparison.messageHeading': '消息',
  'pages.comparison.noResultsYet': '暂无结果',
  'pages.comparison.startComparisonButton': '开始比较',
  'pages.comparison.newComparisonButton': '开始新的比较',
  'pages.comparison.searchComparisonsPlaceholder': '搜索比较',
  'pages.comparison.reuseButton': '重新使用',
  'pages.comparison.selectMattersLabel': '选择项目：',
  'pages.comparison.searchMattersPlaceholder': '搜索项目...',
  'pages.comparison.mattersUpdated': '项目更新成功',
  'pages.comparison.mattersUpdateFailed': '项目更新失败',
  'pages.comparison.addToMattersButton': '添加到项目',
  'pages.comparison.untitled': '（未命名）',
  'pages.comparison.processingMoreResults': '正在处理更多结果...',
  'pages.comparison.processingComparison': '正在处理比较...',
  'pages.comparison.taskType.strikethroughUnderline.label': '删除线与下划线',
  'pages.comparison.taskType.trackedChanges.label': '修订记录',
  'pages.comparison.taskType.trackedChanges.description': '审阅使用修订功能所做的修改和批注。',
  'pages.comparison.taskType.twoVersions.label': '两个版本',
  'pages.comparison.taskType.twoVersions.description': '比较文档的两个不同版本以识别差异。',
  'pages.comparison.taskType.referenceDocument.label': '目标文档对照参考文档',
  'pages.comparison.requirement.singleDocument': '单份文档',
  'pages.comparison.requirement.twoDocuments': '两份文档',
  'pages.comparison.startHereTab': '从此处开始',
  'pages.comparison.selectDocumentsPrompt': '选择您要进行比较的文档',
  'pages.comparison.dragUploadText': '点击或将文件拖拽至此区域进行上传',
  'pages.comparison.swapOrderButton': '交换顺序',
  'pages.comparison.fileLabel.old': '（旧） ',
  'pages.comparison.fileLabel.new': '（新） ',
  'pages.comparison.fileLabel.reference': '（参考） ',
  'pages.comparison.fileLabel.target': '（目标） ',
  'pages.comparison.customInstructionTab': '自定义指令（可选）',
  'pages.comparison.modifyPromptTitle': '修改提示',
  'pages.comparison.pageTitle': '比较',
  'pages.comparison.similarDocumentComparisonTitle': '相似文档比较',
  'pages.comparison.referenceDocumentComparisonTitle': '参考文档比较',
  'pages.comparison.dragHereToUpload': '拖拽至此处上传',
  'pages.comparison.documentCount.unknownFile': '未知文件',
  'pages.comparison.documentCount.fileCount': '{count} 个文件',
  'pages.comparison.reviewDirection.reviewedOnBehalfOf': '代表以下方审阅 ',
  'pages.comparison.reviewDirection.swapButton': '交换审阅方向',
  'pages.comparison.invalidFileDocxOrPdf': '{fileName} 不是有效的 .docx 或 .pdf 文件',
  'pages.comparison.invalidFileDocx': '{fileName} 不是有效的 .docx 文件',
  'pages.comparison.twoVersionsFileCountError': '进行两版本比较时，请上传恰好 2 份文档。',
  'pages.comparison.singleFileCountError': '此任务请上传恰好 1 份文档。',
  'pages.composer.changeAction.accept': '接受',
  'pages.composer.changeAction.reject': '拒绝',
  'pages.composer.changeAction.reset': '重置',
  'pages.composer.documentView.foundCount': '找到 {count} 项',
  'pages.composer.documentView.nextChangeArrow': '下一个 ↓',
  'pages.composer.documentView.nextChangeTitle': '下一处修改',
  'pages.composer.documentView.positionCount': '{current} / {total}',
  'pages.composer.documentView.previousChangeTitle': '上一处修改',
  'pages.composer.documentView.stepNumber': '第 {number} 步',
  'pages.composer.documentView.turnNumber': '第 {number} 轮',
  'pages.composer.playbook.askAgel': '询问 A&GEL',
  'pages.composer.playbook.chooseDocumentTitle': '选择一份文档以开始',
  'pages.composer.playbook.createSessionFailed': '创建 Workstudio 会话失败',
  'pages.composer.playbook.documentCanvas': '文档画布',
  'pages.composer.playbook.docxOnlyAllowedError': 'Workstudio 模式仅支持 .docx 文件',
  'pages.composer.playbook.docxOnlySkippedWarning': '部分文件已跳过。仅支持 .docx 文件',
  'pages.composer.playbook.docxOnlySupportedError': 'Workstudio 模式仅支持 .docx 文件',
  'pages.composer.playbook.downloadGenerating': '生成中…',
  'pages.composer.playbook.dragToUpload': '拖拽至此处上传',
  'pages.composer.playbook.fileUploadFailed': '上传 {fileName} 失败',
  'pages.composer.playbook.fileUploadedSuccess': '{fileName} 上传成功',
  'pages.composer.playbook.newButtonText': '新建 Workstudio',
  'pages.composer.playbook.openFailed': '打开 Workstudio 失败',
  'pages.composer.playbook.reuseButton': '复用',
  'pages.composer.playbook.resizeChatPane': '调整聊天区域宽度',
  'pages.composer.playbook.searchPlaceholder': '搜索 Workstudio',
  'pages.composer.playbook.title': 'Workstudio',
  'pages.composer.playbookReview.acceptAllButton': '全部接受',
  'pages.composer.playbookReview.acceptChangeError': '接受更改失败,请重试。',
  'pages.composer.playbookReview.addCommentButton': '评论',
  'pages.composer.playbookReview.addCommentPlaceholder': '添加评论...',
  'pages.composer.playbookReview.addCommentTooltip': '添加评论',
  'pages.composer.playbookReview.allAcceptError': '接受所有更改失败,请重试。',
  'pages.composer.playbookReview.allAcceptedSuccess': '所有更改已接受',
  'pages.composer.playbookReview.allRejectError': '拒绝所有更改失败,请重试。',
  'pages.composer.playbookReview.allRejectedSuccess': '所有更改已拒绝',
  'pages.composer.playbookReview.allResetError': '重置所有更改失败,请重试。',
  'pages.composer.playbookReview.allResetSuccess': '所有更改已重置为待处理',
  'pages.composer.playbookReview.backToWorkstudio': '返回 Workstudio',
  'pages.composer.playbookReview.changeOfTotal': '第 {index} 项更改,共 {total} 项',
  'pages.composer.playbookReview.commentSaveError': '保存评论失败,请重试。',
  'pages.composer.playbookReview.commentSavedSuccess': '评论已保存',
  'pages.composer.playbookReview.discardDraftButton': '放弃草稿',
  'pages.composer.playbookReview.documentLoadFailedError': '无法加载此文档,请刷新页面重试。',
  'pages.composer.playbookReview.documentViewAriaLabel': '文档视图',
  'pages.composer.playbookReview.doneEditingButton': '完成',
  'pages.composer.playbookReview.downloadGenericError': '生成下载文件失败',
  'pages.composer.playbookReview.downloadSuccess': '文档下载成功!',
  'pages.composer.playbookReview.downloadTimeoutError': '生成下载文件超时',
  'pages.composer.playbookReview.editCommentButton': '编辑评论',
  'pages.composer.playbookReview.editCommentTooltip': '编辑评论',
  'pages.composer.playbookReview.editDocumentButton': '编辑',
  'pages.composer.playbookReview.groupAcceptAllCount': '全部接受 ({count})',
  'pages.composer.playbookReview.groupAcceptedError': '接受更改失败,请重试。',
  'pages.composer.playbookReview.groupAcceptedSuccess': '已接受 {count} 处相同更改',
  'pages.composer.playbookReview.groupRejectAllCount': '全部拒绝 ({count})',
  'pages.composer.playbookReview.groupRejectedError': '拒绝更改失败,请重试。',
  'pages.composer.playbookReview.groupRejectedSuccess': '已拒绝 {count} 处相同更改',
  'pages.composer.playbookReview.groupResetAllCount': '全部重置 ({count})',
  'pages.composer.playbookReview.groupResetError': '重置更改失败,请重试。',
  'pages.composer.playbookReview.groupResetSuccess': '已重置 {count} 处相同更改',
  'pages.composer.playbookReview.hidePromptButton': '隐藏提示词',
  'pages.composer.playbookReview.layerChangeCount': '{count, plural, other {# 处更改}}',
  'pages.composer.playbookReview.loadingDocument': '正在加载文档...',
  'pages.composer.playbookReview.localDraftTag': '本地草稿',
  'pages.composer.playbookReview.localDraftTooltip':
    '未保存的草稿。使用“保存编辑”将文本更改记录为跟踪修订。',
  'pages.composer.playbookReview.noChangesDescription': 'AI 未针对该指令提出任何更改。',
  'pages.composer.playbookReview.noChangesFromStep': '此步骤未产生更改',
  'pages.composer.playbookReview.noChangesTitle': '未发现更改',
  'pages.composer.playbookReview.previousChangesFallback': '先前的更改',
  'pages.composer.playbookReview.processingTimeoutError': '处理时间超出预期,请刷新页面查看状态。',
  'pages.composer.playbookReview.regenerateLabel': '重新生成',
  'pages.composer.playbookReview.rejectAllButton': '全部拒绝',
  'pages.composer.playbookReview.rejectChangeError': '拒绝更改失败,请重试。',
  'pages.composer.playbookReview.resetAllButton': '全部重置',
  'pages.composer.playbookReview.reviewViewAriaLabel': '审阅视图',
  'pages.composer.playbookReview.saveEditsButton': '保存编辑',
  'pages.composer.playbookReview.saveEditsError': '保存编辑失败。您的草稿已保留，请重试。',
  'pages.composer.playbookReview.saveEditsNoChanges': '没有可保存的文本更改。',
  'pages.composer.playbookReview.saveEditsSuccess': '编辑已保存为跟踪修订。',
  'pages.composer.playbookReview.saveEditsTooltip':
    '将文本更改保存为跟踪修订。仅格式的更改不会被保存。',
  'pages.composer.playbookReview.saveEditsUnavailableTooltip':
    '无法保存：此文档的版式无法映射回文档文本。编辑内容将保留为本地草稿。',
  'pages.composer.playbookReview.selfPromptedUsing': '已使用 {promptName} 自动生成提示。',
  'pages.composer.playbookReview.showFullPromptButton': '显示完整提示词',
  'pages.composer.playbookReview.showingDocumentView': '正在显示文档视图',
  'pages.composer.playbookReview.showingStepView': '正在显示分步视图',
  'pages.composer.playbookReview.status.accepted': '已接受',
  'pages.composer.playbookReview.status.pending': '待处理',
  'pages.composer.playbookReview.status.rejected': '已拒绝',
  'pages.composer.playbookReview.statusDistributionAriaLabel': '审阅状态分布',
  'pages.composer.playbookReview.stepChangeCount': '{count, plural, other {# 处更改}}',
  'pages.composer.playbookReview.stepTag': '步骤 {number}',
  'pages.composer.playbookReview.stepViewAriaLabel': '分步视图',
  'pages.composer.playbookReview.turnNeedsRegeneration': '此轮次需要重新生成。',
  'pages.composer.playbookReview.turnHasConflicts': '此轮次包含冲突的更改。',
  'pages.composer.playbookReview.turnConflictReason':
    '部分建议的更改相互重叠。请重新生成此轮次以重新应用。',
  'pages.composer.playbookReview.turnHasUnlocatableChanges': '此轮次包含无法定位的更改。',
  'pages.composer.playbookReview.turnUnlocatableReason':
    '部分建议的更改无法在文档中定位。请重新生成此轮次以重新应用。',
  'pages.composer.playbookReview.turnTitle': '第 {order} 轮:{prompt}',
  'pages.composer.playbookReview.undoChangeError': '撤销失败,请重试。',
  'pages.composer.playbookReview.updatingCanvas': '正在更新审阅画布...',
  'pages.composer.playbookReview.viewChangeTooltip': '在原始文档中查看更改',
  'pages.composer.playbookReview.viewContextButton': '查看上下文',
  'pages.composer.playbookReview.waitForUpdateWarning': '请等待当前更新完成后再下载。',
  'pages.dashboard.allChannelsOption': '所有渠道',
  'pages.dashboard.presetPast30Days': '过去 30 天',
  'pages.dashboard.presetToday': '今天',
  'pages.dashboard.presetWtd': '本周至今',
  'pages.dashboard.presetMtd': '本月至今',
  'pages.dashboard.presetYtd': '本年至今',
  'pages.dashboard.exportLoading': '导出仪表盘',
  'pages.dashboard.downloaded': '已下载',
  'pages.dashboard.downloadingName': '正在下载 {name}',
  'pages.dashboard.chatGptMessageSeries': 'ChatGPT 消息',
  'pages.dashboard.storyboardMessageSeries': 'Storyboard 消息',
  'pages.dashboard.broadcastMessageSeries': '广播消息',
  'pages.dashboard.messageTrendDataTitle': '消息趋势数据',
  'pages.dashboard.messageTrendDataTooltip': '所选时间段内消息统计数据的历史趋势。',
  'pages.dashboard.newUsersSeries': '新增用户',
  'pages.dashboard.activeUsersSeries': '活跃用户',
  'pages.dashboard.userTrendDataTitle': '用户趋势数据',
  'pages.dashboard.userTrendDataTooltip': '所选时间段内用户统计数据的历史趋势。',
  'pages.dashboard.userActivityHeatmapTitle': '用户活跃度热力图',
  'pages.dashboard.userActivityHeatmapTooltip': '所选时间段内每周各天每小时的平均用户消息数。',
  'pages.dashboard.wordCloudTitle': '词云',
  'pages.dashboard.wordCloudTooltip': '以图形方式展示所选时间段内用户消息中高频查询词的分布。',
  'pages.dashboard.realTimeUsersTitle': '实时用户',
  'pages.dashboard.activeUsersTitle': '活跃用户',
  'pages.dashboard.newUsersTitle': '新增用户',
  'pages.dashboard.promptTokensTitle': '输入 Token 数',
  'pages.dashboard.completionTokensTitle': '输出 Token 数',
  'pages.dashboard.userMessagesTitle': '用户消息',
  'pages.dashboard.chatGptTitle': 'ChatGPT',
  'pages.dashboard.storyboardsTitle': 'Storyboard',
  'pages.dashboard.botMessagesTitle': '机器人消息',
  'pages.dashboard.broadcastsTitle': '广播',
  'pages.dashboard.repliesTitle': '回复',
  'pages.dashboard.messageExchangesTitle': '消息交互',
  'pages.dashboard.broadcastTitle': '#广播',
  'pages.dashboard.outreachTitle': '触达',
  'pages.dashboard.totalUsersTitle': '用户总数',
  'pages.dashboard.totalUserMessagesTitle': '用户消息总数',
  'pages.dashboard.totalBotMessagesTitle': '机器人消息总数',
  'pages.dashboard.totalMessageExchangesTitle': '消息交互总数',
  'pages.diagnostics.usersFilter.label': '用户:',
  'pages.diagnostics.usersFilter.placeholder': '用户',
  'pages.diagnostics.typesFilter.label': '类型:',
  'pages.diagnostics.typesFilter.placeholder': '类型',
  'pages.diagnostics.dateFilter.label': '日期:',
  'pages.diagnostics.datePreset.past30Days': '过去 30 天',
  'pages.diagnostics.datePreset.today': '今天',
  'pages.diagnostics.datePreset.wtd': '本周至今',
  'pages.diagnostics.datePreset.mtd': '本月至今',
  'pages.diagnostics.datePreset.ytd': '本年至今',
  'pages.diagnostics.errorItem.description': ' {username} · 创建时间:{createdTime}',
  'pages.files.you': '我',
  'pages.files.assignAnotherOwnerFirst': '请先指定其他所有者。',
  'pages.files.keepAtLeastOneMember': '请至少保留一位成员。',
  'pages.files.keepAtLeastOneOwner': '请至少保留一位所有者。',
  'pages.files.deletingEllipsis': '正在删除...',
  'pages.files.failedToDelete': '删除失败',
  'pages.files.dropToUploadCurrentFolder': '拖放以上传到当前文件夹',
  'pages.files.deleteConfirm.title': '删除 {count} 个文件?',
  'pages.files.fromPath': '来自:{path}',
  'pages.files.createdAtColumn': '创建时间',
  'pages.files.favoritesTitle': '收藏夹',
  'pages.files.searchFavoritesPlaceholder': '搜索收藏夹...',
  'pages.files.chatTooltip': '聊天',
  'pages.files.uploadingEllipsis': '正在上传...',
  'pages.files.paginationRangeOfTotal': '第 {start}-{end} 项,共 {total} 项',
  'pages.files.enterNamePlaceholder': '输入名称',
  'pages.files.deleteConfirm.itemContent': '确定要删除“{name}”吗?',
  'pages.files.chatWithFolderTooltip': '与此文件夹对话',
  'pages.files.chatWithFileTooltip': '与此文件对话',
  'pages.files.filePreviewAlt': '文件预览',
  'pages.files.fileTypeCannotBePreviewed': '该文件类型不支持预览',
  'pages.files.uploadFilesMenuItem': '上传文件',
  'pages.files.uploadFolderMenuItem': '上传文件夹',
  'pages.files.newFolderButton': '新建文件夹',
  'pages.files.sortOption.newestFirst': '最新在前',
  'pages.files.sortOption.oldestFirst': '最早在前',
  'pages.files.sortOption.nameAZ': '名称 A–Z',
  'pages.playbook.header.title': 'Workstudio',
  'pages.playbook.emptyState.title': '随时为您服务。',
  'pages.playbook.emptyState.description': '可要求改写、条款审查、摘要或定向修改。',
  'pages.playbook.checkingDocument': '正在检查文档...',
  'pages.playbook.updatingReviewCanvas': '正在更新审阅画布...',
  'pages.playbook.inputPlaceholder': '告诉 A&GEL 需要修改的内容...',
  'pages.playbook.inputAriaLabel': 'Workstudio 指令',
  'pages.playbook.contextButton': '上下文',
  'pages.playbook.sendButtonAriaLabel': '发送 Workstudio 指令',
  'pages.playbook.sendInstructionError': '发送 Workstudio 指令失败',
  'pages.projectsHub.func.chat': '聊天',
  'pages.projectsHub.func.scribe': '记录',
  'pages.projectsHub.func.apps': '应用',
  'pages.projectsHub.func.review': '审阅',
  'pages.projectsHub.func.sideBySide': '并排对比',
  'pages.projectsHub.func.comparison': '比较',
  'pages.projectsHub.func.translation': '翻译',
  'pages.projectsHub.func.template': '自定义输出',
  'pages.projectsHub.func.quote': '报价',
  'pages.projectsHub.untitledSession': '未命名',
  'pages.projectsHub.untitledFileLabel': '(未命名)',
  'pages.projectsHub.errors.loadDataFailed': '数据加载失败',
  'pages.projectsHub.subfolderCreated': '子文件夹已创建',
  'pages.projectsHub.collectionCreated': '合集已创建',
  'pages.projectsHub.errors.createFailed': '创建失败',
  'pages.projectsHub.errors.updateFailed': '更新失败',
  'pages.projectsHub.deleteCollectionConfirm.title': '删除合集',
  'pages.projectsHub.deleteCollectionConfirm.content': '确定删除“{name}”吗？',
  'pages.projectsHub.collectionDeleted': '已删除',
  'pages.projectsHub.errors.deleteFailed': '删除失败',
  'pages.projectsHub.sessionsAdded': '已添加 {count} 个会话',
  'pages.projectsHub.errors.addSessionsFailed': '添加失败',
  'pages.projectsHub.sessionRemoved': '会话已移除',
  'pages.projectsHub.errors.removeSessionFailed': '移除会话失败',
  'pages.projectsHub.sessionsRemoved': '已移除 {count} 个会话',
  'pages.projectsHub.errors.removeSessionsFailed': '移除会话失败',
  'pages.projectsHub.fieldSaved': '已保存',
  'pages.projectsHub.errors.saveFieldFailed': '保存失败',
  'pages.projectsHub.folderDeleted': '文件夹已删除',
  'pages.projectsHub.errors.deleteFolderFailed': '删除文件夹失败',
  'pages.projectsHub.folderCreated': '文件夹已创建',
  'pages.projectsHub.errors.createFolderFailed': '创建文件夹失败',
  'pages.projectsHub.deleteFolderConfirm.description': '确定删除“{name}”及其全部内容吗？',
  'pages.projectsHub.deleteSessionsConfirm.title': '删除会话',
  'pages.projectsHub.deleteSessionsConfirm.description': '确定要从此合集中移除 {count} 个会话吗？',
  'pages.projectsHub.removeSessionConfirm.title': '移除会话',
  'pages.projectsHub.removeSessionConfirm.description': '确定要从此合集中移除“{name}”吗？',
  'pages.projectsHub.sort.newestFirst': '最新优先',
  'pages.projectsHub.sort.oldestFirst': '最早优先',
  'pages.projectsHub.sort.nameAsc': '名称（A-Z）',
  'pages.projectsHub.sort.nameDesc': '名称（Z-A）',
  'pages.projectsHub.doubleClickToOpen': '双击打开',
  'pages.projectsHub.tidyUp': '整理',
  'pages.projectsHub.exit': '退出',
  'pages.projectsHub.manage': '管理',
  'pages.projectsHub.deleteSessionsButton': '删除（{count}）',
  'pages.projectsHub.searchSessionsPlaceholder': '搜索会话',
  'pages.projectsHub.emptyState.noFiles': '暂无文件',
  'pages.projectsHub.newFolderButton': '新建文件夹',
  'pages.projectsHub.addSessionsButton': '添加会话',
  'pages.projectsHub.folderInfoLabel': '文件夹信息',
  'pages.projectsHub.mattersHeading': '项目',
  'pages.projectsHub.mattersSubtitle': '在同一工作区中创建合集，整理来自不同功能的会话。',
  'pages.projectsHub.hubBreadcrumbLabel': '中心',
  'pages.projectsHub.deleteFolderButton': '删除文件夹',
  'pages.projectsHub.itemsLabel': '项目',
  'pages.projectsHub.selectSubfolderEmptyState': '选择一个子文件夹以查看详情',
  'pages.projectsHub.selectFolderEmptyState': '选择一个文件夹以查看详情',
  'pages.projectsHub.noCollectionsMatch': '没有符合当前筛选条件的合集。',
  'pages.projectsHub.noSessionsFoundForFunction': '未找到 {func} 会话。',
  'pages.projectsHub.addSelectedSessionsButton': '添加{count, plural, =0 {所选}other {# 个会话}}',
  'pages.projectsHub.step1ChooseFunctionType': '第 1 步 — 选择功能类型',
  'pages.projectsHub.selectFunctionPlaceholder': '选择功能',
  'pages.projectsHub.step2SelectSessions': '第 2 步 — 选择要添加的会话',
  'pages.projectsHub.createFolderButton': '创建文件夹',
  'pages.projectsHub.folderNameLabel': '文件夹名称',
  'pages.projectsHub.subfolderNamePlaceholder': '例如：尽职调查',
  'pages.projectsHub.collectionNamePlaceholder': '例如：并购尽职调查',
  'pages.projectsHub.optionalDescriptionPlaceholder': '描述（选填）',
  'pages.projectsHub.optionalNotesPlaceholder': '备注（选填）',
  'pages.projectsHub.createCollectionModalTitle': '创建合集',
  'pages.projectsHub.collectionNameLabel': '合集名称',
  'pages.projectsHub.editCollectionModalTitle': '编辑 • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, other {# 项}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, other {# 个文件}}',
  'pages.quote.historyTooltip': '历史记录（Tab+H）',
  'pages.quote.hideTooltip': '隐藏（Tab+H）',
  'pages.quote.newQuoteTooltip': '新建报价（Tab+N）',
  'pages.quote.untitled': '(未命名)',
  'pages.quote.newQuote': '新建报价',
  'pages.quote.deletedExample': '已删除示例',
  'pages.quote.generateDescription': '根据您的模板和事实生成报价',
  'pages.quote.sizeLabel': '篇幅',
  'pages.quote.sizeShort': '简短',
  'pages.quote.sizeMedium': '中等',
  'pages.quote.sizeLong': '详尽',
  'pages.quote.examplesLabel': '示例',
  'pages.quote.promptLabel': '提示词',
  'pages.quote.examplesTitle': '示例',
  'pages.quote.quoteTitle': '报价',
  'pages.quote.uploadManageExamples': '上传/管理示例',
  'pages.quote.generateQuoteSubtitle': '生成报价',
  'pages.quote.fileLabel': '文件',
  'pages.quote.deleteConfirmTitle': '确定要删除以下示例吗？',
  'pages.review.addAtLeastOneQuestion': '提交前请至少添加一个问题。',
  'pages.review.addAtLeastOneQuestionFirst': '请先至少添加一个问题。',
  'pages.review.addAtLeastOneQuestionRule': '请至少添加一个问题',
  'pages.review.addQuestionButton': '问题',
  'pages.review.addSectionButton': '章节',
  'pages.review.addToMatters': '添加到项目',
  'pages.review.adhocModifyMode': '临时修改',
  'pages.review.audiencePlaceholder': '客户或目标受众名称',
  'pages.review.authorLabel': '作者',
  'pages.review.categoryLabel': '类别',
  'pages.review.cellDetailsDrawer.addCommentPlaceholder': '添加评论...',
  'pages.review.cellDetailsDrawer.answer': '答案',
  'pages.review.cellDetailsDrawer.comments': '评论',
  'pages.review.cellDetailsDrawer.commentsWithCount': '评论（{count}）',
  'pages.review.cellDetailsDrawer.exactMatch': '在源文档中找到完全匹配项',
  'pages.review.cellDetailsDrawer.explanation': '说明',
  'pages.review.cellDetailsDrawer.fullReference': '完整引用',
  'pages.review.cellDetailsDrawer.fuzzyMatch': '在源文档中找到近似匹配项',
  'pages.review.cellDetailsDrawer.openDocument': '打开文档',
  'pages.review.cellDetailsDrawer.openInSearch': '在搜索中打开',
  'pages.review.cellDetailsDrawer.verified': '已核实',
  'pages.review.cellDetailsDrawer.verify': '核实',
  'pages.review.cellMarkedUnverified': '单元格已标记为未核实',
  'pages.review.cellMarkedVerified': '单元格已标记为已核实',
  'pages.review.cellUpdateFailed': '更新单元格失败',
  'pages.review.cellUpdatedSuccessfully': '单元格更新成功',
  'pages.review.cellVerificationUpdateFailed': '更新单元格核实状态失败',
  'pages.review.changesUndone': '已撤销更改',
  'pages.review.chatWithEntireOutput': '与完整输出对话',
  'pages.review.cloneButton': '克隆',
  'pages.review.clonedNamePrefix': '已克隆 - {name}',
  'pages.review.columnEditModal.addTitle': '添加新文档（列）',
  'pages.review.columnEditModal.columnUpdated': '列更新已开始，列内容将很快刷新。',
  'pages.review.columnEditModal.columnsAdded': '已添加新列，矩阵将很快刷新。',
  'pages.review.columnEditModal.dropToUpload': '将文件拖放到此处以上传',
  'pages.review.columnEditModal.fileRequired': '请上传或选择要用于此列的文件。',
  'pages.review.columnEditModal.filesRequiredValidation': '请上传文件或选择现有文件',
  'pages.review.columnEditModal.updateFailed': '更新列失败',
  'pages.review.columnEditModal.updateTitle': '为此列新建文档',
  'pages.review.createQuestionListButton': '创建问题列表',
  'pages.review.createdByYou': '您',
  'pages.review.customInstruction': '自定义指令',
  'pages.review.customInstructionOptional': '自定义指令（选填）',
  'pages.review.deleteQuestionListConfirm': '确定要删除此问题列表吗？',
  'pages.review.downloadExcel': 'Excel (.xlsx)',
  'pages.review.downloadWord': 'Word (.docx)',
  'pages.review.dragHereToUpload': '拖拽至此上传',
  'pages.review.exitButton': '退出',
  'pages.review.exitClone': '退出克隆',
  'pages.review.exitCreate': '退出创建',
  'pages.review.exitModify': '退出修改',
  'pages.review.fileCount': '{count} 个文件',
  'pages.review.mattersUpdateFailed': '更新项目失败',
  'pages.review.mattersUpdated': '项目更新成功',
  'pages.review.modifyButton': '修改',
  'pages.review.newCategoryPlaceholder': '新建分类',
  'pages.review.newQuestionListDefaultName': '新审查问题清单',
  'pages.review.noEmailOnFile': '暂无留存邮箱',
  'pages.review.noNotesAvailable': '暂无备注。',
  'pages.review.noPrivateGroupsFound': '未找到私密小组',
  'pages.review.noPurposeAvailable': '暂无用途说明。',
  'pages.review.noQuestionsYet': '暂无问题。',
  'pages.review.notesLabel': '备注',
  'pages.review.pendingApproval': '待审批',
  'pages.review.pollingTimeout': '轮询超时。审查可能仍在处理中。',
  'pages.review.publishButton': '发布',
  'pages.review.publishFailed': '发布问题清单失败',
  'pages.review.publishTargetFirm': '全所范围',
  'pages.review.publishToLabel': '发布至:',
  'pages.review.publishedAccess.firm': '律所',
  'pages.review.publishedAccess.privateGroup': '私密小组',
  'pages.review.publishedAccess.public': '公开',
  'pages.review.publishedToLabel': '已发布至 {access}',
  'pages.review.publishedToPrivateGroup': '问题清单已发布至私密小组',
  'pages.review.publishedToPrivateGroups': '问题清单已发布至多个私密小组',
  'pages.review.purposeLabel': '用途',
  'pages.review.questionListCloned': '问题清单克隆成功',
  'pages.review.questionListCreated': '问题清单创建成功',
  'pages.review.questionListDeleted': '问题清单删除成功',
  'pages.review.questionListImporter.allColumns': '所有列(合并每个单元格)',
  'pages.review.questionListImporter.checklistText': '清单文本',
  'pages.review.questionListImporter.checklistTextPlaceholder': '在此粘贴清单,每行一项要求。',
  'pages.review.questionListImporter.columnOption': '第 {index} 列 - {label}',
  'pages.review.questionListImporter.couldNotParse': '无法解析该清单。',
  'pages.review.questionListImporter.couldNotReadFile': '无法读取 {fileName}。',
  'pages.review.questionListImporter.docxColumn': 'DOCX 列',
  'pages.review.questionListImporter.dropZoneText': '点击或拖拽清单文件至此区域',
  'pages.review.questionListImporter.granularityEveryLine': '每行作为一个问题',
  'pages.review.questionListImporter.granularityLevel2': '细化至第 2 级',
  'pages.review.questionListImporter.granularityLevel3': '细化至第 3 级',
  'pages.review.questionListImporter.granularityLevel4': '细化至第 4 级',
  'pages.review.questionListImporter.granularityLevel5': '细化至第 5 级',
  'pages.review.questionListImporter.granularityTopLevel': '仅顶层',
  'pages.review.questionListImporter.groupByLevel': '按层级对问题分组',
  'pages.review.questionListImporter.importQuestions': '导入问题',
  'pages.review.questionListImporter.importQuestionsAction': '导入问题',
  'pages.review.questionListImporter.loadedFile': '已加载 {fileName}',
  'pages.review.questionListImporter.noQuestionsDetected': '在该清单中未检测到任何问题。',
  'pages.review.questionListImporter.noQuestionsSelected': '未选择要导入的问题。',
  'pages.review.questionListImporter.pasteOrSelectRequired': '请先粘贴或选择清单,然后再预览。',
  'pages.review.questionListImporter.previewQuestions': '预览问题',
  'pages.review.questionListImporter.questionGranularity': '问题粒度',
  'pages.review.questionListImporter.readingChecklist': '正在读取清单...',
  'pages.review.questionListImporter.removeFile': '移除文件',
  'pages.review.questionListImporter.removeQuestion': '移除问题 {number}',
  'pages.review.questionListImporter.removeQuestionsHint': '移除任何不希望导入的问题。',
  'pages.review.questionListImporter.reviewQuestions': '审查问题',
  'pages.review.questionListNamePlaceholder': '审查问题清单名称',
  'pages.review.questionListUpdated': '问题清单更新成功',
  'pages.review.questionNamePlaceholder': '问题',
  'pages.review.questionRow.dragToReorder': '拖拽以重新排序',
  'pages.review.questionRow.moveDown': '下移',
  'pages.review.questionRow.moveUp': '上移',
  'pages.review.questionRow.rowType': '行类型',
  'pages.review.questionsList': '问题清单',
  'pages.review.quickQuestionsDescription': '根据一组临时问题,对一个或多个文档生成结构化审查',
  'pages.review.quickQuestionsHeading': '快速提问',
  'pages.review.rejected': '已拒绝',
  'pages.review.resizeHint': '拖拽边框以调整大小。',
  'pages.review.restoreConfigFailed': '恢复配置失败,请重试。',
  'pages.review.resultPanel.processing': '处理中',
  'pages.review.resultPanel.stopped': '处理已停止。',
  'pages.review.reuseButton': '复用',
  'pages.review.rowEditModal.addTitle': '添加新问题(行)',
  'pages.review.rowEditModal.promptLabel': '提示词',
  'pages.review.rowEditModal.promptRequired': '请输入提示词。',
  'pages.review.rowEditModal.rowAdded': '新行已添加,矩阵将很快刷新。',
  'pages.review.rowEditModal.rowUpdated': '行更新已开始,该行将很快刷新。',
  'pages.review.rowEditModal.updateFailed': '更新行失败',
  'pages.review.rowEditModal.updateTitle': '更新问题提示词',
  'pages.review.saveAsButton': '另存为',
  'pages.review.saveChangesButton': '保存更改',
  'pages.review.searchMattersPlaceholder': '搜索项目...',
  'pages.review.sectionNamePlaceholder': '章节标题',
  'pages.review.selectCellHint': '点击单元格、行或列以选中。',
  'pages.review.selectDocumentsToReview': '选择您希望审查的文档',
  'pages.review.selectDocumentsToReviewNumbered': '2. 选择您希望审查的文档',
  'pages.review.selectMatters': '选择项目:',
  'pages.review.selectPrivateGroupsHint': '选择一个或多个要共享的私密小组:',
  'pages.review.selectPrivateGroupsPlaceholder': '选择私密小组',
  'pages.review.sentForApproval': '问题清单已提交审批',
  'pages.review.sentimentLegendPrefix': '图例:AI 的情感倾向:',
  'pages.review.sentimentNegative': '负面',
  'pages.review.sentimentPositive': '正面',
  'pages.review.showAll': '显示全部',
  'pages.review.startNewReview': '开始新的审查',
  'pages.review.stayButton': '留在此页',
  'pages.review.submitReviewFailed': '提交审查失败',
  'pages.review.systemPromptLabel': '系统提示词',
  'pages.review.tabs.customiseOptional': '自定义(可选)',
  'pages.review.tabs.prompts': '提示词',
  'pages.review.tabs.selectDocuments': '选择文档',
  'pages.review.tabs.startHere': '从这里开始',
  'pages.review.typeHerePlaceholder': '在此输入...',
  'pages.review.undoChangesButton': '撤销更改',
  'pages.review.unsavedChangesWillBeLost': '未保存的更改将会丢失。',
  'pages.review.untitledSession': '(未命名)',
  'pages.review.updateFailed': '更新失败',
  'pages.review.viewMode': '查看',
  'pages.review.whatsNewDescription': '推出多项新功能,提升您的文档审查体验。',
  'pages.review.whoIsItFor': '适用对象?',
  'pages.review.whoIsItForNumbered': '1. 适用对象?',
  'pages.scribe.addToMatters': '添加到项目',
  'pages.scribe.aiWorking': 'AI 正在处理...',
  'pages.scribe.appDescription': '将音频文件或录音转录为结构化文本。',
  'pages.scribe.audioUploadFailedSavingOnly': '音频文件上传失败,仅保存转录文本',
  'pages.scribe.audioUploadSuccess': '音频文件上传成功',
  'pages.scribe.autoDetect': '自动检测',
  'pages.scribe.autoGenerateFailed': '自动生成所选输出失败',
  'pages.scribe.autoRecordingName': '录音 {timestamp}',
  'pages.scribe.autoSavedNote': '已自动保存 {relative}({time})',
  'pages.scribe.convertingEllipsis': '转换中...',
  'pages.scribe.customLanguageFallback': '自定义',
  'pages.scribe.deleteConfirm.content': '确定要删除此转录文本吗?',
  'pages.scribe.deleteConfirm.title': '删除转录文本',
  'pages.scribe.deleteTranscriptFailed': '删除转录文本失败',
  'pages.scribe.discardChangesConfirm.cancelText': '继续编辑',
  'pages.scribe.discardChangesConfirm.content': '您有未保存的编辑内容,是否放弃?',
  'pages.scribe.discardChangesConfirm.okText': '放弃',
  'pages.scribe.discardChangesConfirm.title': '放弃更改?',
  'pages.scribe.downloadAudio': '下载音频',
  'pages.scribe.downloadFailed': '下载失败',
  'pages.scribe.downloadScript': '下载转录稿',
  'pages.scribe.downloadStarted': '下载已开始',
  'pages.scribe.downloadingAudio': '正在下载音频...',
  'pages.scribe.enterTranscriptNamePlaceholder': '输入转录文本名称',
  'pages.scribe.errors.authTokenFailed': '获取身份验证令牌失败',
  'pages.scribe.errors.startRecordingFailed': '开始录音失败',
  'pages.scribe.exitRecordingConfirm.cancelText': '继续录音',
  'pages.scribe.exitRecordingConfirm.content': '转录文本将不会被保存。',
  'pages.scribe.exitRecordingConfirm.okText': '退出录音',
  'pages.scribe.exitRecordingConfirm.title': '退出录音?',
  'pages.scribe.exitRecordingPopconfirm.description': '退出录音?转录文本将不会被保存。',
  'pages.scribe.fastForward10': '快进 10 秒',
  'pages.scribe.fileUploadFailed': '{fileName} 文件上传失败。',
  'pages.scribe.fileUploadSuccess': '文件上传成功,已开始处理。',
  'pages.scribe.generateButton': '生成',
  'pages.scribe.generationFailedRetryText': '生成失败,请尝试重新生成。',
  'pages.scribe.generationStarted': '已开始生成',
  'pages.scribe.historyButton': '历史记录',
  'pages.scribe.homeButton': '主页',
  'pages.scribe.initializingTranscription': '正在初始化转录...',
  'pages.scribe.interruptedModal.okText': '查看转录内容',
  'pages.scribe.interruptedModal.title': '录音已中断',
  'pages.scribe.langGroup.custom': '自定义',
  'pages.scribe.langGroup.everythingElse': '其他所有语言',
  'pages.scribe.langGroup.otherOption': '其他…',
  'pages.scribe.langGroup.preferred': '常用',
  'pages.scribe.langGroup.seaEastAsian': '东南亚 + 东亚',
  'pages.scribe.languageSelector.addLanguageButton': '添加语言',
  'pages.scribe.languageSelector.customPlaceholder': '输入语言(例如马来语)',
  'pages.scribe.liveTranslationLabel': '实时翻译',
  'pages.scribe.loadingAudio': '正在加载音频...',
  'pages.scribe.mattersUpdatedSuccess': '项目更新成功',
  'pages.scribe.modeNotGenerated': '{modeLabel}尚未生成',
  'pages.scribe.nameYourTranscriptPlaceholder': '为转录内容命名',
  'pages.scribe.newRecordingTitle': '新建录音',
  'pages.scribe.newTranscript': '新建转录',
  'pages.scribe.newTranscriptName': '新转录 {timestamp}',
  'pages.scribe.noAudioFileAvailable': '暂无可用的音频文件。',
  'pages.scribe.noAudioForDownload': '暂无可下载的音频文件。',
  'pages.scribe.noContentAvailable': '暂无可用内容,请重新生成。',
  'pages.scribe.noOutputsGenerated': '未生成任何输出内容',
  'pages.scribe.noRecentRecordings': '暂无最近录音。',
  'pages.scribe.noSegmentsToEdit': '没有可编辑的片段',
  'pages.scribe.noTimestampedSegments': '没有带时间戳的转录片段。',
  'pages.scribe.notAvailable': '不适用',
  'pages.scribe.optionEmailDrafts': '邮件草稿',
  'pages.scribe.outputNotGeneratedYet': '此输出内容尚未生成。',
  'pages.scribe.outputViewer.actionItemsLabel': '行动事项',
  'pages.scribe.outputViewer.addActionItemButton': '添加行动事项',
  'pages.scribe.outputViewer.columnAction': '操作',
  'pages.scribe.outputViewer.columnAssignee': '负责人',
  'pages.scribe.outputViewer.columnDueDate': '截止日期',
  'pages.scribe.outputViewer.columnTask': '任务',
  'pages.scribe.outputViewer.commaSeparatedNamesPlaceholder': '以逗号分隔的姓名',
  'pages.scribe.outputViewer.fieldBody': '正文',
  'pages.scribe.outputViewer.fieldCategory': '类别',
  'pages.scribe.outputViewer.fieldCleanedTranscript': '整理后的转录文本',
  'pages.scribe.outputViewer.fieldExecutiveSummary': '摘要总结',
  'pages.scribe.outputViewer.fieldGeneratedTitle': '生成的标题',
  'pages.scribe.outputViewer.fieldKeyDecisions': '关键决策',
  'pages.scribe.outputViewer.fieldNextMeeting': '下次会议',
  'pages.scribe.outputViewer.fieldParticipants': '参与人员',
  'pages.scribe.outputViewer.fieldRecipients': '收件人',
  'pages.scribe.outputViewer.fieldSignatureBlock': '签名栏',
  'pages.scribe.outputViewer.fieldSubject': '主题',
  'pages.scribe.outputViewer.fieldTopic': '议题',
  'pages.scribe.outputViewer.generatingContent': '正在生成内容...',
  'pages.scribe.outputViewer.generationFailed': '生成失败',
  'pages.scribe.outputViewer.onePerLinePlaceholder': '每行一项',
  'pages.scribe.outputViewer.pleaseCheckFields': '请检查填写的字段',
  'pages.scribe.outputViewer.titleDefault': '输出内容',
  'pages.scribe.outputViewer.titleEmailDraft': '邮件草稿',
  'pages.scribe.outputViewer.titleMeetingNotes': '会议记录',
  'pages.scribe.outputViewer.titleVoiceMemo': '语音备忘录',
  'pages.scribe.outputViewer.unknownOutputType': '未知的输出类型',
  'pages.scribe.pauseRecordingTitle': '暂停录音',
  'pages.scribe.recentRecordingsTitle': '最近录音',
  'pages.scribe.recentlyTranscribed': '最近转录',
  'pages.scribe.recordingInProgressWarning': '您当前正在录音中,请先停止录音,再切换会话',
  'pages.scribe.recordingPaused': '录音已暂停',
  'pages.scribe.recordingPausedInline': '录音已暂停',
  'pages.scribe.regenerateButton': '重新生成',
  'pages.scribe.resumeRecordingTitle': '恢复录音',
  'pages.scribe.retranslatingSegments': '正在重新翻译已编辑的片段...',
  'pages.scribe.fillingMissingTranslations': '正在翻译缺失的片段...',
  'pages.scribe.rewind10': '快退 10 秒',
  'pages.scribe.saveEditsFailed': '保存转录内容编辑失败',
  'pages.scribe.saveFailed': '保存失败',
  'pages.scribe.saveTranscriptFailed': '保存转录内容失败',
  'pages.scribe.saveTranscriptModalTitle': '保存转录内容',
  'pages.scribe.saveTranscriptTitle': '保存转录内容',
  'pages.scribe.savedSuccessfully': '保存成功',
  'pages.scribe.savingTranscript': '正在保存转录内容...',
  'pages.scribe.scribeTitle': '录音',
  'pages.scribe.scrollToBottom': '滚动到底部',
  'pages.scribe.searchMattersPlaceholder': '搜索项目...',
  'pages.scribe.searchTranscriptsPlaceholder': '搜索转录内容',
  'pages.scribe.segmentTranslationFailed': '片段翻译失败',
  'pages.scribe.selectMattersLabel': '选择项目:',
  'pages.scribe.startGenerationFailed': '启动生成失败',
  'pages.scribe.startTranscriptionFailed': '启动转录流程失败',
  'pages.scribe.status.clickMicToStart': '点击麦克风图标开始录音',
  'pages.scribe.status.defaultDescription': '将音频文件或录音转录为结构化文本',
  'pages.scribe.status.processingFile': '正在处理文件...{stage}',
  'pages.scribe.status.queued': '排队中',
  'pages.scribe.status.transcriptionCancelled': '转录已取消',
  'pages.scribe.status.transcriptionCompleted': '转录已完成',
  'pages.scribe.status.transcriptionFailed': '转录失败',
  'pages.scribe.stopRecordingConfirm.cancelText': '留在此页',
  'pages.scribe.stopRecordingConfirm.okText': '离开页面',
  'pages.scribe.stopRecordingConfirm.title': '是否停止录音?',
  'pages.scribe.stopRecordingSaveTitle': '停止录音并保存',
  'pages.scribe.tabs.emailDraft': '邮件草稿',
  'pages.scribe.tabs.meetingNotes': '会议记录',
  'pages.scribe.tabs.rawTranscript': '原始转录内容',
  'pages.scribe.tabs.voiceMemo': '语音备忘录',
  'pages.scribe.transcriptDeleted': '转录内容已删除',
  'pages.scribe.transcriptEmpty': '转录内容为空',
  'pages.scribe.transcriptNameUpdated': '转录名称已更新',
  'pages.scribe.transcriptSavedSuccess': '转录内容保存成功',
  'pages.scribe.transcriptUpdated': '转录内容已更新',
  'pages.scribe.transcriptionFailedDesc': 'Scribe 未能转录此音频。请尝试下载音频文件后重新上传。',
  'pages.scribe.transcriptionFailedTitle': '转录失败',
  'pages.scribe.transcriptionLanguageQuestion': '转录应使用哪种语言?',
  'pages.scribe.transcriptionPurposeQuestion': '此次转录的用途是什么?',
  'pages.scribe.translatingEllipsis': '正在翻译...',
  'pages.scribe.increaseTranslationSize': '放大翻译文字',
  'pages.scribe.decreaseTranslationSize': '缩小翻译文字',
  'pages.scribe.translationTextSize': '翻译文字大小',
  'pages.scribe.unassigned': '未分配',
  'pages.scribe.unnamedTranscript': '未命名转录',
  'pages.scribe.untitled': '无标题',
  'pages.scribe.untitledParens': '(无标题)',
  'pages.scribe.untitledTranscript': '无标题转录',
  'pages.scribe.updateMattersFailed': '更新项目失败',
  'pages.scribe.updateNameFailed': '更新转录名称失败',
  'pages.scribe.updateTranscriptNameTitle': '更新转录名称',
  'pages.scribe.uploadRecordingButton': '上传录音',
  'pages.scribe.uploadingAudioFile': '正在上传音频文件...',
  'pages.scribe.waitingEllipsis': '等待中...',
  'pages.scribe.waitingForTranslations': '正在等待翻译完成...',
  'pages.scribe.whatsNew': '新功能',
  'pages.scribe.whatsNew.filteringSortingDesc': '改进了用于管理和查找转录内容的界面。',
  'pages.scribe.whatsNew.filteringSortingLabel': '筛选与排序:',
  'pages.scribe.whatsNew.guidanceTabsDesc': '轻松找到入门指南或发现新功能的说明。',
  'pages.scribe.whatsNew.guidanceTabsLabel': '引导标签页:',
  'pages.scribe.whatsNew.intro': '我们对 Scribe 进行了升级,以提供更流畅的转录体验:',
  'pages.scribe.whatsNew.upcomingFeaturesTitle': '即将推出的功能',
  'pages.search.chunkCopiedSuccess': '分段已复制!',
  'pages.search.chunkCopyFailed': '分段复制失败',
  'pages.search.searchRatioLabel': '搜索比例',
  'pages.search.favouriteFileWeightLabel': '收藏文件权重',
  'pages.search.rerankLabel': '重新排序',
  'pages.search.filePreviewAlt': '文件预览',
  'pages.search.previewNotSupported': '此文件类型不支持预览',
  'pages.search.chunkPageLabel': '页码: {pageNumber}',
  'pages.search.matchPercentage': '匹配度 {score}%',
  'pages.search.openChunkAriaLabel': '打开分段 {index}',
  'pages.search.navigateResultsTitle': '浏览结果',
  'pages.search.loadingChunkResults': '正在加载分段结果...',
  'pages.search.chunkResultCount': '{count, plural, other {分段结果}}',
  'pages.search.previousResultTitle': '上一个结果',
  'pages.search.nextResultTitle': '下一个结果',
  'pages.search.chatWithDocumentButton': '与此文档对话',
  'pages.search.searchWithinDocumentPlaceholder': '在文档内搜索...',
  'pages.search.filterDownLabel': '缩小筛选范围',
  'pages.search.documentPreviewTitle': '文档预览',
  'pages.search.askAgelPlaceholder': '询问 A&GEL',
  'pages.search.searchAllButton': '搜索全部',
  'pages.search.advancedSettingsButton': '高级设置',
  'pages.search.allTagsOption': ' 所有标签',
  'pages.sideBySide.addAtLeastOneQuestion': '请至少添加一个问题',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting': '提交前请至少添加一个问题。',
  'pages.sideBySide.addNewQuestionsPlaceholder': '添加新问题(每行一个)',
  'pages.sideBySide.addPlusButton': '添加 +',
  'pages.sideBySide.addQuestionsLabel': '添加问题',
  'pages.sideBySide.addToMattersButton': '添加到项目',
  'pages.sideBySide.authorFieldLabel': '作者',
  'pages.sideBySide.authorLabel': '作者: ',
  'pages.sideBySide.categoryLabel': '类别',
  'pages.sideBySide.cellDetails.answer': '答案',
  'pages.sideBySide.cellDetails.verified': '已验证',
  'pages.sideBySide.cellDetails.verify': '验证',
  'pages.sideBySide.cellMarkedUnverified': '单元格已标记为未验证',
  'pages.sideBySide.cellMarkedVerified': '单元格已标记为已验证',
  'pages.sideBySide.cellUpdatedSuccess': '单元格更新成功',
  'pages.sideBySide.changesUndone': '更改已撤销',
  'pages.sideBySide.clickOrDragToUpload': '点击或拖拽上传',
  'pages.sideBySide.cloneButton': '克隆',
  'pages.sideBySide.cloneModeLabel': '克隆',
  'pages.sideBySide.clonedNamePrefix': '已克隆 - {name}',
  'pages.sideBySide.columnEditModal.columnAddedSuccess': '新列已添加,矩阵即将刷新。',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess': '列更新已开始,该列即将刷新。',
  'pages.sideBySide.columnEditModal.enterPromptWarning': '请输入提示词。',
  'pages.sideBySide.columnEditModal.promptLabel': '提示词',
  'pages.sideBySide.columnEditModal.promptPlaceholder': '描述该列的提示词/系统指令',
  'pages.sideBySide.columnEditModal.title': '修改列',
  'pages.sideBySide.columnEditModal.updateColumnFailed': '列更新失败',
  'pages.sideBySide.createCustomQuestionListDescription': '为此会话创建自定义的并排对比问题列表',
  'pages.sideBySide.createModeLabel': '创建',
  'pages.sideBySide.createQuestionListButton': '创建问题列表',
  'pages.sideBySide.createdByLabel': '创建者: ',
  'pages.sideBySide.createdByYou': '您',
  'pages.sideBySide.customInstructionOptional': '2. 自定义说明(可选)',
  'pages.sideBySide.deleteQuestionListConfirm': '确定要删除此问题列表吗?',
  'pages.sideBySide.dragHereToUpload': '拖拽至此处上传',
  'pages.sideBySide.emailButton': '电子邮件',
  'pages.sideBySide.exitButton': '退出',
  'pages.sideBySide.exitModeButton': '退出 {mode}',
  'pages.sideBySide.fileCount': '{count} 个文件',
  'pages.sideBySide.firmOption': '律所',
  'pages.sideBySide.firmWideOption': '全所范围',
  'pages.sideBySide.fromDocumentOption': '来自文档',
  'pages.sideBySide.groupOption': '群组',
  'pages.sideBySide.leadRowHeader': '源文档段落',
  'pages.sideBySide.manualCraftOption': '手动创建',
  'pages.sideBySide.modifyButton': '修改',
  'pages.sideBySide.modifyModeLabel': '修改',
  'pages.sideBySide.newCategoryPlaceholder': '新类别',
  'pages.sideBySide.newQuestionListButtonLabel': '新建并排对比问题列表',
  'pages.sideBySide.newQuestionListDefaultName': '新建并排对比问题列表',
  'pages.sideBySide.noNotesAvailable': '暂无备注。',
  'pages.sideBySide.noPurposeAvailable': '暂无用途说明。',
  'pages.sideBySide.noSystemPromptConfigured': '尚未配置系统提示词。',
  'pages.sideBySide.notesFieldLabel': '备注',
  'pages.sideBySide.notesLabel': '备注: ',
  'pages.sideBySide.pendingApprovalTag': '待审批',
  'pages.sideBySide.pollingTimeoutWarning': '轮询超时。并排对比可能仍在处理中。',
  'pages.sideBySide.processing': '处理中',
  'pages.sideBySide.processingStopped': '处理已停止。',
  'pages.sideBySide.publicOption': '公开',
  'pages.sideBySide.publishButton': '发布',
  'pages.sideBySide.publishQuestionListFailed': '问题列表发布失败',
  'pages.sideBySide.publishStatusLabel': '发布状态',
  'pages.sideBySide.publishToLabel': '发布至:',
  'pages.sideBySide.publishedToAccess': '已发布至 {access}',
  'pages.sideBySide.publishedToGroupSuccess': '问题列表已发布至群组',
  'pages.sideBySide.publishedToPrivateGroups': '问题列表已发布至私有群组',
  'pages.sideBySide.publisherLabel': '发布者: ',
  'pages.sideBySide.purposeFieldLabel': '用途',
  'pages.sideBySide.purposeLabel': '用途: ',
  'pages.sideBySide.questionListClonedSuccess': '问题列表克隆成功',
  'pages.sideBySide.questionListCreatedSuccess': '问题列表创建成功',
  'pages.sideBySide.questionListDeletedSuccess': '问题列表删除成功',
  'pages.sideBySide.questionListNamePlaceholder': '并排对比问题列表名称',
  'pages.sideBySide.questionListUpdatedSuccess': '问题列表更新成功',
  'pages.sideBySide.questionsListLabel': '问题列表',
  'pages.sideBySide.quickQuestionsTitle': '快速提问',
  'pages.sideBySide.rejectedTag': '已拒绝',
  'pages.sideBySide.restoreConfigurationFailed': '配置恢复失败,请重试。',
  'pages.sideBySide.reuseButton': '重复使用',
  'pages.sideBySide.reviewTemplateQuestionsDescription': '查看此模板的问题',
  'pages.sideBySide.saveChangesButton': '保存更改',
  'pages.sideBySide.selectDocumentDescription': '选择您要进行并排对比的文档',
  'pages.sideBySide.selectGroupsPlaceholder': '选择群组',
  'pages.sideBySide.selectGroupsToShareDescription': '选择要共享给的一个或多个群组:',
  'pages.sideBySide.selectionDescription': '根据您的问题列表,为一个或多个文档生成结构化的并排对比',
  'pages.sideBySide.selectionFeatureName': '并排对比',
  'pages.sideBySide.selectionTitle': '并排对比',
  'pages.sideBySide.sentForApprovalSuccess': '问题列表已提交审批',
  'pages.sideBySide.showQuestionsButton': '显示问题',
  'pages.sideBySide.startGenerateReview': '开始生成审查',
  'pages.sideBySide.startNewSideBySideButton': '开始新的并排对比',
  'pages.sideBySide.stayButton': '留在此页',
  'pages.sideBySide.submitFailed': '并排对比提交失败',
  'pages.sideBySide.systemPromptLabel': '系统提示词',
  'pages.sideBySide.tabs.prompts': '提示词',
  'pages.sideBySide.tabs.questionList': '问题列表',
  'pages.sideBySide.tabs.selectDocuments': '选择文档',
  'pages.sideBySide.targetAudiencePlaceholder': '客户名称或目标受众',
  'pages.sideBySide.teamsButton': '团队',
  'pages.sideBySide.templateSystemPromptLabel': '模板系统提示词',
  'pages.sideBySide.tour.step1.title': '选择问题列表',
  'pages.sideBySide.tour.step2.title': '填写目标受众并选择文件',
  'pages.sideBySide.tour.step3.title': '查看系统提示词和问题',
  'pages.sideBySide.tour.step4.title': '查看并排对比结果',
  'pages.sideBySide.typeHerePlaceholder': '在此输入...',
  'pages.sideBySide.undoChangesButton': '撤销更改',
  'pages.sideBySide.unsavedChangesWillBeLost': '任何未保存的更改都将丢失。',
  'pages.sideBySide.untitled': '(未命名)',
  'pages.sideBySide.updateCellFailed': '单元格更新失败',
  'pages.sideBySide.updateCellVerificationFailed': '单元格验证状态更新失败',
  'pages.sideBySide.updateFailed': '更新失败',
  'pages.sideBySide.uploadDocumentFailed': '文档上传失败',
  'pages.sideBySide.whatsNewDescription': '我们推出了多项新功能，以提升您的文档对照体验。',
  'pages.sideBySide.whoIsItForQuestion': '1. 适用对象？',
  'pages.template.waitingMessage.justAMoment': '请稍候...',
  'pages.template.waitingMessage.fetchingThatForYou': '正在为您获取内容...',
  'pages.template.waitingMessage.hangTight': '别急，马上处理...',
  'pages.template.waitingMessage.letMeCheck': '让我查一下...',
  'pages.template.waitingMessage.oneSecPlease': '请稍等片刻...',
  'pages.template.waitingMessage.lookingThatUp': '正在为您查找...',
  'pages.template.waitingMessage.almostThere': '即将完成...',
  'pages.template.waitingMessage.holdOnRetrieving': '请稍候，正在获取信息...',
  'pages.template.waitingMessage.workingOnIt': '正在处理中...',
  'pages.template.dragDropUpload': '拖拽至此处上传',
  'pages.template.uploadInvalidFileTypes': '请仅上传 PDF、DOC、DOCX、MSG、EML、TXT 或 MD 文件',
  'pages.template.fileUploadedSuccess': '{fileName} 上传成功',
  'pages.template.fileUploadFailed': '{fileName} 上传失败',
  'pages.template.loadTemplateDetailsFailed': '加载模板详情失败',
  'pages.template.viewLess': '收起',
  'pages.template.viewAll': '查看全部',
  'pages.template.tour.step1Title': '选择自定义输出模板',
  'pages.template.tour.step1Description': '首先从可用类别中选择一个模板预设。',
  'pages.template.tour.step2Title': '选择要分析的文件',
  'pages.template.tour.step2Description': '上传或选择您要执行自定义输出的文档。',
  'pages.template.tour.step3Title': '查看提示与说明',
  'pages.template.tour.step3Description': '在此提供目标受众信息及可选的自定义说明。',
  'pages.template.tour.step4Title': '查看结果',
  'pages.template.tour.step4Description': '提交后，生成的自定义输出将显示在此区域。',
  'pages.template.noSessionsFound': '未找到模板会话。请运行一次以查看结果。',
  'pages.template.startNewCustomOutput': '开始新的自定义输出',
  'pages.template.untitled': '（未命名）',
  'pages.template.newSession': '新建会话',
  'pages.template.fileCount': '{count} 个文件',
  'pages.template.reuseButton': '重新使用',
  'pages.template.addToMattersButton': '添加到项目',
  'pages.template.startFillingTemplates': '开始填写模板',
  'pages.template.unsavedChangesWarning': '未保存的更改将会丢失。',
  'pages.template.stayButton': '留在此页',
  'pages.template.exitButton': '退出',
  'pages.template.undoChangesButton': '撤销更改',
  'pages.template.changesUndoneMessage': '更改已撤销',
  'pages.template.templateCreatedSuccess': '模板创建成功',
  'pages.template.templateUpdatedSuccess': '模板更新成功',
  'pages.template.fillRequiredFields': '请填写所有必填字段',
  'pages.template.saveTemplateFailed': '模板保存失败',
  'pages.template.createTemplateButton': '创建模板',
  'pages.template.saveTemplateButton': '保存模板',
  'pages.template.presetNamePlaceholder': '自定义模板预设名称',
  'pages.template.categoryLabel': '类别',
  'pages.template.newCategoryPlaceholder': '新类别',
  'pages.template.addCategoryButton': '添加类别',
  'pages.template.purposeLabel': '用途',
  'pages.template.notesLabel': '备注',
  'pages.template.systemPromptLabel': '系统提示词',
  'pages.template.typeProse': '文本',
  'pages.template.typeTable': '表格',
  'pages.template.tableTypeLabel': '表格类型',
  'pages.template.tableTypeTooltip': '“逐条款”和“逐文档”表格不支持用户自定义列。',
  'pages.template.tableTypeStandard': '标准',
  'pages.template.tableTypeDocument': '逐文档',
  'pages.template.tableTypeClause': '逐条款',
  'pages.template.columnsLabel': '列',
  'pages.template.newColumnButton': '新建列',
  'pages.template.exampleLabel': '示例',
  'pages.template.userDefinedLabel': '用户自定义',
  'pages.template.userDefinedColumnTooltip': '用户自定义列',
  'pages.template.columnTypeString': '字符串',
  'pages.template.columnTypeNumber': '数字',
  'pages.template.columnTypeDatetime': '日期时间',
  'pages.template.sectionsLabel': '章节',
  'pages.template.newSectionButton': '新建章节',
  'pages.template.headingColumnHeader': '标题',
  'pages.template.promptColumnHeader': '提示词',
  'pages.template.modifyButton': '修改',
  'pages.template.publishToLabel': '发布至：',
  'pages.template.publishFirmWide': '全所范围',
  'pages.template.publicAccessLabel': '公开',
  'pages.template.firmAccessLabel': '本所',
  'pages.template.publishButton': '发布',
  'pages.template.publishSentForApproval': '模板预设已提交审批',
  'pages.template.publishTemplateFailed': '模板发布失败',
  'pages.template.deleteConfirmQuestion': '确定要删除此模板吗？',
  'pages.template.templateDeletedSuccess': '模板删除成功',
  'pages.template.deleteTemplateFailed': '模板删除失败',
  'pages.template.customTemplateCreatedForSession': '已成功为此会话创建自定义模板',
  'pages.template.publishStatusLabel': '发布状态',
  'pages.template.pendingApprovalStatus': '待审批',
  'pages.template.rejectedStatus': '已拒绝',
  'pages.template.publishedToStatus': '已发布至 {target}',
  'pages.template.authorLabel': '作者',
  'pages.template.emailButton': '邮件',
  'pages.template.noPurposeAvailable': '暂无用途说明。',
  'pages.template.noNotesAvailable': '暂无备注。',
  'pages.template.startHereTab': '从这里开始',
  'pages.template.whoIsItForQuestion': '1. 适用对象？',
  'pages.template.clientAudiencePlaceholder': '客户名称或目标受众',
  'pages.template.selectDocumentsQuestion': '2. 选择要审阅的文档',
  'pages.template.customInstructionTab': '自定义说明（可选）',
  'pages.template.modifyPromptLabel': '修改提示词',
  'pages.template.typeHerePlaceholder': '请在此输入...',
  'pages.template.noSystemPromptConfigured': '尚未配置系统提示词。',
  'pages.template.exampleValuePrefix': '例如 {example}',
  'pages.template.customOutputTitle': '自定义输出',
  'pages.template.whatsNewButton': '新功能',
  'pages.template.tourButton': '导览',
  'pages.template.addNewCustomTemplateButton': '添加新的自定义模板',
  'pages.template.whatsNewModal.intro': '我们推出了多项新功能，以提升您的文档审阅流程：',
  'pages.template.whatsNewModal.improvedFilteringTitle': '筛选功能优化：',
  'pages.template.whatsNewModal.adhocQuestionsTitle': '临时问题：',
  'pages.template.whatsNewModal.adhocQuestionsBody': '更灵活地随时添加问题。',
  'pages.template.whatsNewModal.uiEnhancementsTitle': '界面优化：',
  'pages.template.whatsNewModal.uiEnhancementsBody': '更简洁、更直观的界面，便于管理您的模板。',
  'pages.template.upcomingFeaturesTitle': '即将推出的功能',
  'pages.template.upcomingFeaturesBody': '敬请期待更多更新，包括协同审阅和高级 AI 分析功能。',
  'pages.template.tourIndicator': '{current} / {total}',
  'pages.translation.addToMattersButton': '添加到项目',
  'pages.translation.batchFileCountLabel': '{count} 个文件',
  'pages.translation.batchTranslationStarted': '批量翻译已开始',
  'pages.translation.copiedSuccess': '已复制！',
  'pages.translation.couldNotResolveFile': '无法解析所选文件，请重新上传或选择文件。',
  'pages.translation.customInstructionTab': '自定义说明（可选）',
  'pages.translation.docxOrPdfOnly': '请仅选择 DOCX 或 PDF 文件。',
  'pages.translation.downloadFailed': '下载失败（{status}）',
  'pages.translation.dragHereToUpload': '拖拽至此处上传',
  'pages.translation.enterLanguageRequired': '请输入语言',
  'pages.translation.failedRenderOriginalPreview': '原文预览渲染失败',
  'pages.translation.failedRenderTranslatedPreview': '译文预览渲染失败',
  'pages.translation.failedToFetchDocx': '获取 DOCX 失败（{status}）',
  'pages.translation.failedToStartTranslation': '启动翻译失败',
  'pages.translation.failedToStartTranslationMissingId': '启动翻译失败（缺少 ID）',
  'pages.translation.fileCountLabel': '{count} 个文件',
  'pages.translation.filterFilesPlaceholder': '筛选文件',
  'pages.translation.liveTranslationHint': '在左侧输入，右侧即时显示翻译结果。',
  'pages.translation.liveTranslationTitle': '实时翻译',
  'pages.translation.modifyPromptLabel': '修改提示词',
  'pages.translation.failed': '翻译失败',
  'pages.translation.noPreviewAvailable': '暂无可用预览',
  'pages.translation.noFilesMatch': '没有与“{query}”匹配的文件',
  'pages.translation.noTranslatedDocumentYet': '暂无已翻译的文档。',
  'pages.translation.originalLabel': '原文',
  'pages.translation.viewSideBySide': '并排显示',
  'pages.translation.viewAlternating': '交替显示',
  'pages.translation.originalPdfTitle': '原始 PDF',
  'pages.translation.otherLanguagePlaceholder': '例如：泰米尔语',
  'pages.translation.outputLanguageStep': '2. 输出语言',
  'pages.translation.previewNotSupported': '目前预览仅支持 DOCX 和 PDF 文件。',
  'pages.translation.processingTitle': '处理中…',
  'pages.translation.processingTranslation': '正在处理翻译…',
  'pages.translation.promptOptionalLabel': '提示词（可选）',
  'pages.translation.recentlyTranslatedLabel': '最近翻译',
  'pages.translation.renderingOriginal': '正在渲染原文…',
  'pages.translation.renderingTranslation': '正在渲染译文…',
  'pages.translation.reuseButton': '复用',
  'pages.translation.searchTranslationsPlaceholder': '搜索翻译',
  'pages.translation.selectAtLeastOneDocument': '请上传或选择至少 1 份需要翻译的文档。',
  'pages.translation.selectAtMostDocuments': '请选择最多 {max} 份需要翻译的文档。',
  'pages.translation.selectDocumentStep': '1. 选择您要翻译的文档',
  'pages.translation.selectLanguagePlaceholder': '选择语言',
  'pages.translation.selectLanguageRequired': '请选择一种语言',
  'pages.translation.selectOutputLanguagePlaceholder': '选择一种输出语言',
  'pages.translation.selectOutputLanguageRequired': '请选择一种输出语言。',
  'pages.translation.startHereTab': '从这里开始',
  'pages.translation.startLiveTranslationButton': '开始实时翻译',
  'pages.translation.startNewTranslationButton': '开始新的翻译',
  'pages.translation.startTranslationButton': '开始翻译',
  'pages.translation.stopTranslationFailed': '停止翻译失败',
  'pages.translation.swapLanguagesTooltip': '交换语言',
  'pages.translation.title': '翻译',
  'pages.translation.translateButton': '翻译',
  'pages.translation.translatedLabel': '已翻译',
  'pages.translation.translatedPdfTitle': '已翻译的 PDF',
  'pages.translation.downloadAsPdf': 'PDF – 原始版式',
  'pages.translation.downloadAsWord': 'Word – 可编辑文本',
  'pages.translation.zoomIn': '放大',
  'pages.translation.zoomOut': '缩小',
  'pages.translation.fitWidth': '适合宽度',
  'pages.translation.translationFailedError': '翻译失败',
  'pages.translation.translationStoppedSuccess': '翻译已停止',
  'pages.translation.translationTaskStarted': '翻译任务已开始',
  'pages.translation.typeTextToTranslatePlaceholder': '输入要翻译的文本',
  'pages.translation.unknownLanguage': '未知',
  'pages.translation.untitledFallback': '(未命名)',
  'pages.translation.untitledTranslationFallback': '未命名翻译',
  'pages.user.passwordConfirmationPlaceholder': '确认密码',
  'pages.user.logoAlt': '徽标',
  'pages.user.emailPlaceholder': '邮箱',
  'pages.user.passwordPlaceholder': '密码',
  'pages.user.newPasswordPlaceholder': '新密码',
  'pages.user.forgotPassword.emailSentMessage': '如果该邮箱已注册,系统将很快发送一封邮件',
  'pages.user.forgotPassword.submitButton': '发送重置链接',
  'pages.user.resetPassword.successMessage': '您的密码已更新',
  'pages.user.resetPassword.submitButton': '重置密码',
  'pages.user.resetPassword.passwordRequired': '请输入密码',
  'pages.user.resetPassword.passwordMinLength': '长度至少为 8 个字符',
  'pages.user.resetPassword.passwordNeedsAlpha': '至少包含 1 个字母',
  'pages.user.resetPassword.passwordNeedsNumber': '至少包含 1 个数字',
  'pages.user.resetPassword.passwordNeedsSpecial': '至少包含 1 个特殊字符',
  'pages.user.resetPassword.confirmPasswordRequired': '请确认您的新密码!',
  'pages.user.resetPassword.passwordMismatch': '两次输入的密码不一致!',
  'pages.user.login.ssoNotConfigured': 'Microsoft SSO 配置有误',
  'pages.user.login.ssoAccountNotFound': '未找到 Microsoft SSO 账户',
  'pages.user.login.emailPasswordWrong': '邮箱/密码错误',
  'pages.user.login.contactAdminContent': '请联系您的管理员重置密码。',
  'pages.user.management.pageTitle': '管理',
  'pages.user.rolesLoadingPlaceholder': '正在加载角色...',
  'pages.user.selectRolePlaceholder': '选择角色',
  'pages.user.billing.seatsMinimumError': '席位数必须为大于或等于 1 的整数。',
  'pages.user.billing.contactRequiredError': '请填写账单联系人姓名和邮箱。',
  'pages.user.billing.renewOrChoosePlan': '续订/选择套餐',
  'pages.user.billing.switchPlanAction': '切换套餐',
  'pages.user.billing.subscribeAction': '订阅',
  'pages.user.billing.renewPlanAction': '续订套餐',
  'pages.user.billing.switchPlanModalTitle': '切换套餐',
  'pages.user.billing.renewThisPlanButton': '续订此套餐',
  'pages.user.billing.currentPlanButton': '当前套餐',
  'pages.user.billing.switchToThisPlanButton': '切换至此套餐',
  'pages.user.billing.subscribeToThisPlanButton': '订阅此套餐',
  'pages.user.billing.planText': '套餐',
  'pages.user.billing.selectedTag': '已选择',
  'pages.user.billing.totalLabel': '总计:',
  'pages.user.billing.billingContactTitle': '账单联系人',
  'pages.user.billing.billingContactHint': '结账付款和开具发票时需要此信息。',
  'pages.user.billing.fullNameLabel': '全名',
  'pages.user.billing.billingEmailLabel': '账单邮箱',
  'pages.user.billing.seatsLabel': '席位',
  'pages.user.billing.registeringTenantTitle': '正在注册 Microsoft 租户',
  'pages.user.billing.tenantStep1': '步骤 1/4:正在加载 Microsoft SSO 配置...',
  'pages.user.billing.ssoNotEnabledError': '尚未启用 Microsoft SSO,请联系您的管理员。',
  'pages.user.billing.tenantStep3': '步骤 3/4:正在与服务器核实租户令牌...',
  'pages.user.billing.tenantStep4': '步骤 4/4:正在将租户注册信息保存至您当前的组织...',
  'pages.user.billing.tenantRegistrationCompleteTitle': 'Microsoft 租户注册完成',
  'pages.user.billing.tenantAddedMessage': '成功。租户 ID {tenantId} 已添加至您的组织。',
  'pages.user.billing.tenantRegisterGenericError': '无法注册 Microsoft 租户,请重试。',
  'pages.user.billing.tenantRegistrationFailedTitle': 'Microsoft 租户注册失败',
  'pages.user.billing.tenantRegistrationIncompleteMessage': '注册未完成。{detail}',
  'pages.user.billing.loadInvoicesError': '无法加载发票。',
  'pages.user.billing.loadBillingDetailsError': '无法加载账单详情。',
  'pages.user.billing.openCheckoutError': '无法打开账单结账页面。',
  'pages.user.billing.seatChangeScheduledMessage': '席位变更已排期 — 将于下次续订时生效。',
  'pages.user.billing.seatsUpdatedMessage': '席位已更新。',
  'pages.user.billing.editSeatsModalTitle': '编辑席位',
  'pages.user.billing.saveSeatsButton': '保存席位',
  'pages.user.billing.currentTotalLabel': '当前总计',
  'pages.user.billing.previewTotalLabel': '预览总计',
  'pages.user.billing.differenceLabel': '与下次续订的差额',
  'pages.user.billing.invoices': '发票',
  'pages.user.billing.nextInvoiceDateLabel': '下次发票日期:',
  'pages.user.billing.invoiceColumn': '发票',
  'pages.user.billing.dueColumn': '到期日',
  'pages.user.billing.amountColumn': '金额',
  'pages.user.billing.downloadInvoiceError': '无法下载发票 PDF。',
  'pages.user.billing.membersSeatsLabel': '成员/席位',
  'pages.user.billing.scheduledTag': '已排期',
  'pages.user.billing.pendingSeatsNotice': '→ 自下次续订起为 {seats} 个席位',
  'pages.user.billing.editSeatsButton': '编辑席位',
  'pages.user.billing.currentPlanCardLabel': '当前套餐',
  'pages.user.billing.priceLabel': '价格:',
  'pages.user.billing.billingCardTitle': '账单',
  'pages.user.billing.nextInvoiceLabel': '下次发票',
  'pages.user.billing.registerMicrosoftTenantButton': '注册 Microsoft 租户',
  'pages.user.billing.contactOrgAdmin': '请联系您的组织管理员。',
  'pages.user.billing.graceDeadlineFallback': '宽限截止日期',
  'pages.user.billing.paymentIssueTitle': '付款问题',
  'pages.user.billing.subscriptionCancelledTitle': '订阅已取消。',
  'pages.user.billing.subscriptionInactiveTitle': '订阅未生效',
  'pages.angelInsider.basics.habits.habit1.intro':
    '新用户最常犯的错误，是低估了为 AI 工具提供足够初始信息的重要性。',
  'pages.angelInsider.basics.habits.habit2.intro':
    '理解大语言模型（LLM）的本质至关重要。它们并非真理数据库，也不能替代人类判断。相反，可以把 LLM 看作是处理语言和基础认知任务的高速 CPU 或处理器。',
  'pages.angelInsider.basics.welcome.intro':
    '很高兴您的加入。在您开始探索 A&GEL 之际，我们想分享一些想法，帮助您顺利起步。',
  'pages.angelInsider.basics.welcome.supportParagraph':
    '我们知道，熟悉新技术起初可能会有挑战。请记住：我们会在每一步为您提供支持。如果您有任何疑问、遇到困难，或者只是希望我们协助您了解某项功能，请随时与我们联系。',
  'pages.angelInsider.basics.welcome.differentParagraph':
    '像 A&GEL 这样的 AI 工具与以往的工具<strong>有所不同</strong>——它们直接赋能<strong>您本人</strong>。可以把它想象成拥有一支随时待命的助理团队：它们或许无法取代人类判断，但在许多方面能将您的能力放大到远超个人独立所能达到的程度。',
  'pages.angelInsider.basics.welcome.bestWayParagraph':
    '<strong>开始学习的最佳方式就是开始使用 A&GEL——</strong>我们鼓励您自由探索。大胆尝试，犯一些无伤大雅的错误，找到最适合您的使用方式。',
  'pages.angelInsider.basics.welcome.staircaseParagraph':
    '可以把技能提升想象成爬楼梯。从基础开始，随着信心的增强，迈向下一个台阶会变得更加自然。不必着急——这不是一场竞赛。请花足够的时间打好坚实的基础。',
  'pages.angelInsider.basics.welcome.togetherParagraph':
    '当团队和律所共同拥抱 A&GEL 时，收益会为每个人成倍增长。在用户群体中分享知识、协作共进，将产生惠及所有人的连锁效应。',
  'pages.angelInsider.basics.welcome.welcomeAboardParagraph':
    '欢迎加入——我们很期待看到我们借助 A&GEL 能取得怎样的成果。',
  'pages.angelInsider.basics.habitsSection.intro':
    '开始使用 A&GEL，不仅仅是在对话框中输入问题并回车。要真正发挥像 A&GEL 这样的 AI 工具的威力，您需要转变与 AI 互动的思维方式。',
  'pages.angelInsider.basics.habitsSection.lockHint':
    '点击面板以锁定更大的查看区域，再次点击可解锁。',
  'pages.app.analysisType.agenticResearch.description':
    '检索所选文档和已上传文件，综合生成带引用来源的完整答案。',
  'pages.app.analysisType.comparison.description':
    '比较两份文档并生成差异说明报告。您可以提供提示词以指定比较重点。',
  'pages.app.analysisType.contractDeadlines.description':
    '列出合同/文档中的所有截止日期、重要日期和期限。提供客户详情会有所帮助（例如“客户是一家专注于电子银行服务的新加坡银行”）',
  'pages.app.analysisType.executiveSummary.description':
    '提供关于关键建议、问题、风险和行动事项的简明摘要报告。',
  'pages.app.analysisType.multiStepPrompt.description':
    '按顺序执行多个提示词，每一步基于上一步的输出结果继续推进。',
  'pages.app.analysisType.scopeOfWork.description':
    '上传或选择客户提出协助或服务请求的邮件、函件或 RFP。在“提示词”中提供客户详情会有所帮助（例如“客户是一家专注于电子银行服务的新加坡银行”）',
  'pages.app.analysisType.standardInfo.description':
    '提供简明摘要、相关人员与实体清单以及简要事件时间线。最多可提供 100 份文档。',
  'pages.app.appsInstructions':
    '选择需要处理的多个文件，然后从下方列表中选择分析类型。请求处理大约需要 1-5 分钟。',
  'pages.app.appsList.agenticResearch.description':
    '检索所选文档和已上传文件，综合生成带引用来源的完整答案。',
  'pages.app.appsList.contractDeadlines.description':
    '列出合同/文档中的所有截止日期、重要日期和期限。',
  'pages.app.appsList.multiStepPrompt.description':
    '按顺序执行多个提示词，每一步基于上一步的输出结果继续推进',
  'pages.app.appsList.scopeOfWork.description':
    '上传或选择客户提出协助或服务请求的邮件、函件或 RFP。',
  'pages.app.extractDeadlinesModalDescription':
    '列出合同/文件中所有的截止日期、重要日期和期限。提供客户的详细信息会有所帮助（例如“客户是一家专注于电子银行服务的新加坡银行”）',
  'pages.app.newAnalysisModesDescription':
    '我们推出了两种强大的全新分析模式，帮助您从合同中获得更多价值。',
  'pages.app.publishFirmWideNotice':
    '此配置将与贵机构中的所有人共享。系统将向机构管理员发送审批请求。',
  'pages.app.scopeOfWorkModalDescription':
    '上传或选择客户的邮件、信函或征询书（RFP），其中包含协助或服务请求。在“提示词”中，提供客户的详细信息会有所帮助（例如“客户是一家专注于电子银行服务的新加坡银行”）',
  'pages.app.timelineFieldsDescription':
    '定义您希望在时间线中显示的其他列。对于每个字段，请提供一个键名（列标题）以及要提取的信息描述。',
  'pages.chat.allowSelfPrompting.tooltip':
    '启用后，助手可能会建议并应用提示词库中的提示词以改善回复。',
  'pages.chat.starterPrompt.caseSummariser.description':
    '包含法律背景信息的详细提示，用于总结新加坡案例。',
  'pages.chat.starterPrompt.draftChecklist.description':
    '让 Angel 根据任意文档生成检查清单的提示。',
  'pages.chat.upload.fileTypeNotAllowed':
    '不支持该文件类型。仅支持 PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT、PPTX 格式。',
  'pages.chat.upload.someFilesSkipped':
    '部分文件已跳过。仅支持 PDF、DOC、DOCX、MSG、EML、TXT、MD、XLS、XLSX、PPT 或 PPTX 格式的文件',
  'pages.comparison.taskType.strikethroughUnderline.description':
    '分析以标准删除线和下划线格式标记的变更。',
  'pages.comparison.taskType.referenceDocument.description':
    '将目标文档与参考文档（如条款清单）进行比较。',
  'pages.comparison.customInstructionPlaceholder':
    '请输入您对 A&GEL 的具体指令（例如“我的客户是 XYZ，请重点关注影响我客户的修订内容”或“请使用马来文进行批注”）',
  'pages.comparison.legalReviewDescription':
    '比较功能经过优化，可对修订内容进行“法律审阅”（即默认情况下会针对修订所产生的法律后果进行批注）。',
  'pages.composer.playbook.chooseDocumentDescription':
    '选择一个 .docx 文件以打开其画布并开始对话。',
  'pages.composer.playbookReview.downloadInfoTooltip':
    '每一轮更改都可随时查看。下载将生成应用已接受和待处理更改后的当前合并文档。',
  'pages.composer.playbookReview.showMoreIdentical':
    '{action, select, hide {隐藏} other {显示}}另外 {count} 处相同更改',
  'pages.composer.playbookReview.turnRegenerationReason':
    '此前某一轮次的决定更改了其所基于的文档。',
  'pages.review.questionListImporter.dropZoneHint':
    '支持 DOCX、PDF、EML、MSG、TXT 或 MD 格式,文件仅保存在本地。',
  'pages.review.questionListImporter.questionsReadyCount':
    '{count, plural, one {# 个问题} other {# 个问题}}已就绪',
  'pages.scribe.interruptedModal.content':
    '由于连接中断(例如设备进入休眠状态),您的录音已被中断。请点击“查看转录内容”以保存已捕获的内容。',
  'pages.scribe.recordingMicOnlyNote':
    '录音仅采集麦克风音频,不包含扬声器声音。如需转录计算机播放的音频,请使用其他设备或上传录音文件。',
  'pages.scribe.stopRecordingConfirm.content':
    '您有一段正在进行的录音。离开此页面将停止录音,是否继续?',
  'pages.scribe.whatsNew.upcomingFeaturesDesc':
    '敬请期待更深入的多语言控制功能和高级结构化输出格式。',
  'pages.sideBySide.quickQuestionsDescription':
    '根据一组临时问题,为一个或多个文档生成结构化的并排对比',
  'pages.sideBySide.tour.noHistorySessions':
    '历史记录中暂无并排对比会话。请先创建一个以查看此步骤。',
  'pages.sideBySide.tour.step1.description':
    '首先从可用类别中选择一个问题列表。点击任意问题列表卡片以继续。',
  'pages.sideBySide.tour.step2.description':
    '输入目标受众或客户名称,然后选择要进行并排对比的文档。',
  'pages.sideBySide.tour.step3.description':
    '在此查看系统提示词和问题列表。切换到历史记录面板可查看以往的会话。',
  'pages.sideBySide.tour.step4.description':
    '提交后,并排对比结果将显示在表格中。点击单元格可查看详情。',
  'pages.template.someFilesSkipped':
    '部分文件已被跳过。仅支持 PDF、DOC、DOCX、MSG、EML、TXT 或 MD 文件',
  'pages.template.customOutputDescription':
    '创建并使用自定义提示词（在 A&GEL 上称为“自定义输出”），针对需要提取特定信息或需要更深入分析的文档，进行更有针对性的分析',
  'pages.template.whatsNewModal.improvedFilteringBody':
    '新增受众和作者筛选条件，帮助您更快找到问题列表。',
  'pages.translation.translationHint':
    '将您的文档翻译为一种或多种输出语言,翻译结果将与原文分段并排显示。',
  'pages.user.login.tenantNotRegistered':
    '您的 Microsoft 租户尚未在本应用注册,请联系您的 IT 管理员。',
  'pages.user.billing.contactNameInvalidError':
    "账单联系人姓名只能包含字母、空格、连字符(-)和撇号(')。",
  'pages.user.billing.switchPlanConfirmContent':
    '系统将跳转至结账页面,您将为 {planName}({interval}ly)套餐的 {seats} 个席位支付 {total}。',
  'pages.user.billing.switchPlanConfirmContentRenewal':
    '系统将跳转至结账页面,您将为 {planName}({interval}ly)套餐的 {seats} 个席位支付 {total},以续订您已取消的订阅。',
  'pages.user.billing.switchPlanConfirmContentReplace':
    '系统将跳转至结账页面,您将为 {planName}({interval}ly)套餐的 {seats} 个席位支付 {total}。您当前的套餐将被替换。',
  'pages.user.billing.tenantStep2':
    '步骤 2/4:正在打开 Microsoft 登录弹窗,请登录并为您的租户授予权限。',
  'pages.user.billing.tenantAlreadyRegisteredMessage':
    '租户 ID {tenantId} 已在您的组织注册,无需进一步操作。',
  'pages.user.billing.tenantPopupNotice':
    '请保持此窗口打开。系统需要弹出 Microsoft 窗口,请完成登录并授权以继续。',
  'pages.user.billing.seatChangeRenewalNotice':
    '席位变更将于您下次续订日({nextInvoiceDisplay})生效。',
  'pages.user.billing.pastDueDescription':
    '您的订阅已逾期。访问权限将持续至 {graceDate},请立即续订以避免服务中断。',
  'pages.user.billing.orgAccessRestrictedDescription':
    '在账单问题解决之前,组织访问权限将受到限制。',
  'pages.files.addAtLeastOneMember': '请至少添加一位成员。',
  'pages.files.addGroupTitle': '添加群组',
  'pages.files.addNewButton': '新建',
  'pages.files.addPersonPlaceholder': '添加人员',
  'pages.files.allowedFileTypesMessage':
    '仅支持 PDF、DOC、DOCX、MSG、EML、TXT、MD、PPT、PPTX、XLS、XLSX 文件',
  'pages.files.chatWithGroupTooltip': '与该群组对话',
  'pages.files.cleanupButton': '清理',
  'pages.files.deleteAllFailedFilesConfirm':
    '{count, plural, other {确定删除全部 {count} 个上传失败的文件吗?}}',
  'pages.files.duplicateFileNameError': '文件名重复,请重命名该文件',
  'pages.files.editGroupTitle': '编辑群组',
  'pages.files.failedToCreateFolder': '创建文件夹失败:{folderName}',
  'pages.files.failedToDeleteCount': '{count} 个文件删除失败',
  'pages.files.failedToDeleteFiles': '文件删除失败',
  'pages.files.failedToMoveCount': '{count} 个文件移动失败',
  'pages.files.failedToMoveFiles': '文件移动失败',
  'pages.files.failedToUpdate': '更新失败',
  'pages.files.failedToUploadFile': '{fileName} 上传失败',
  'pages.files.filesDeletedCount': '已删除 {count} 个文件',
  'pages.files.filesDeletedCountWithFailures': '已删除 {count} 个文件,{failedCount} 个失败',
  'pages.files.filesMovedCount': '已移动 {count} 个文件',
  'pages.files.filesMovedCountWithFailures': '已移动 {count} 个文件,{failedCount} 个失败',
  'pages.files.folderUploadFailed': '文件夹上传失败',
  'pages.files.folderWarning.firmWide': '非常不安全:您所在律所内均可查看。',
  'pages.files.folderWarning.privateGroup': '安全性较低:您的群组内可查看。',
  'pages.files.folderWarning.public': '非常不安全:所有人均可查看。',
  'pages.files.groupType.firmWide': '全所范围',
  'pages.files.groupType.privateGroup': '私密群组',
  'pages.files.groupType.public': '公开',
  'pages.files.historyTitle': '历史记录',
  'pages.files.homeButton': '首页',
  'pages.files.memberColumn': '成员',
  'pages.files.moveMultipleFilesTitle': '移动 {count} 个文件',
  'pages.files.moveSingleFileTitle': '移动“{name}”',
  'pages.files.noFieldValue': '无{field}',
  'pages.files.noMembersYet': '暂无成员。',
  'pages.files.renamedTo': ' 至 ',
  'pages.files.revisionHistoryTitle': '修订历史',
  'pages.files.roleColumn': '角色',
  'pages.files.roleMember': '成员',
  'pages.files.roleOwner': '所有者',
  'pages.files.searchFilesPlaceholder': '搜索文件...',
  'pages.files.selectAtLeastOneOwner': '请至少选择一位所有者。',
  'pages.files.selectButton': '选择',
  'pages.files.selectFolderPlaceholder': '选择文件夹',
  'pages.files.selectGroupTypeRequired': '请选择群组类型。',
  'pages.files.groupNameRequired': '请输入群组名称。',
  'pages.files.groupNameTaken': '已存在同名群组。',
  'pages.files.folderNameTaken': '已存在同名文件夹。',
  'pages.files.newFolderDisabledTooltip':
    '无法在此处创建文件夹。请打开一个群组，然后在其中创建文件夹。',
  'pages.files.someFilesSkippedUnsupportedTypes': '部分文件因类型不受支持而被跳过',
  'pages.files.sortOption.nameZA': '名称 Z–A',
  'pages.files.unnamedFile': '未命名',
  'pages.files.uploadingFolderEllipsis': '正在上传文件夹...',
  'pages.library.addButton': '添加 +',
  'pages.library.addPromptModalTitle': '添加提示词',
  'pages.library.allowSelfInstruction': '允许自我指令',
  'pages.library.attachedDocsAccessNote': '提示词所附文档的访问权限与该提示词本身的访问权限一致。',
  'pages.library.attachedDocuments': '附加文档',
  'pages.library.chatWithPromptButton': '与该提示词对话',
  'pages.library.cloneAudienceLabel': '可见范围:{visibility}',
  'pages.library.cloneAuthorLabel': '作者:{author}',
  'pages.library.cloneButton': '克隆',
  'pages.library.compareButton': '比较',
  'pages.library.compareLimitWarning': '最多只能比较 3 个提示词',
  'pages.library.compareSelectHint': '请选择您要比较的两到三个提示词',
  'pages.library.copyFailed': '复制提示词失败',
  'pages.library.copyPromptButton': '复制提示词',
  'pages.library.copySuccess': '提示词已复制到剪贴板!',
  'pages.library.description':
    '一个结构化的预设提示词集合,用于引导或优化与 AI 语言模型的交互。它是一个集中式资源库,提示词按用途、任务或领域(如写作、编程、数据分析或创意生成)进行分类整理。',
  'pages.library.documentsCount': '{count} 个文档',
  'pages.library.enterNotesPlaceholder': '请输入备注',
  'pages.library.enterPromptContentPlaceholder': '请输入提示词内容',
  'pages.library.enterPromptNamePlaceholder': '请输入提示词名称',
  'pages.library.enterPurposePlaceholder': '请输入用途',
  'pages.library.exitCompareButton': '退出比较',
  'pages.library.exitModifyButton': '退出修改',
  'pages.library.favoriteOnly': '仅显示收藏',
  'pages.library.field.author': '作者',
  'pages.library.field.notes': '备注',
  'pages.library.field.prompt': '提示词',
  'pages.library.field.purpose': '用途',
  'pages.library.field.tags': '标签',
  'pages.library.field.visibility': '可见范围',
  'pages.library.filterByAudiencePlaceholder': '按可见范围筛选',
  'pages.library.filterByFunctionPlaceholder': '按功能筛选',
  'pages.library.filterByLabel': '筛选条件:',
  'pages.library.firmWideVisibilityNote':
    '此提示词将对贵机构内所有人可见。系统将向机构管理员发送审批请求。',
  'pages.library.functionOption.amend': '修改',
  'pages.library.functionOption.promptlet': '微提示',
  'pages.library.functionOption.redFlagging': '风险标记',
  'pages.library.functionOption.review': '审阅',
  'pages.library.functionOption.summarise': '摘要',
  'pages.library.functionOption.search': '搜索',
  'pages.library.functionOption.selfInstruct': '自我指令',
  'pages.library.functionOption.translate': '翻译',
  'pages.library.functionOption.transcribe': '转录',
  'pages.library.functionOption.reviewAnalyse': '审阅/分析',
  'pages.library.functionOption.playbook': '编排指南',
  'pages.library.functionOption.comparison': '对比',
  'pages.library.functionOption.template': '模板',
  'pages.library.noPromptsSelected': '未选择任何提示词',
  'pages.library.pendingApproval': '待审批',
  'pages.library.pendingApprovalNote':
    '发布请求正在审批中。在该请求获批或被拒绝之前,无法选择“全所范围”或“公开”。',
  'pages.library.promptClonedSuccess': '提示词克隆成功',
  'pages.library.publicVisibilityNote':
    '此提示词将对所有用户可见。系统将向超级管理员发送审批请求。',
  'pages.library.publishButton': '发布',
  'pages.library.publishFailedDefault': '提交发布请求失败,请重试。',
  'pages.library.publishPromptModalTitle': '发布提示词',
  'pages.library.publishRequestSentToAdmin': '您发布此提示词的请求已发送至管理员审批。',
  'pages.library.publishSuccess': '提示词发布成功。',
  'pages.library.saveChangesButton': '保存更改',
  'pages.library.searchPlaceholder': '搜索提示词和标签',
  'pages.library.selfInstruction': '自我指令',
  'pages.library.tagsPlaceholder': '标签列表',
  'pages.library.title': '提示词库',
  'pages.library.undoChangesButton': '撤销更改',
  'pages.library.unsavedChangesContent': '您有尚未保存的更改,确定要退出吗?',
  'pages.library.unsavedChangesTitle': '未保存的更改',
  'pages.library.untitledPrompt': '未命名提示词',
  'pages.library.updateFailed': '更新失败',
  'pages.library.updateSuccess': '更新成功',
  'pages.library.visibilityOption.firmWide': '全所范围',
  'pages.library.visibilityOption.group': '群组',
  'pages.library.visibilityOption.personal': '个人',
  'pages.library.visibilityOption.public': '公开',
  'pages.organisation.addUserButtonLabel': '添加用户',
  'pages.organisation.changeRoleButtonLabel': '更改角色',
  'pages.organisation.createOrganisationLabel': '创建机构',
  'pages.organisation.defaultOrganisationName': '机构',
  'pages.organisation.defaultUserRoleLabel': '用户',
  'pages.organisation.editOrganisationModalTitle': '编辑机构',
  'pages.organisation.emailColumnTitle': '电子邮件',
  'pages.organisation.emailRequiredMessage': '电子邮件为必填项',
  'pages.organisation.idColumnTitle': 'ID',
  'pages.organisation.msTenantIdsLabel': 'MS 租户 ID',
  'pages.organisation.msTenantIdsTooltip': '来自这些 Microsoft 租户 ID 的用户可通过 SSO 登录。',
  'pages.organisation.organisationCreatedSuccessMessage': '机构创建成功',
  'pages.organisation.organisationNameLabel': '机构名称',
  'pages.organisation.organisationNameRequiredMessage': '机构名称为必填项',
  'pages.organisation.organisationUpdatedSuccessMessage': '机构更新成功',
  'pages.organisation.organisationsTableHeaderTitle': '机构列表',
  'pages.organisation.removeUserConfirmTitle': '确定将该用户从机构中移除吗?',
  'pages.organisation.roleLabel': '角色',
  'pages.organisation.roleRequiredMessage': '角色为必填项',
  'pages.organisation.roleUpdatedSuccessMessage': '角色已更新',
  'pages.organisation.unableToAddUserErrorMessage': '无法添加用户',
  'pages.organisation.unableToLoadRolesErrorMessage': '无法加载角色',
  'pages.organisation.unableToRemoveUserErrorMessage': '无法移除用户',
  'pages.organisation.unableToUpdateRoleErrorMessage': '无法更新角色',
  'pages.organisation.untitledOrganisationFallback': '未命名机构',
  'pages.organisation.userAddedSuccessMessage': '用户已添加',
  'pages.organisation.userEmailLabel': '用户电子邮件',
  'pages.organisation.userEmailPlaceholder': 'user@company.com',
  'pages.organisation.userLimitLabel': '用户数量上限',
  'pages.organisation.userLimitOnly': '上限:{limit}',
  'pages.organisation.userLimitReachedTooltip': '已达到用户数量上限',
  'pages.organisation.userLimitTooltip': '允许的最大用户数。留空表示不限。',
  'pages.organisation.userLimitUnlimited': '不限',
  'pages.organisation.userLimitUnlimitedCount': '{count} / 不限',
  'pages.organisation.userRemovedSuccessMessage': '用户已移除',
  'pages.organisation.usernameColumnTitle': '用户名',
  'pages.organisation.usersTableHeaderTitle': '{orgName} 用户',
  'pages.welcomeDashboard.jsonResponseTitle': 'JSON 响应',
  'pages.welcomeDashboard.textResponseTitle': '文本响应',
  'pages.welcomeDashboard.visibility.public': '公开',
  'pages.welcomeDashboard.visibility.firm': '所属机构',
  'pages.welcomeDashboard.visibility.unknown': '未知',
  'pages.welcomeDashboard.rejectButton': '拒绝',
  'pages.welcomeDashboard.approveButton': '批准',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.title': '今日生成字数',
  'pages.welcomeDashboard.metrics.wordsGenerated.chartLabel': '生成字数',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.description': 'AI 辅助起草',
  'pages.welcomeDashboard.metrics.pagesProcessed.title': '已处理 A4 页数',
  'pages.welcomeDashboard.metrics.pagesProcessed.chartLabel': '已处理页数',
  'pages.welcomeDashboard.metrics.pagesProcessed.description': '今日活跃项目中',
  'pages.welcomeDashboard.metrics.documentsDownloaded.title': '已下载文档',
  'pages.welcomeDashboard.metrics.documentsDownloaded.chartLabel': '已下载文档',
  'pages.welcomeDashboard.metrics.documentsDownloaded.description': '今日导出文件',
  'pages.welcomeDashboard.metrics.questionsAnswered.title': '已回答问题',
  'pages.welcomeDashboard.metrics.questionsAnswered.chartLabel': '已回答问题',
  'pages.welcomeDashboard.metrics.questionsAnswered.description': '今日处理的 AI 提示',
  'pages.welcomeDashboard.features.apps.name': '应用',
  'pages.welcomeDashboard.features.apps.description': '分析并总结内容',
  'pages.welcomeDashboard.features.scribe.name': '录音',
  'pages.welcomeDashboard.features.scribe.description': '文档转录',
  'pages.welcomeDashboard.features.comparison.name': '对比',
  'pages.welcomeDashboard.features.comparison.description': '并排比较文档',
  'pages.welcomeDashboard.features.review.name': '审查',
  'pages.welcomeDashboard.features.review.description': '使用问题清单审查文档',
  'pages.welcomeDashboard.features.translation.name': '翻译',
  'pages.welcomeDashboard.features.translation.description': '翻译文档',
  'pages.welcomeDashboard.features.chat.name': '聊天',
  'pages.welcomeDashboard.features.chat.description': '与 AI 助手聊天',
  'pages.welcomeDashboard.features.templates.name': '模板',
  'pages.welcomeDashboard.features.templates.description': '管理模板',
  'pages.welcomeDashboard.features.quote.name': '报价',
  'pages.welcomeDashboard.features.quote.description': '生成报价',
  'pages.welcomeDashboard.features.files.name': '文件',
  'pages.welcomeDashboard.features.files.description': '管理您的文件',
  'pages.welcomeDashboard.features.library.name': '提示库',
  'pages.welcomeDashboard.features.library.description': '访问您的提示库',
  'pages.welcomeDashboard.features.sideBySide.name': '并排',
  'pages.welcomeDashboard.features.sideBySide.description': '并排比较',
  'pages.welcomeDashboard.features.playbook.name': 'Workstudio',
  'pages.welcomeDashboard.features.playbook.description': '创建并管理 Workstudio 会话',
  'pages.welcomeDashboard.features.fallback.description': '功能',
  'pages.welcomeDashboard.features.search.name': '搜索',
  'pages.welcomeDashboard.greeting': '你好，{username}',
  'pages.welcomeDashboard.useCasesButton': '使用案例',
  'pages.welcomeDashboard.faqsButton': '常见问题',
  'pages.welcomeDashboard.publishingApprovalsButton': '发布审批（{count}）',
  'pages.welcomeDashboard.jumpBackInTitle': '继续之前的操作',
  'pages.welcomeDashboard.untitledSession': '未命名会话',
  'pages.welcomeDashboard.viewAllButton': '查看全部',
  'pages.welcomeDashboard.noRecentSessions': '暂无最近会话',
  'pages.welcomeDashboard.statsTitle': '统计',
  'pages.welcomeDashboard.usefulFeaturesTitle': '实用功能',
  'pages.welcomeDashboard.sessionsCount': '{count, plural, other {# 个会话}}',
  'pages.welcomeDashboard.foundUsefulThisWeek': '本周有 {count} 位用户认为有用',
  'pages.welcomeDashboard.noRecentActivity': '暂无最近活动',
  'pages.welcomeDashboard.publishingApprovalsModalTitle': '发布审批',
  'pages.welcomeDashboard.approvalTag.template': '模板',
  'pages.welcomeDashboard.approvalTag.review': '审查',
  'pages.welcomeDashboard.approvalTag.sideBySide': '并排对比',
  'pages.welcomeDashboard.approvalTag.prompt': '提示词',
  'pages.welcomeDashboard.approvalTag.multiStep': '多步骤',
  'pages.welcomeDashboard.recentSessionsModalTitle': '{pageName} — 最近会话',
  'pages.welcomeDashboard.detail.publishTarget': '发布目标',
  'pages.welcomeDashboard.detail.author': '作者',
  'pages.welcomeDashboard.detail.unknown': '未知',
  'pages.welcomeDashboard.detail.category': '类别',
  'pages.welcomeDashboard.detail.purpose': '用途',
  'pages.welcomeDashboard.detail.notes': '备注',
  'pages.welcomeDashboard.systemPromptLabel': '系统提示词',
  'pages.welcomeDashboard.noSystemPromptProvided': '未提供系统提示词',
  'pages.welcomeDashboard.promptContentLabel': '提示词内容',
  'pages.welcomeDashboard.noPromptContentAvailable': '暂无提示词内容',
  'pages.welcomeDashboard.multiStepConfigFallback': '多步骤配置',
  'pages.welcomeDashboard.detail.description': '描述',
  'pages.welcomeDashboard.stepsLabel': '步骤',
  'pages.welcomeDashboard.stepFallback': '步骤 {number}',
  'pages.welcomeDashboard.templateFallback': '模板',
  'pages.welcomeDashboard.detail.target': '目标',
  'pages.welcomeDashboard.miscFallback': '其他',
  'pages.welcomeDashboard.detail.type': '类型',
  'pages.welcomeDashboard.templateType.prose': '文本式',
  'pages.welcomeDashboard.templateType.table': '表格式',
  'pages.welcomeDashboard.tableTypeLabel': '表格类型',
  'pages.welcomeDashboard.tableType.standard': '标准',
  'pages.welcomeDashboard.tableType.documentByDocument': '逐文档',
  'pages.welcomeDashboard.tableType.clauseByClause': '逐条款',
  'pages.welcomeDashboard.columnsLabel': '列',
  'pages.welcomeDashboard.sectionsLabel': '章节',
  'pages.welcomeDashboard.userDefinedTag': '用户自定义',
  'pages.welcomeDashboard.noTemplateStructureAvailable': '暂无模板结构',
  'pages.welcomeDashboard.questionListFallback': '问题清单',
  'pages.welcomeDashboard.noQuestionsAvailable': '暂无问题',
};
